
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("a5txT", function(module, exports) {

var $7xVCs = parcelRequire("7xVCs");

const $82982cff56793d8b$var$standalonePageTreeStateUpdater = new (0, $7xVCs.PageTreeStateUpdater)();
const $82982cff56793d8b$export$19e3952b1a66ecb = ()=>$82982cff56793d8b$var$standalonePageTreeStateUpdater;
module.exports["getStandalonePageTreeStateUpdater"] = $82982cff56793d8b$export$19e3952b1a66ecb;

});

parcelRegister("7xVCs", function(module, exports) {

var $a4TK8 = parcelRequire("a4TK8");


var $T1bCI = parcelRequire("T1bCI");

class $3c23582ca65aa05a$export$90a06df90d015db9 extends (0, $T1bCI.Container) {
    scrollToCurrentPage() {
        this.setState({
            scrollToCurrent: true
        });
    }
    clearScrollTo() {
        this.setState({
            scrollToCurrent: false
        });
    }
    setHighlightPagesIds(pageIds) {
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(this.state.highlightPagesIds, pageIds)) this.setState({
            highlightPagesIds: pageIds
        });
    }
    clearHighlightedPages() {
        this.setHighlightPagesIds([]);
    }
    setForceFetchPageId(pageId) {
        this.setState({
            forceFetchPageId: pageId
        });
    }
    clearForceFetch() {
        this.setForceFetchPageId(null);
    }
    setOptimisticDeleteId(pageId) {
        this.setState({
            optimisticDeletePageId: pageId
        });
    }
    clearOptimisticDeleteId() {
        this.setOptimisticDeleteId(null);
    }
    setIsEditingTitleId(contentId) {
        return this.setState({
            editingTitle: {
                contentId: contentId
            }
        });
    }
    // This is for content types such as folders that do not have a create content url
    // Instead, we allow naming the content inside the page tree immediately after creation
    forceFetchWithInlineRename(forceFetchId, contentId) {
        this.setState({
            forceFetchPageId: forceFetchId,
            editingTitle: {
                contentId: contentId,
                isNewContent: true
            },
            scrollToPageId: contentId
        });
    }
    clearScrollToPageId() {
        this.setState({
            scrollToPageId: null
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            highlightPagesIds: [],
            forceFetchPageId: null,
            optimisticDeletePageId: null,
            scrollToCurrent: false,
            scrollToPageId: null,
            editingTitle: {
                contentId: null
            }
        };
    }
}
module.exports["PageTreeStateUpdater"] = $3c23582ca65aa05a$export$90a06df90d015db9;

});

parcelRegister("30qWc", function(module, exports) {

var $308Wd = parcelRequire("308Wd");

function $9acca7871dfd8a5c$export$a59d7e865b63a081({ children: children, mutation: mutation, ...props }) {
    const [mutate, result] = (0, $308Wd.useMutationInterop)(mutation, props);
    return children(mutate, result);
}
module.exports["MutationInterop"] = $9acca7871dfd8a5c$export$a59d7e865b63a081;

});

parcelRegister("b1HmN", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $80716d6d5be0d4f0$export$fff6e0d8ba6c4cc6 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "ishvT",
    name: "LoadableChangeEditionNotificationDialog",
    loader: async ()=>(await (parcelRequire("kHp2S"))).ChangeEditionNotificationDialog
});
module.exports["LoadableChangeEditionNotificationDialog"] = $80716d6d5be0d4f0$export$fff6e0d8ba6c4cc6;

});

parcelRegister("kHp2S", function(module, exports) {

let $f11b404c5fa8cafa$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f11b404c5fa8cafa$var$load("hhss7"),
    $f11b404c5fa8cafa$var$load("kSVGa")
]).then(()=>parcelRequire('5BDEU'));

});

parcelRegister("hDG7z", function(module, exports) {
//this file switches between Nav 3 and Nav 4 page-layout components. When Nav 4 is at 100% this file can simply be deleted and index can export nav 4 directly instead

var $42omo = parcelRequire("42omo");


var $gz8ZY = parcelRequire("gz8ZY");


var $cgEsw = parcelRequire("cgEsw");


var $jbuqY = parcelRequire("jbuqY");

const $c8aadc7c03a52230$export$6d1402fb58384e4f = (props)=>{
    const isNav4Enabled = (0, $gz8ZY.useIsNav4Enabled)();
    return isNav4Enabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cgEsw.Nav4Layout), props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jbuqY.Nav3Layout), props);
};
module.exports["PageLayout"] = $c8aadc7c03a52230$export$6d1402fb58384e4f;

});

parcelRegister("cgEsw", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $acf3be568142fa4d$export$25b68ac96f2af713 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "Y6119",
    name: "Nav4Layout",
    loader: async ()=>(await (parcelRequire("b6bl6"))).PageLayout
});
module.exports["Nav4Layout"] = $acf3be568142fa4d$export$25b68ac96f2af713;

});

parcelRegister("b6bl6", function(module, exports) {

let $81490cffb0e5ad03$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $81490cffb0e5ad03$var$load("7Omhy"),
    $81490cffb0e5ad03$var$load("1QdXB"),
    $81490cffb0e5ad03$var$load("eYGV1"),
    $81490cffb0e5ad03$var$load("5IgYU"),
    $81490cffb0e5ad03$var$load("87NBA"),
    $81490cffb0e5ad03$var$load("8KnyD"),
    $81490cffb0e5ad03$var$load("8JZKd"),
    $81490cffb0e5ad03$var$load("2Cftu"),
    $81490cffb0e5ad03$var$load("4i0CB"),
    $81490cffb0e5ad03$var$load("1Ywby"),
    $81490cffb0e5ad03$var$load("7WaUI"),
    $81490cffb0e5ad03$var$load("3Kg3S"),
    $81490cffb0e5ad03$var$load("wirGo"),
    $81490cffb0e5ad03$var$load("4WF1A"),
    $81490cffb0e5ad03$var$load("gO36l"),
    $81490cffb0e5ad03$var$load("9GMEV"),
    $81490cffb0e5ad03$var$load("fgH74"),
    $81490cffb0e5ad03$var$load("5VdYb"),
    $81490cffb0e5ad03$var$load("1aPQ5"),
    $81490cffb0e5ad03$var$load("4YwES"),
    $81490cffb0e5ad03$var$load("1zcLV"),
    $81490cffb0e5ad03$var$load("9mtZC"),
    $81490cffb0e5ad03$var$load("6tsCm"),
    $81490cffb0e5ad03$var$load("lWxi6"),
    $81490cffb0e5ad03$var$load("gMWRW"),
    $81490cffb0e5ad03$var$load("2tSa5"),
    $81490cffb0e5ad03$var$load("jvHRs"),
    $81490cffb0e5ad03$var$load("gLGsg"),
    $81490cffb0e5ad03$var$load("dChec"),
    $81490cffb0e5ad03$var$load("9XYQ9"),
    $81490cffb0e5ad03$var$load("aeEUI"),
    $81490cffb0e5ad03$var$load("iXzmH"),
    $81490cffb0e5ad03$var$load("65c4i"),
    $81490cffb0e5ad03$var$load("6wr18"),
    $81490cffb0e5ad03$var$load("kjZZD"),
    $81490cffb0e5ad03$var$load("1qlDN"),
    $81490cffb0e5ad03$var$load("1yVM6"),
    $81490cffb0e5ad03$var$load("awqCy"),
    $81490cffb0e5ad03$var$load("kDPsc"),
    $81490cffb0e5ad03$var$load("fZt2F"),
    $81490cffb0e5ad03$var$load("4shpn"),
    $81490cffb0e5ad03$var$load("cIHDc"),
    $81490cffb0e5ad03$var$load("6vEb6"),
    $81490cffb0e5ad03$var$load("Wowvf"),
    $81490cffb0e5ad03$var$load("dS0Pr"),
    $81490cffb0e5ad03$var$load("huYla"),
    $81490cffb0e5ad03$var$load("amUNi"),
    $81490cffb0e5ad03$var$load("8Gekp"),
    $81490cffb0e5ad03$var$load("37ZO9"),
    $81490cffb0e5ad03$var$load("1GxVg"),
    $81490cffb0e5ad03$var$load("let0D"),
    $81490cffb0e5ad03$var$load("ffEVr"),
    $81490cffb0e5ad03$var$load("kUbUu"),
    $81490cffb0e5ad03$var$load("hhss7"),
    $81490cffb0e5ad03$var$load("7EorR"),
    $81490cffb0e5ad03$var$load("gmHzx")
]).then(()=>parcelRequire('48Eol'));

});

parcelRegister("jbuqY", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $f6f90fb0ae36f35f$export$7faac1b59c375dfa = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "oUMKP",
    name: "Nav3Layout",
    loader: async ()=>(await (parcelRequire("34V0f"))).PageLayout
});
module.exports["Nav3Layout"] = $f6f90fb0ae36f35f$export$7faac1b59c375dfa;

});

parcelRegister("34V0f", function(module, exports) {

let $23ddf66d3d6e274a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $23ddf66d3d6e274a$var$load("gMWRW"),
    $23ddf66d3d6e274a$var$load("6wr18"),
    $23ddf66d3d6e274a$var$load("6tsCm"),
    $23ddf66d3d6e274a$var$load("2F69B"),
    $23ddf66d3d6e274a$var$load("fZt2F"),
    $23ddf66d3d6e274a$var$load("ffEVr"),
    $23ddf66d3d6e274a$var$load("dS0Pr"),
    $23ddf66d3d6e274a$var$load("huYla"),
    $23ddf66d3d6e274a$var$load("amUNi"),
    $23ddf66d3d6e274a$var$load("37ZO9"),
    $23ddf66d3d6e274a$var$load("1GxVg"),
    $23ddf66d3d6e274a$var$load("hhss7"),
    $23ddf66d3d6e274a$var$load("7Omhy"),
    $23ddf66d3d6e274a$var$load("kC80R"),
    $23ddf66d3d6e274a$var$load("7EorR"),
    $23ddf66d3d6e274a$var$load("a6eof")
]).then(()=>parcelRequire('2xpE0'));

});

parcelRegister("eWwvy", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $49b80c0b2fd2c306$export$9c32b7bc3af8de64 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "5liJC",
    name: "EditSpaceLogo",
    loader: async ()=>(await (parcelRequire("cPd7b"))).EditSpaceLogo
});
module.exports["EditSpaceLogo"] = $49b80c0b2fd2c306$export$9c32b7bc3af8de64;

});

parcelRegister("cPd7b", function(module, exports) {

let $95646bca4e19ee54$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $95646bca4e19ee54$var$load("hhss7"),
    $95646bca4e19ee54$var$load("kyxdN")
]).then(()=>parcelRequire('asonV'));

});

parcelRegister("ezLwY", function(module, exports) {
parcelRequire("cEgln");
var $3IK76 = parcelRequire("3IK76");


var $cpjd2 = parcelRequire("cpjd2");

const $a9c9343047c8f651$var$contexts = {};
const $a9c9343047c8f651$var$runSafely = (fn)=>{
    try {
        fn();
    } catch (e) {
        // TODO: find a real fix for this issue HOT-82965 | CONFCLOUD-58951
        console.error(e);
    }
};
const $a9c9343047c8f651$export$2cd8252107eb640b = ()=>{
    (0, $cpjd2.requireLegacyWRM)([
        'wrc!confluence-keyboard-shortcuts-batch'
    ], ()=>{
        $a9c9343047c8f651$var$runSafely(()=>{
            (0, $3IK76.bind)('register-contexts.keyboardshortcuts', (e, data)=>{
                const { enableContext: enableContext } = data.shortcutRegistry;
                Object.entries($a9c9343047c8f651$var$contexts).forEach(([context, enabled])=>{
                    if (enabled) enableContext(context);
                });
            });
            (0, $3IK76.trigger)('initialize.keyboardshortcuts');
        });
    }, ()=>{});
};
const $a9c9343047c8f651$export$e758fd0259c79269 = ()=>{
    // We need to disable all shortcuts and enable again
    // the ones still available as the currrent library doesn't expose a
    // method for removing just one context and we want to keep previous
    // added contexts alive
    $a9c9343047c8f651$var$runSafely(()=>{
        (0, $3IK76.trigger)('remove-bindings.keyboardshortcuts');
        (0, $3IK76.trigger)('initialize.keyboardshortcuts');
    });
};
const $a9c9343047c8f651$var$makeSetContext = (enable)=>(newContexts)=>{
        if (!Array.isArray(newContexts)) newContexts = [
            newContexts
        ];
        newContexts.forEach((context)=>{
            if ($a9c9343047c8f651$var$contexts[context] !== enable) {
                $a9c9343047c8f651$var$contexts[context] = enable;
                $a9c9343047c8f651$export$e758fd0259c79269();
            }
        });
    };
const $a9c9343047c8f651$export$2ca78a0e32b5ba4e = $a9c9343047c8f651$var$makeSetContext(true);
const $a9c9343047c8f651$export$48a00fd3a2cf40e0 = $a9c9343047c8f651$var$makeSetContext(false);
const $a9c9343047c8f651$export$4794d9b1949031cf = ()=>{
    $a9c9343047c8f651$var$runSafely(()=>{
        (0, $3IK76.trigger)('remove-bindings.keyboardshortcuts');
    });
};
module.exports["init"] = $a9c9343047c8f651$export$2cd8252107eb640b;
module.exports["enableContext"] = $a9c9343047c8f651$export$2ca78a0e32b5ba4e;
module.exports["disableContext"] = $a9c9343047c8f651$export$48a00fd3a2cf40e0;
module.exports["teardown"] = $a9c9343047c8f651$export$4794d9b1949031cf;

});

parcelRegister("cEgln", function(module, exports) {
$parcel$export(module.exports, "trigger", () => (parcelRequire("3IK76")).trigger);
$parcel$export(module.exports, "bind", () => (parcelRequire("3IK76")).bind);
$parcel$export(module.exports, "unbind", () => (parcelRequire("3IK76")).unbind);

var $3IK76 = parcelRequire("3IK76");


});

parcelRegister("3IK76", function(module, exports) {

var $6g1oe = parcelRequire("6g1oe");


var $jnN7b = parcelRequire("jnN7b");

function $2b59405ae3db7385$export$2385a24977818dd0(eventType, eventData, handler) {
    if (typeof handler === 'function') return (0, (/*@__PURE__*/$parcel$interopDefault($jnN7b)))((0, (/*@__PURE__*/$parcel$interopDefault($6g1oe)))).bind(eventType, eventData, handler);
    else return (0, (/*@__PURE__*/$parcel$interopDefault($jnN7b)))((0, (/*@__PURE__*/$parcel$interopDefault($6g1oe)))).bind(eventType, eventData);
}
function $2b59405ae3db7385$export$433e98592e7124fd(eventType, handler) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($jnN7b)))((0, (/*@__PURE__*/$parcel$interopDefault($6g1oe)))).unbind(eventType, handler);
}
function $2b59405ae3db7385$export$e614dc9140f7ae71(eventType, extraParameters) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($jnN7b)))((0, (/*@__PURE__*/$parcel$interopDefault($6g1oe)))).trigger(eventType, extraParameters);
}
module.exports["bind"] = $2b59405ae3db7385$export$2385a24977818dd0;
module.exports["unbind"] = $2b59405ae3db7385$export$433e98592e7124fd;
module.exports["trigger"] = $2b59405ae3db7385$export$e614dc9140f7ae71;

});

parcelRegister("jnN7b", function(module, exports) {
module.exports = jQuery;

});

parcelRegister("fmuCC", function(module, exports) {

let $b2f0a9f0e00b7e22$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b2f0a9f0e00b7e22$var$load("lgm1i").then(()=>parcelRequire('04Nru'));

});

parcelRegister("jzEl8", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jTxSS = parcelRequire("jTxSS");


var $9HkI0 = parcelRequire("9HkI0");

const $6cbcb1ce2cb81a03$var$REPLACED_MARKER = 'data-replaced';
const $6cbcb1ce2cb81a03$var$CLONE_MARKER = 'data-clone';
class $6cbcb1ce2cb81a03$export$a1d3010d20ec2131 extends (0, $42omo.PureComponent) {
    getLegacyElements() {
        const { rootNode: rootNode = window.document, selectors: selectors = [] } = this.props;
        if (!rootNode) return [];
        return Array.from(rootNode.querySelectorAll(selectors.join(',')));
    }
    getDomElementAttrsMap(domElement) {
        if (!domElement.hasAttributes()) return {};
        return Object.values(domElement.attributes).reduce((acc, attr)=>{
            acc[attr.name] = attr.value;
            return acc;
        }, {});
    }
    replaceDOMElementsWithPortal() {
        const { deleteExistingContent: deleteExistingContent, replacePlaceholderWith: replacePlaceholderWith, portalNode: portalNode } = this.props;
        this.workerInProgress = true;
        this.getLegacyElements().forEach((node)=>{
            const currentNodeAttrs = this.getDomElementAttrsMap(node);
            if (currentNodeAttrs[$6cbcb1ce2cb81a03$var$REPLACED_MARKER] || currentNodeAttrs[$6cbcb1ce2cb81a03$var$CLONE_MARKER]) return; // do not clone clones or already cloned nodes
            // @ts-expect-error FIXME: `true` here probably needs to be replaced with `"true"`
            node.setAttribute($6cbcb1ce2cb81a03$var$REPLACED_MARKER, true);
            // @ts-expect-error FIXME: `true` here probably needs to be replaced with `"true"`
            currentNodeAttrs[$6cbcb1ce2cb81a03$var$CLONE_MARKER] = true;
            currentNodeAttrs['key'] = currentNodeAttrs.id || (0, (/*@__PURE__*/$parcel$interopDefault($9HkI0)))();
            let targetNode = node;
            if (replacePlaceholderWith) {
                targetNode = window.document.createElement(replacePlaceholderWith.elementName);
                const attributes = replacePlaceholderWith.attributes || {};
                for(const attr in attributes)targetNode.setAttribute(attr, attributes[attr]);
                node.parentNode.replaceChild(targetNode, node);
            }
            if (deleteExistingContent) while(targetNode.firstChild)targetNode.removeChild(targetNode.firstChild);
            if (portalNode) {
                const reactEl = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).cloneElement(portalNode, currentNodeAttrs);
                this.portals.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).createPortal(reactEl, targetNode));
            }
        });
        const attemptsLeft = this.state.attemptsLeft - 1;
        this.setState({
            attemptsLeft: attemptsLeft
        });
        if (attemptsLeft > 0) window.setTimeout(()=>{
            this.replaceDOMElementsWithPortal();
        }, this.props.retryDelay);
        else this.workerInProgress = false;
    }
    render() {
        if (this.state.attemptsLeft > 0 && !this.workerInProgress) setTimeout(()=>{
            this.replaceDOMElementsWithPortal();
        }, 0);
        return this.portals.map((item)=>item);
    }
    constructor(...args){
        super(...args);
        this.state = {
            attemptsLeft: this.props.attempts ?? 0
        };
        this.workerInProgress = false;
        this.portals = [];
    }
}
$6cbcb1ce2cb81a03$export$a1d3010d20ec2131.defaultProps = {
    attempts: 1,
    retryDelay: 50,
    deleteExistingContent: true
};
module.exports["LegacyDOMBridge"] = $6cbcb1ce2cb81a03$export$a1d3010d20ec2131;

});

parcelRegister("5qwh1", function(module, exports) {

let $3f386a518f113b7b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $3f386a518f113b7b$var$load("6wr18"),
    $3f386a518f113b7b$var$load("j06N4"),
    $3f386a518f113b7b$var$load("ffEVr"),
    $3f386a518f113b7b$var$load("Wowvf"),
    $3f386a518f113b7b$var$load("hhss7"),
    $3f386a518f113b7b$var$load("lwfE5")
]).then(()=>parcelRequire('MkVVm'));

});

parcelRegister("2NJWg", function(module, exports) {

let $20a3cae097b49b58$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $20a3cae097b49b58$var$load("6wr18"),
    $20a3cae097b49b58$var$load("ffEVr"),
    $20a3cae097b49b58$var$load("Wowvf"),
    $20a3cae097b49b58$var$load("hhss7"),
    $20a3cae097b49b58$var$load("d7sp9")
]).then(()=>parcelRequire('4Au5p'));

});

parcelRegister("cq0jI", function(module, exports) {

let $90a828add24c033b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $90a828add24c033b$var$load("hhss7"),
    $90a828add24c033b$var$load("ei0Jg")
]).then(()=>parcelRequire('esrJ1'));

});

parcelRegister("7nmkU", function(module, exports) {

let $55ec01e1fb53735b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $55ec01e1fb53735b$var$load("hhf8b").then(()=>parcelRequire('cDa2P'));

});

parcelRegister("ax8Zf", function(module, exports) {

let $7ab3f50d85b48d99$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7ab3f50d85b48d99$var$load("82QsP"),
    $7ab3f50d85b48d99$var$load("an2zh")
]).then(()=>parcelRequire('3Fqft'));

});

parcelRegister("d1Pi6", function(module, exports) {

let $97c327a8a6cb8f32$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $97c327a8a6cb8f32$var$load("82QsP"),
    $97c327a8a6cb8f32$var$load("gJRFC")
]).then(()=>parcelRequire('bQl5d'));

});

parcelRegister("14QAi", function(module, exports) {

var $hBkCm = parcelRequire("hBkCm");

var $flE5X = parcelRequire("flE5X");


var $lzcvT = parcelRequire("lzcvT");

const $1ce5a19013c572e5$export$4a6cb1fe56895a84 = {
    federal: {
        staging: 'https://fed-support-gateway.us-east-1.staging.atl-paas-us-gov-mod.net',
        production: 'https://fed-support-gateway.us-east-1.prod.atl-paas-us-gov-mod.net'
    }
};
const $1ce5a19013c572e5$export$529433b0a9e66822 = (url, isFedrampEnv, environment)=>{
    const isFedrampEnvironment = isFedrampEnv ?? (0, $lzcvT.isFedRamp)();
    if (isFedrampEnvironment) {
        // Auto-detect environment based on hostname patterns
        const env = environment ?? (()=>{
            const hostname = typeof window !== 'undefined' ? window.location.hostname : '';
            // Check for staging patterns in hostname
            return hostname.includes('stg') || hostname.includes('staging') ? 'staging' : 'production';
        })();
        const baseUrl = $1ce5a19013c572e5$export$4a6cb1fe56895a84.federal[env];
        return `${baseUrl}${url}`;
    }
    // For non-FedRAMP environments, use relative URLs (current behavior)
    return url;
};
// ANALYTICS PROPERTIES
const $1ce5a19013c572e5$var$SPACE_OVERVIEW = 'spaceSettings/overview';
const $1ce5a19013c572e5$var$SPACE_PERMISSIONS = 'spaceSettings/permissions';
const $1ce5a19013c572e5$var$SPACE_CONTENT_TOOLS = 'spaceSettings/contentTools';
const $1ce5a19013c572e5$var$SPACE_LOOK_AND_FEEL = 'spaceSettings/lookAndFeel';
const $1ce5a19013c572e5$var$SPACE_INTEGRATIONS = 'spaceSettings/Integrations';
// ROUTE GROUPS
const $1ce5a19013c572e5$var$SPACE_SETTINGS = 'space-settings';
const $1ce5a19013c572e5$export$244e5242c65921be = 'https://hello.atlassian.net/wiki/spaces/PMP/pages/139161942/Standard+-+Global+Workplace+Privacy+Notice#13.-Additional-Disclosures-for-California-Residents';
const $1ce5a19013c572e5$export$ab8f8977c5e363cb = 'https://www.atlassian.com/legal/privacy-policy#additional-disclosures-for-ca-residents';
const $1ce5a19013c572e5$export$86f8e0fbd7845b32 = 'https://hello.atlassian.net/wiki/spaces/PMP/pages/139161942/Standard+-+Global+Workplace+Privacy+Notice';
const $1ce5a19013c572e5$export$87259143062a27ea = 'https://www.atlassian.com/legal/privacy-policy#what-this-policy-covers';
const $1ce5a19013c572e5$export$108231643dc5e01e = [
    'Online Help',
    'Get the mobile app',
    'Feed Builder',
    'Keyboard Shortcuts',
    'Site Status',
    "What\u2019s new",
    'About Confluence'
];
const $1ce5a19013c572e5$export$40e045b7d0d057fd = (route)=>{
    // get what route we're on by switching based on
    // the regex evaluating to true
    switch(true){
        /**
		 * SPACE SETTINGS - OVERVIEW
		 */ case /viewspacesummary/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'space-details',
                articleId: '2ngx6W7OSkTdvFP6m1jdYC',
                section: $1ce5a19013c572e5$var$SPACE_OVERVIEW,
                screen: 'spaceDetailsScreen'
            };
        case /archivespace/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'archive-space',
                articleId: '18AcZoC9QhZZ0lzuMBaZQD',
                section: $1ce5a19013c572e5$var$SPACE_OVERVIEW,
                screen: 'archiveSpaceScreen'
            };
        case /archiveSpace/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'archive-space',
                articleId: '18AcZoC9QhZZ0lzuMBaZQD',
                section: $1ce5a19013c572e5$var$SPACE_OVERVIEW,
                screen: 'archiveSpaceScreen'
            };
        case /editFeatures/.test(route):
            return {
                routeName: 'edit-sidebar',
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                articleId: '6ivofSJlfSXa9IASo00kvA',
                section: $1ce5a19013c572e5$var$SPACE_OVERVIEW,
                screen: 'sidebarConfigurationScreen'
            };
        case /removespace/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'delete-space',
                articleId: '7edCGN0nkqsvUd9s3AzEq8',
                section: $1ce5a19013c572e5$var$SPACE_OVERVIEW,
                screen: 'deleteSpaceScreen'
            };
        /**
		 * SPACE SETTINGS - PERMISSIONS
		 */ case /spaces\/.*\/settings\/permissions\/\d*/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'space-permissions',
                articleId: '6fQGHt1G8f5KUxXTinTVvW',
                section: $1ce5a19013c572e5$var$SPACE_PERMISSIONS,
                screen: 'permissionsScreen'
            };
        case /spacepermissions/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'space-permissions',
                articleId: '6fQGHt1G8f5KUxXTinTVvW',
                section: $1ce5a19013c572e5$var$SPACE_PERMISSIONS,
                screen: 'permissionsScreen'
            };
        case /addonpermissions/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'analytics-permissions',
                articleId: '',
                section: $1ce5a19013c572e5$var$SPACE_PERMISSIONS,
                screen: 'addOnScreen'
            };
        case /listpermissionpages/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'page-restrictions',
                articleId: '7f9j14trnF75aeuihHAoLp',
                section: $1ce5a19013c572e5$var$SPACE_PERMISSIONS,
                screen: 'restrictedPagesScreen'
            };
        case /reorderpages/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'reorder-pages',
                articleId: '5faOvjH2hAw2CpZY3tC3ej',
                section: $1ce5a19013c572e5$var$SPACE_CONTENT_TOOLS,
                screen: 'reorderPagesScreen'
            };
        case /listorphanedpages/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'orphaned-pages',
                articleId: '1mxG2f1dvIifiDqKrkvy98',
                section: $1ce5a19013c572e5$var$SPACE_CONTENT_TOOLS,
                screen: 'orphanedPagesScreen'
            };
        case /listundefinedpages/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'undefined-pages',
                articleId: '',
                section: $1ce5a19013c572e5$var$SPACE_CONTENT_TOOLS,
                screen: 'undefinedPagesScreen'
            };
        case /listattachmentsforspace/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'attachments',
                articleId: '',
                section: $1ce5a19013c572e5$var$SPACE_CONTENT_TOOLS,
                screen: 'attachmentsScreen'
            };
        case /viewtrash/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'trash',
                articleId: '6NL5cRC6aV7k9ucd2yEZzZ',
                section: $1ce5a19013c572e5$var$SPACE_CONTENT_TOOLS,
                screen: 'trashScreen'
            };
        case /exportspacewelcome/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'export-space',
                articleId: '6RcXthpHKQasH09gERDkE8',
                section: $1ce5a19013c572e5$var$SPACE_CONTENT_TOOLS,
                screen: 'exportScreen'
            };
        case /listrssfeeds/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'rss-feed',
                articleId: '6TyTkhaowcNTwvq9V0rt10',
                section: $1ce5a19013c572e5$var$SPACE_CONTENT_TOOLS,
                screen: 'rssFeedsScreen'
            };
        /**
		 * SPACE SETTINGS - LOOK AND FEEL
		 */ case /spaces\/choosetheme/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'themes',
                articleId: '3Owkyfl2mshKQQ2mECCV8q',
                section: $1ce5a19013c572e5$var$SPACE_LOOK_AND_FEEL,
                screen: 'themesScreen'
            };
        case /custompagecontent/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'header-and-footer',
                articleId: '2i2NAHbTjkWeoprrdWlNX',
                section: $1ce5a19013c572e5$var$SPACE_LOOK_AND_FEEL,
                screen: 'headerAndFooterScreen'
            };
        case /viewpdfconfig/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'undefined',
                articleId: '',
                section: $1ce5a19013c572e5$var$SPACE_LOOK_AND_FEEL,
                screen: 'pdfConfigScreen'
            };
        case /viewpdflayoutconfig/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'undefined',
                articleId: '',
                section: $1ce5a19013c572e5$var$SPACE_LOOK_AND_FEEL,
                screen: 'pdfLayoutScreen'
            };
        case /viewpdfstyleconfig/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'undefined',
                articleId: '',
                section: $1ce5a19013c572e5$var$SPACE_LOOK_AND_FEEL,
                screen: 'pdfStylesheetScreen'
            };
        /**
		 * SPACE SETTINGS - INTEGRATIONS
		 */ case /listentitylinks/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'undefined',
                articleId: '',
                section: $1ce5a19013c572e5$var$SPACE_INTEGRATIONS,
                screen: 'applicationLinksScreen'
            };
        /**
		 * CONNECT ADDONS
		 */ case /analytics\/permissions/.test(route):
            return {
                routeGroup: 'site-settings',
                routeName: 'analytics-permissions',
                articleId: '6yKVtN1tSSrOHTp4TpXtkg',
                section: 'notTracked',
                screen: 'notTracked'
            };
        case /atlassian-connect\/space-tools-tab.action/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'analytics-permissions',
                articleId: '6yKVtN1tSSrOHTp4TpXtkg',
                section: $1ce5a19013c572e5$var$SPACE_PERMISSIONS,
                screen: 'analyticsPermissionsScreen'
            };
        /**
		 * CONTENT TYPE VIEW PAGES
		 */ case /spaces\/.*\/pages\/\d*/.test(route):
            return {
                routeGroup: 'space',
                routeName: 'view-page',
                articleId: '',
                section: 'notTracked',
                screen: 'notTracked'
            };
        case /spaces\/.*\/whiteboard\/\d*/.test(route):
            return {
                routeGroup: 'space',
                routeName: 'view-whiteboard',
                articleId: '',
                section: 'notTracked',
                screen: 'notTracked'
            };
        case /spaces\/.*\/database\/\d*/.test(route):
            return {
                routeGroup: 'space',
                routeName: 'view-database',
                articleId: '',
                section: 'notTracked',
                screen: 'notTracked'
            };
        case /spaces\/.*\/embed\/\d*/.test(route):
            return {
                routeGroup: 'space',
                routeName: 'view-embed',
                articleId: '',
                section: 'notTracked',
                screen: 'notTracked'
            };
        case /spaces\/.*\/calendars/.test(route):
            return {
                routeGroup: 'space',
                routeName: 'view-calendars',
                articleId: '85KAXe75f9VdMibJa5FHz',
                section: 'notTracked',
                screen: 'notTracked'
            };
        /**
		 * EVERYTHING ELSE
		 */ default:
            return {
                routeGroup: 'undefined',
                articleId: '',
                section: 'notTracked',
                routeName: 'undefined',
                screen: 'notTracked'
            };
    }
};
const $1ce5a19013c572e5$export$c28bcc688252a1b6 = (error)=>{
    return [
        'algolia',
        'unreachable hosts'
    ].some((err)=>error.message.toLowerCase().includes(err)) || error instanceof (0, $flE5X.NoNetworkError) || error instanceof (0, $hBkCm.BadStatusError) && error.response.status >= 500;
};
module.exports["getFedSupportGatewayURL"] = $1ce5a19013c572e5$export$529433b0a9e66822;
module.exports["INTERNAL_NOTICE_AT_COLLECTION_LINK"] = $1ce5a19013c572e5$export$244e5242c65921be;
module.exports["EXTERNAL_NOTICE_AT_COLLECTION_LINK"] = $1ce5a19013c572e5$export$ab8f8977c5e363cb;
module.exports["INTERNAL_PRIVACY_POLICY_LINK"] = $1ce5a19013c572e5$export$86f8e0fbd7845b32;
module.exports["EXTERNAL_PRIVACY_POLICY_LINK"] = $1ce5a19013c572e5$export$87259143062a27ea;
module.exports["FILTERED_MENU_ITEMS"] = $1ce5a19013c572e5$export$108231643dc5e01e;
module.exports["getRouteData"] = $1ce5a19013c572e5$export$40e045b7d0d057fd;
module.exports["isSearchProviderUnreachableError"] = $1ce5a19013c572e5$export$c28bcc688252a1b6;

});

$parcel$global.rwr("3pblT", () => { var $8f67bdf8b085aeb0$exports = {};

(parcelRequire("02nRr")).register(new URL("", import.meta.url).toString(), JSON.parse("[\"3pblT\",\"standalone-navigation-jquery3.3b827c1e.js\",\"kSVGa\",\"ChangeEditionNotificationDialog.ce391398.js\",\"hhss7\",\"vendors~editor_atlaskit_lg.7256e4cd.js\",\"gmHzx\",\"PageLayout.06966a06.js\",\"i5eMd\",\"cs.3a015ad6.js\",\"4UPfH\",\"da.cf98e3b4.js\",\"gd4qs\",\"de.7a0dbd15.js\",\"fviv5\",\"en-GB.d8099fef.js\",\"hEkXc\",\"en-US.c2f93eaf.js\",\"6oOC9\",\"en-XA.3bb04105.js\",\"le1sE\",\"en-XB.e122e2e7.js\",\"eBoC7\",\"en-ZZ.c220e339.js\",\"bNv64\",\"es.c5b6e93f.js\",\"bAoKR\",\"et.b46b672c.js\",\"4Afgd\",\"fi.a73c4b9b.js\",\"cMubu\",\"fr.d817fcca.js\",\"oUCro\",\"hr.665c3168.js\",\"3fLE9\",\"hu.1f1083aa.js\",\"8hOn0\",\"it.cdfc1d77.js\",\"h4OCL\",\"ja.b629fe18.js\",\"bcQs2\",\"ko.0d665579.js\",\"aBa7j\",\"nb.8094732b.js\",\"b544F\",\"nl.7aff0995.js\",\"K6fhx\",\"pl.169b86f6.js\",\"gZU54\",\"pt-BR.70324fec.js\",\"hlJc4\",\"ro.968019e9.js\",\"4Wdqb\",\"ru.ac7f1c67.js\",\"bJMZS\",\"sl.36363fa9.js\",\"exiT6\",\"sr-RS.3450f456.js\",\"jLkRH\",\"sr-YR.99ef1f81.js\",\"dmrYq\",\"sr.7f38330b.js\",\"k10Cs\",\"sv.1b319415.js\",\"g5LV7\",\"th.83e205fa.js\",\"1n8w9\",\"tr.b38ee386.js\",\"2QtDQ\",\"uk.a23b114b.js\",\"i2vEA\",\"vi.34033112.js\",\"f1B4n\",\"zh-CN.26d3df5d.js\",\"l079e\",\"zh-TW.295a5bf2.js\",\"bv8GZ\",\"cs.b8d1c1b1.js\",\"cdeuH\",\"da.42823f82.js\",\"7gF8f\",\"de.8842c040.js\",\"djb49\",\"en-GB.70cd0dcf.js\",\"koawN\",\"en-US.8577a1a6.js\",\"6htQT\",\"en-XA.605c5dfb.js\",\"fi75i\",\"en-XB.dbd5f8f0.js\",\"ksTQ6\",\"en-ZZ.4f7eefe8.js\",\"5CGnz\",\"es.98f8e90e.js\",\"X0Jic\",\"et.155c1ee0.js\",\"9Oxgj\",\"fi.f2f3389c.js\",\"kAg8V\",\"fr.368a32d8.js\",\"36XYg\",\"hr.ea791c71.js\",\"fM2oh\",\"hu.f2f9ae82.js\",\"xnqy2\",\"it.351ab003.js\",\"awkVi\",\"ja.99d2f833.js\",\"11DLa\",\"ko.8aeaf96b.js\",\"barSq\",\"nb.4503e9a5.js\",\"a8heY\",\"nl.6070b16e.js\",\"6hlNE\",\"pl.9a5b0b0f.js\",\"2bqSD\",\"pt-BR.10f91e79.js\",\"j6IGj\",\"ro.b5d74be6.js\",\"bJykp\",\"ru.2a448b30.js\",\"7Rbde\",\"sl.9bd17812.js\",\"l8auu\",\"sr-RS.de35f66e.js\",\"3ColL\",\"sr-YR.6d75fa4f.js\",\"2VSOH\",\"sr.cbf031a6.js\",\"dh2Er\",\"sv.e6031ecb.js\",\"kyBJI\",\"th.ea68a7ea.js\",\"eBLgB\",\"tr.a4d35ce1.js\",\"ahhGv\",\"uk.13d42b80.js\",\"1Zesg\",\"vi.e3d9da82.js\",\"eLlpV\",\"zh-CN.914fb213.js\",\"bV8sS\",\"zh-TW.90b55434.js\",\"1jsQH\",\"cs.688247af.js\",\"deyvi\",\"da.ce01a3f4.js\",\"6dERU\",\"de.196d0286.js\",\"kTurq\",\"en-GB.8a65ad76.js\",\"fbIIm\",\"en-US.0fcdf1ae.js\",\"7l3it\",\"en-XA.c8b2e360.js\",\"i64HJ\",\"en-XB.a74dceeb.js\",\"j0PWv\",\"en-ZZ.900f269f.js\",\"dlmud\",\"es.a37dad44.js\",\"7snhF\",\"et.20d4d799.js\",\"cbkj0\",\"fi.c129a5d2.js\",\"17m16\",\"fr.d48d2214.js\",\"eQZk8\",\"hr.e3f3497b.js\",\"b4NO6\",\"hu.d63219d9.js\",\"1K1Fj\",\"it.68b18a63.js\",\"38sfA\",\"ja.05e83d89.js\",\"bjmre\",\"ko.5d08c8ec.js\",\"asvK9\",\"nb.b60c8cb7.js\",\"7v6wU\",\"nl.d417f24d.js\",\"aEpRh\",\"pl.26cf010d.js\",\"3fuR9\",\"pt-BR.b55187ea.js\",\"bSjyK\",\"ro.8940bbdc.js\",\"fMrUo\",\"ru.f0bbf79a.js\",\"glLvq\",\"sl.93d481e6.js\",\"fFGjZ\",\"sr-RS.ddc08819.js\",\"fEAqG\",\"sr-YR.289dc38a.js\",\"e9tHh\",\"sr.14f31eee.js\",\"9eNkX\",\"sv.12cce2b0.js\",\"fTPgj\",\"th.4d360fb6.js\",\"h0uBE\",\"tr.a1624066.js\",\"lKa7i\",\"uk.38ddf7bc.js\",\"9aufD\",\"vi.4cc44e33.js\",\"gDiIK\",\"zh-CN.268ccaa6.js\",\"j9OUx\",\"zh-TW.9fda702e.js\",\"kpHRm\",\"GeneralShortcutListener.4e5bcbe8.js\",\"fZt2F\",\"GeneralShortcutListener.e6d60d9f.js\",\"82QsP\",\"InProductHelpButton.1f473766.js\",\"6KGrg\",\"EmojiComponent.f4798e92.js\",\"2bmVk\",\"EmojiComponent.d462f5be.js\",\"ffEVr\",\"vendors~editor_icon.7a33fabc.js\",\"kjZZD\",\"vendors~editor_icon-object.21e9b8e9.js\",\"ffEVr\",\"vendors~editor_icon.7a33fabc.js\",\"6wr18\",\"vendors~editor_icon.912c9318.js\",\"6wr18\",\"vendors~editor_icon.912c9318.js\",\"bRz9K\",\"CommentsPanelFilterMenu.59ec201d.js\",\"bUC6C\",\"FeedbackCollector.c0a2dc00.js\",\"cyGuT\",\"feedback-collector.7ff2d132.js\",\"Wowvf\",\"vendors~editor_atlaskit_sm.7d036110.js\",\"hwiu3\",\"NavigationLockout.b1900bd2.js\",\"6Jk99\",\"drag-handle.a0568be3.js\",\"dnVDi\",\"top-nav-items.7ab89a21.js\",\"7EorR\",\"vendors~editor_atlaskit_md.bb4106fd.js\",\"iMSgb\",\"log-in.9b553c7d.js\",\"kFEyO\",\"top-nav-items.9fbc1df6.js\",\"gY1B8\",\"async.a6061a23.js\",\"35VU5\",\"cs.d801dcbc.js\",\"6W6gh\",\"da.bac7ddcf.js\",\"bfTAm\",\"de.c95398fc.js\",\"fP9up\",\"en_GB.47d12276.js\",\"hc0i6\",\"en.747f8213.js\",\"15E48\",\"en_ZZ.299e4f49.js\",\"jLWG0\",\"es.7e41636e.js\",\"9J49E\",\"fi.89090e5d.js\",\"br9SP\",\"fr.2a048ea9.js\",\"5h4sF\",\"hu.c2dc4635.js\",\"1MV5Z\",\"it.05b27b71.js\",\"iV5Fv\",\"ja.7b259d22.js\",\"7R5mJ\",\"ko.203f86ca.js\",\"5XMUp\",\"nb.e44f5efd.js\",\"jaDFz\",\"nl.405ee529.js\",\"LOg5S\",\"pl.23c5179b.js\",\"lnJdQ\",\"pt_BR.805e95d7.js\",\"hqsLl\",\"ru.c980f637.js\",\"j0btO\",\"sv.9635f53d.js\",\"2YEqr\",\"tr.ddf2ab95.js\",\"7zFV7\",\"th.3ecc11fa.js\",\"fZ22O\",\"uk.04a59e12.js\",\"4tleS\",\"vi.cca22a6d.js\",\"bE6tX\",\"zh_TW.af40ed8f.js\",\"esYD7\",\"zh.8eeac7b4.js\",\"let0D\",\"AgentProfileCard.8bff6584.js\",\"kHOMt\",\"manual-triggers-modal.ac3155e2.js\",\"7Q5vz\",\"CoreInvites.e2f85678.js\",\"7oczk\",\"cs.4da6ec84.js\",\"e2gl6\",\"da.92e1a20b.js\",\"9oo3s\",\"de.949a6b27.js\",\"1ZyUV\",\"es.c52c200d.js\",\"6tijD\",\"et.a748dc81.js\",\"6fkVy\",\"fi.14d12f06.js\",\"5nw5x\",\"fr.99ae2fd0.js\",\"jK12s\",\"hu.c6563fe5.js\",\"6lWvL\",\"is.e7fee0c5.js\",\"kk9To\",\"it.165dc383.js\",\"lyt83\",\"ja.c888829c.js\",\"2uvfp\",\"ko.caee176c.js\",\"4Wx8B\",\"nb.b215ce05.js\",\"huTg5\",\"nl.991f3345.js\",\"fPfEd\",\"pl.fdd8fa15.js\",\"fTYhL\",\"pt_BR.9a48d763.js\",\"dVHhf\",\"pt_PT.137566ba.js\",\"2SsCI\",\"ro.a2a72a07.js\",\"kVi5E\",\"ru.73740831.js\",\"6HoYh\",\"sk.63554299.js\",\"kOAvl\",\"sv.bebc1fbd.js\",\"5ErHy\",\"tr.36b807a9.js\",\"jJzpI\",\"th.64051e8c.js\",\"2PvRH\",\"uk.d1a904b6.js\",\"eUGjU\",\"vi.d80ec259.js\",\"drbCf\",\"zh_TW.d982069e.js\",\"5dk6T\",\"zh.dda96faa.js\",\"7pAFt\",\"WarningIllustration.6f86942e.js\",\"2CfIU\",\"WarningIllustration.ec26752f.png\",\"1TOYq\",\"CoreInvites.8d8ff53d.js\",\"1d7Ag\",\"arrow-up-right--open.a14764a1.js\",\"8JZKd\",\"activity.7479de1f.js\",\"5uN9h\",\"arrow-up-right.b9da73d9.js\",\"j4ThT\",\"link-broken--unlink.278d8021.js\",\"aL59j\",\"settings.6b2650c7.js\",\"a0ogJ\",\"link--link-filled.7b54b8c4.js\",\"8KnyD\",\"component-lazy.39cad44c.js\",\"5a167\",\"scheduler-polyfill.ca4ea44c.js\",\"1Ywby\",\"simpleHasher.f97da9c3.js\",\"65c4i\",\"datasourceTableView.b76fdc9d.js\",\"iXzmH\",\"datasourceTableView.runtime.5c274deb.js\",\"euNhD\",\"archive.1acf3ad4.js\",\"1TICk\",\"archive.runtime.a9dc73c5.js\",\"4i0CB\",\"mention.774d1f3a.js\",\"2Cftu\",\"mention.runtime.3e88f659.js\",\"9XYQ9\",\"render.cafdc632.js\",\"h05Zl\",\"ufo.1597da7c.js\",\"iXzmH\",\"datasourceTableView.runtime.5c274deb.js\",\"1TICk\",\"archive.runtime.a9dc73c5.js\",\"2Cftu\",\"mention.runtime.3e88f659.js\",\"5iVCs\",\"cs.6a4c25c7.js\",\"k7RZQ\",\"da.9877c37f.js\",\"9CFJc\",\"de.bb97d0fd.js\",\"3fPuK\",\"en_GB.9561a37b.js\",\"dUyEb\",\"en_ZZ.c7ec2c16.js\",\"PAD2J\",\"es.8b476d00.js\",\"GNuQo\",\"fi.625ea11d.js\",\"fvsAU\",\"fr.3c57c9b9.js\",\"h7dGJ\",\"hu.a577b1ea.js\",\"kg6sH\",\"it.bd75db28.js\",\"fqF5W\",\"ja.edd3a363.js\",\"1WNp5\",\"ko.b85ae1d4.js\",\"iHPxa\",\"nb.20c3bd75.js\",\"Qf3VH\",\"nl.573e6cdf.js\",\"79OEV\",\"pl.98acd127.js\",\"27dMt\",\"pt_BR.405f85d7.js\",\"bkVVv\",\"ru.c004cf49.js\",\"MLhYA\",\"sv.aaf78479.js\",\"ap7kW\",\"th.a4a6fd4b.js\",\"45YAR\",\"tr.b2cb22e6.js\",\"kqhVG\",\"uk.47e01bb2.js\",\"1susf\",\"vi.1184af6c.js\",\"dl3k2\",\"zh_TW.6e51a40f.js\",\"aquXY\",\"zh.f784abff.js\",\"i4Poh\",\"DevToolsDialog.a1b93abe.js\",\"dUfIT\",\"OnboardingStateEditor.c399537b.js\",\"lUlCu\",\"star-starred.9b99dc04.js\",\"3qsjq\",\"star-unstarred.3e52de8c.js\",\"331QJ\",\"statsigIcon.d38e3090.png\",\"dKuGS\",\"switcherooIcon.4d3f783a.png\",\"kUbUu\",\"manual-triggers-modal.403b1245.js\",\"awqCy\",\"inlineCard.3abbf951.js\",\"lkOIY\",\"CommentsPanelFilterMenu.cce03a2c.js\",\"C72jX\",\"DevToolsBanner.6c186663.js\",\"jZwEH\",\"ExitBranchDeploy.df427067.js\",\"dUr0C\",\"FeedbackCollectorButton.fcc8e12e.js\",\"avZlC\",\"BannerContainer.62eec3be.js\",\"9mi9f\",\"BannerSpacer.db82d299.js\",\"kiqoj\",\"SuperAdminBanner.4fbf1368.js\",\"jE5XU\",\"SatisfactionSurveyFlag.1b0d59e1.js\",\"f8xBv\",\"SatisfactionSurveyComponent.be58036d.js\",\"4csuu\",\"terrible.43df9387.svg\",\"ezTnP\",\"bad.1f02aedc.svg\",\"lKYkZ\",\"okay.fd894a28.svg\",\"eOIaN\",\"great.e17ca230.svg\",\"c1rvV\",\"amazing.0fceeb3a.svg\",\"fbsPn\",\"AdminAnnouncementBanner.dcfaf2c0.js\",\"87NBA\",\"RelatedLinksModal.8aab7af4.js\",\"9wxKg\",\"NativeCollabComponent.7f7b097a.js\",\"1q2w7\",\"panel.8ebbd495.js\",\"1snL0\",\"panel.runtime.2bdf1927.js\",\"jXx9i\",\"NativeCollabComponent.37c3bfb3.js\",\"jkPqm\",\"datasourceTableView.0532d32c.js\",\"2Mq3f\",\"megaphone.8faf2592.js\",\"eIzhm\",\"AdminAnnouncementBanner.88cfc2b0.js\",\"1snL0\",\"panel.runtime.2bdf1927.js\",\"cjDIz\",\"GracePeriodBanner.98fd238c.js\",\"7WaUI\",\"UpFlowCommerceRouter.4901381c.js\",\"9ET5T\",\"GracePeriodBanner.b4e739ed.js\",\"4zlcK\",\"avoid-deactivation-data-modal.525cf63d.js\",\"bpZy3\",\"user-brand-dark.2dd77a4f.svg\",\"4B6ye\",\"user-brand-light.f1d0cd78.svg\",\"g2AXX\",\"user-gray-dark.8d7964d6.svg\",\"30svi\",\"user-gray-light.4df874b4.svg\",\"dTsOE\",\"modal.5991abc8.js\",\"jfplD\",\"GracePeriodBanner.8eca86e0.js\",\"4uVag\",\"StorageEnforcementBanner.fcd49e37.js\",\"cGZdO\",\"PlanConsentDeepLink.e85c4404.js\",\"hmjlF\",\"ConsentBannerWrapper.e9beef20.js\",\"a3Uq6\",\"esm.a58beee4.js\",\"exJm1\",\"browser-storage-controls.94f5eaab.js\",\"gCbq8\",\"cs.a209aa14.js\",\"TR24h\",\"da.52144f35.js\",\"NfUyB\",\"de.189b802b.js\",\"4v21d\",\"en_GB.58bcc852.js\",\"4D2WV\",\"en_ZZ.07b6b0f2.js\",\"gSwbJ\",\"es.27061460.js\",\"chaHI\",\"fi.f05d4dc5.js\",\"kBpIt\",\"fr.d4774d68.js\",\"dPeMl\",\"hu.9a5436ee.js\",\"4PHEa\",\"it.8260474e.js\",\"CGYMd\",\"ja.514cf297.js\",\"fGpBg\",\"ko.09d46e0e.js\",\"cgWNw\",\"nb.593f98f0.js\",\"aUP3I\",\"nl.9e24e59e.js\",\"bs4gz\",\"pl.e0577981.js\",\"gSXrz\",\"pt_BR.1efcd373.js\",\"aJd4I\",\"ru.b8c2b1b7.js\",\"gR7fm\",\"sv.07219ae9.js\",\"xDkFq\",\"th.be4d9bd0.js\",\"cV2OA\",\"tr.7e1ff419.js\",\"ehLR6\",\"uk.86f0ff8b.js\",\"lXmbw\",\"vi.43447bab.js\",\"jwfyA\",\"zh_TW.fa40865e.js\",\"6zOB9\",\"zh.d323a517.js\",\"7ETma\",\"BannerContainer.df04d1c8.js\",\"jryQt\",\"GlobalComponents.32b3d427.js\",\"lnKog\",\"main.bb935c2d.js\",\"6Up0b\",\"PageContentRendererFabric.406a82a8.js\",\"hUIij\",\"main.3f5bce87.js\",\"aLGWB\",\"WaveformAnimation.27743507.js\",\"kiGNy\",\"render.a63c9358.js\",\"ivNGg\",\"GeneratingAnimation.1e1e5744.js\",\"atyNV\",\"CreateSpaceDrawer.9305bfbd.js\",\"cPGpO\",\"premiumLozenge.aa9b0435.svg\",\"eMbU0\",\"SpaceSelector.4dd8f5d6.js\",\"3wN5D\",\"ExternalSpaceLozenge.de41bba8.js\",\"kC80R\",\"esm.d8e1aeea.js\",\"7Omhy\",\"esm.b690446e.js\",\"1GxVg\",\"EmojiPickerComponent.0d2936f8.js\",\"37ZO9\",\"EmojiPickerComponent.runtime.556f0b3a.js\",\"huYla\",\"modal.9b9e551c.js\",\"dS0Pr\",\"modal.runtime.34696ac2.js\",\"P2OWY\",\"DetailsPanelHeaderIcon.1b9f8413.js\",\"37ZO9\",\"EmojiPickerComponent.runtime.556f0b3a.js\",\"dS0Pr\",\"modal.runtime.34696ac2.js\",\"dJhDI\",\"Upload.41b8806c.svg\",\"M5ILR\",\"batteriesBlueDark.307d9428.svg\",\"dnR9a\",\"batteriesBlueLight.58029d15.svg\",\"ixrb7\",\"batteriesYellow.e8d8df45.svg\",\"kGVcH\",\"bookGreen.5c165cdd.svg\",\"loqoo\",\"bookLightBlue.c5d525e7.svg\",\"7Olsp\",\"bookPurpleDark.bbc69ae5.svg\",\"6qyLp\",\"bookPurpleLight.50087e6b.svg\",\"ciCdw\",\"bookTeal.baf50001.svg\",\"bps3L\",\"bookYellow.01d134f1.svg\",\"d8nip\",\"chartPages.84c56718.svg\",\"aEEfr\",\"chatBubbles.752ee291.svg\",\"81Z0f\",\"clipboardBlue.1f41d5b1.svg\",\"4Yhmf\",\"clipboardGreen.ff6ef343.svg\",\"iYpOd\",\"clipboardPurple.a753e54b.svg\",\"3E2sU\",\"clipboardTealLight.23775816.svg\",\"kLu4e\",\"clipboardTealDark.a991e538.svg\",\"4fLmK\",\"cogYellow.be8df822.svg\",\"3wJ5M\",\"fileCabinetTeal.16f6f59f.svg\",\"a9GoZ\",\"frameBlueLight.5b2ffbc9.svg\",\"fEhU6\",\"frameBlueDark.31054afc.svg\",\"3fQrZ\",\"frameGreen.c926fe32.svg\",\"d6OX2\",\"frameRed.43830b0b.svg\",\"aKOqx\",\"frameYellow.139065bc.svg\",\"5Egzg\",\"gearsGreen.90d00858.svg\",\"j7vSR\",\"insightBlueDark.37b94f41.svg\",\"jPZce\",\"insightBlueLight.9abf8616.svg\",\"kfwXh\",\"insightPurple.2faf728d.svg\",\"dwYXe\",\"pageSearchLight.e58e2baa.svg\",\"dAUqn\",\"pageSearchDark.cd5f6733.svg\",\"4Ou3u\",\"powerfulSearchLight.876ff255.svg\",\"9Dfl4\",\"powerfulSearchDark.2139ba31.svg\",\"h1Fz9\",\"ribbonLight.803a1a85.svg\",\"jDFmh\",\"ribbonDark.6fe08399.svg\",\"6GKoK\",\"roadmapLight.b91d4299.svg\",\"2yafp\",\"roadmapDark.a889e2f2.svg\",\"luNRW\",\"rocket.df13335e.svg\",\"5sgCW\",\"sandThingRed.1afa3779.svg\",\"lUKys\",\"templatesLight.79fdbc2b.svg\",\"c6izM\",\"templatesDark.770532e7.svg\",\"4fscz\",\"skyBackground.807308bc.svg\",\"bjH6i\",\"blankThread.8cd5fcf5.svg\",\"5H38F\",\"teamThread.805f1c78.svg\",\"hPrsC\",\"documentationThread.87cb7cb5.svg\",\"h65C2\",\"knowledgeThread.4da53513.svg\",\"GkFQZ\",\"softwareThread.c63cbb64.svg\",\"l9S8D\",\"marketingTeamThread.5ea9534d.svg\",\"9DuCc\",\"designTeamThread.a51c8a49.svg\",\"7b7Le\",\"operationsTeamThread.7b099258.svg\",\"5pZXJ\",\"projectManagementTeamThread.80f46356.svg\",\"97cUe\",\"financeTeamThread.1a41b925.svg\",\"bdlYs\",\"customerSupportTeamThread.93301b92.svg\",\"4Yl3h\",\"legalTeamThread.ba24ce51.svg\",\"gEtqu\",\"salesTeamThread.d1bfc373.svg\",\"c9Wdy\",\"itTeamThread.f9d7c100.svg\",\"2Z9oz\",\"researchTeamThread.742bf70b.svg\",\"hFzEL\",\"hrTeamThread.80788d38.svg\",\"hlubS\",\"productManagementThread.09fb011d.svg\",\"7KLrf\",\"projectCollaborationThread.80f46356.svg\",\"30xR7\",\"knowledgeBaseThread.4da53513.svg\",\"89THn\",\"blankHeaderImage.b2e5214d.svg\",\"e5j6w\",\"blankContentImage.37095a6e.svg\",\"lTMbq\",\"teamHeaderImage.f7f582cf.svg\",\"5rLIC\",\"meepleAngie.b36359fa.svg\",\"1WpWA\",\"meepleGael.321f0541.svg\",\"iDRHz\",\"meepleClaudia.49596a7e.svg\",\"abhev\",\"documentationHeaderImage.4412b92c.svg\",\"2JPI5\",\"sparklesIcon.c88101af.svg\",\"kFXQS\",\"recentlyUpdatedIcon.12afe66f.svg\",\"byqYh\",\"labelIcon.fde8f3d1.svg\",\"4acnY\",\"knowledgeHeaderImage.363eba36.svg\",\"besIq\",\"slackIcon.09e5da26.svg\",\"4LUrg\",\"topicsIcon1.0989a9fb.svg\",\"ahJUE\",\"topicsIcon2.b604b777.svg\",\"a3Rwk\",\"topicsIcon3.ba5d4623.svg\",\"4FAMd\",\"topicsIcon4.ced48f1d.svg\",\"gLN2K\",\"topicsIcon5.49641d70.svg\",\"9GDpT\",\"topicsIcon6.e4b2d662.svg\",\"aBtfy\",\"softwareHeaderImage.192899c6.svg\",\"bIOUn\",\"jiraIssuesImage.98370f5b.svg\",\"byj7D\",\"roadmapImage.af494b5e.svg\",\"5RVPP\",\"marketingTeamHeaderImage.2c3873b0.svg\",\"9LOKa\",\"meepleAlvin.36da1ebc.svg\",\"26SB0\",\"meepleNarul.7730aaba.svg\",\"3mZbA\",\"meepleFabian.5c813638.svg\",\"8L112\",\"designTeamHeaderImage.c46a93d2.svg\",\"bqaRi\",\"meepleHasan.08dad2a0.svg\",\"3eEUG\",\"meepleEliot.64d467ec.svg\",\"TbeMm\",\"meepleMaribel.f2261c26.svg\",\"hEeW5\",\"meepleEffie.7847ff50.svg\",\"lxkYJ\",\"meepleHelena.63e4f930.svg\",\"fkCcV\",\"meepleEd.971a9eb8.svg\",\"da9cR\",\"operationsTeamHeaderImage.a14d17e5.svg\",\"41WRw\",\"projectManagementTeamHeaderImage.33a5a479.svg\",\"7lq4P\",\"financeTeamHeaderImage.1a730228.svg\",\"ivAmF\",\"meepleOliver.42b4efc7.svg\",\"hjCA9\",\"meepleSteve.03d2a4bb.svg\",\"6WsSL\",\"customerSupportTeamHeaderImage.c936930a.svg\",\"4a7nj\",\"meepleEffieSquare.2634dbda.svg\",\"8W0HV\",\"meepleTanya.5912be0f.svg\",\"lV74y\",\"meepleAngieSquare.3e93f6cc.svg\",\"19y9E\",\"legalTeamHeaderImage.4d7daac4.svg\",\"brcnK\",\"salesTeamHeaderImage.44ad8004.svg\",\"6wRd5\",\"itTeamHeaderImage.31c8b476.svg\",\"4Xo1Q\",\"researchTeamHeaderImage.1f6efccb.svg\",\"e3lCz\",\"hrTeamHeaderImage.e709f28b.svg\",\"59GCR\",\"productManagementHeaderImage.b0a18370.svg\",\"eDipp\",\"projectCollaborationHeaderImage.33a5a479.svg\",\"3oMbG\",\"knowledgeBaseHeaderImage.363eba36.svg\",\"4nr7V\",\"pageIcon.21c39749.svg\",\"jXgU3\",\"blogIcon.9747a79d.svg\",\"3FTtM\",\"meepleLydia.bed2d01d.svg\",\"7XX5f\",\"meepleKatina.172e1240.svg\",\"gmEwc\",\"meepleMilo.8a0e1272.svg\",\"61eGd\",\"meepleLara.c691a9bf.svg\",\"4Be4D\",\"meepleNorah.d4705d04.svg\",\"f1x0y\",\"flag.198afb7e.js\",\"1yVM6\",\"UpgradeEditionButton.a8a8046a.js\",\"1qlDN\",\"UpgradeEditionButton.runtime.c5edbfd2.js\",\"6vhrJ\",\"24.25e29644.js\",\"5pvpJ\",\"datasourceTableView.022fac01.js\",\"h4k4y\",\"media.115ffd20.js\",\"b8BDn\",\"js.a0af0607.js\",\"dLFEp\",\"png-chunks-extract.01966068.js\",\"6XCf4\",\"LearnMoreButton.da2a1c97.js\",\"9sJzT\",\"ShareButton.8d75d860.js\",\"eeaKR\",\"credit-card.39a2b6fa.js\",\"fzHDF\",\"archive-box.c5ec2eea.js\",\"eEyVs\",\"book-with-bookmark.f202cd02.js\",\"19uFC\",\"pages.d69df670.js\",\"QcHuP\",\"InspectPermissionsDialog.5d25c2dd.js\",\"8UKe0\",\"chart-trend-up.daa97715.js\",\"4o7bO\",\"CreateSpaceDrawer.8a8ee04d.js\",\"huUvS\",\"16.f4d29d37.js\",\"1oiJ6\",\"16.9b0cfada.js\",\"lxiFd\",\"16.bfa31662.js\",\"eDqo1\",\"16.c9c1057f.js\",\"6HBYC\",\"16.10256d2c.js\",\"bYxCZ\",\"16.733e7fd3.js\",\"eTBsW\",\"16.6f5a520f.js\",\"020xd\",\"16.54d36bc8.js\",\"ls0Um\",\"16.055b6b2a.js\",\"eVYW1\",\"16.ae0fb140.js\",\"f35QR\",\"16.10d23cc6.js\",\"fGT64\",\"media.7fd0f14d.js\",\"1qlDN\",\"UpgradeEditionButton.runtime.c5edbfd2.js\",\"9JWXo\",\"ImportContentDrawer.681bd03b.js\",\"6aruy\",\"media-client-react.1f7d46bc.js\",\"hqblC\",\"browser.4fe71ae1.js\",\"4lnLb\",\"media-viewer-error-boundary.30be694d.js\",\"5eYbH\",\"fileIconLight.abb757fe.png\",\"f27VQ\",\"fileIconDark.2e9120d4.png\",\"eQRZh\",\"alexander.61c8c5b8.png\",\"k3UTH\",\"milo.2bdab175.png\",\"bpNrn\",\"vania.0f716e7d.png\",\"1SbNU\",\"newUsersIcon.57d15f82.png\",\"4pzfE\",\"entireWorkspaceGraphic.ec7c84e3.png\",\"9EbOe\",\"entireWorkspaceGraphicDark.a2cf125d.png\",\"5v8ge\",\"pageWithSubpagesGraphic.bc63f39a.png\",\"l5ApQ\",\"pageWithSubpagesGraphicDark.048b0716.png\",\"e233E\",\"NotionFileIcon.bf57d29e.png\",\"2HswK\",\"NotionFileIconDark.1bce2172.png\",\"iHoZ2\",\"mapNotionMembersIcon.f5fa6c65.png\",\"mKUlU\",\"mapNotionMembersIconDark.78a4caee.png\",\"lve0S\",\"dontMapNotionMembersIcon.d4b46256.png\",\"fHhNe\",\"dontMapNotionMembersIconDark.8a5a6302.png\",\"idIGV\",\"addRemainingMembersIcon.ed292f87.png\",\"eFqPt\",\"addRemainingMembersIconDark.fcaa97df.png\",\"ahBHt\",\"dontAddRemainingMembersIcon.c16498ed.png\",\"bJ6Qx\",\"dontAddRemainingMembersIconDark.2a9fa7cf.png\",\"jO0Zn\",\"copyPagePermissionsIcon.893f44bc.png\",\"koH91\",\"dontCopyPagePermissionsIcon.57c83ce6.png\",\"4qS5d\",\"createNewSpaceIcon.43619a57.png\",\"7HrUn\",\"createNewSpaceIconDark.1df6e816.png\",\"rGPsx\",\"dontCreateNewSpaceIcon.b35b2829.png\",\"5a1S5\",\"dontCreateNewSpaceIconDark.706b6cfd.png\",\"8R1Rz\",\"spaceTransferLight.b2e70613.png\",\"1e1ep\",\"spaceTransferDark.856b3d0e.png\",\"jGDZO\",\"zipFileIconLight.abb757fe.png\",\"4pvad\",\"zipFileIconDark.2e9120d4.png\",\"4xmnl\",\"spaceTransferIconLight.5eeae605.png\",\"aBnpB\",\"spaceTransferIconDark.9c0b5b2f.png\",\"aRCSw\",\"miroBulkImportIconLight.f695f170.png\",\"dur8E\",\"miroBulkImportIconDark.3dc15c83.png\",\"eGDQk\",\"Miro_Connie_Light.97ddc4df.png\",\"5IkEQ\",\"Miro_Connie_Dark.588133c4.png\",\"d4y04\",\"muralSpacesIllustrationLight.297ed65c.png\",\"hgEBB\",\"muralSpacesIllustrationDark.a5d03bf9.png\",\"4YW3x\",\"inviteMembersIconLight.1a833efb.png\",\"jw4LE\",\"inviteMembersIconDark.1179e32a.png\",\"hoRD8\",\"newSpaceIconLight.9405f85d.png\",\"5ILSM\",\"newSpaceIconDark.9c0b5b2f.png\",\"2Q5QN\",\"muralIcon.75d8302a.png\",\"fK2sh\",\"muralSpacesIllustrationDisconnectedLight.4bd334a6.png\",\"3aNue\",\"muralSpacesIllustrationDisconnectedDark.a6cca434.png\",\"7MlKm\",\"archive.5e2679d9.js\",\"7WcBh\",\"MovePageDialog.3110b108.js\",\"k78EM\",\"media.35656e16.js\",\"5abXM\",\"media.runtime.b495c6bc.js\",\"fqGSw\",\"CommentsPanelFilterMenu.780c09f0.js\",\"5abXM\",\"media.runtime.b495c6bc.js\",\"hX5aL\",\"ImportContentModal.9589df9b.js\",\"dIKKx\",\"StorageEnforcementFlags.66a191a3.js\",\"52dqm\",\"GracePeriodModal.86d32684.js\",\"6sJUU\",\"GracePeriodModalComponent.bab4caff.js\",\"gKiqN\",\"gracePeriodIllustrationDark.e34dd459.svg\",\"02fAA\",\"gracePeriodIllustrationLight.04bd67a4.svg\",\"gIOIL\",\"BlockCreateModal.8f0bc1e2.js\",\"fDkpP\",\"blockCreateIllustrationLight.10953577.svg\",\"36KWd\",\"blockCreateIllustrationDark.e6b33366.svg\",\"3CJXT\",\"rovo-video-modal.a0ef0eb2.js\",\"1oAGT\",\"shrink-diagonal.f22f633c.js\",\"2Gceu\",\"minimize.b3b85be5.js\",\"f9Wnm\",\"shrink-diagonal--media-services-fit-to-page.807104c9.js\",\"ktyyJ\",\"TrialFlags.81a51d78.js\",\"dj3mE\",\"ExperimentPlanSelectionModal.65e262fc.js\",\"3AFNb\",\"illustrationStandard.3fd561a4.svg\",\"c7qkT\",\"illustrationBestValue.d42ec92a.svg\",\"cYTMv\",\"illustrationBestValueDarkMode.4db8a5eb.svg\",\"eRZ4m\",\"illustrationStandardDarkMode.d9f68860.svg\",\"gmwfN\",\"ModernizeChangeboarding.bab5b3a1.js\",\"iZkNL\",\"Modal.7bb45a79.js\",\"4jvyy\",\"play-button.f16ed914.png\",\"bSWox\",\"thumbnail-light.cbc485ab.png\",\"espuV\",\"thumbnail-dark.4c2a9461.png\",\"7VEEc\",\"whiteboards.5bac062b.svg\",\"1S5Y4\",\"rovo-ai.1a901dc7.svg\",\"dZyP8\",\"reactions-and-stickers.1f3b4ebe.svg\",\"8VWrF\",\"jira-work-items.11443501.svg\",\"55agv\",\"loom-videos.37a4452c.svg\",\"jGjVz\",\"whiteboards-dark.5a9dae19.svg\",\"j77CV\",\"rovo-ai-dark.ac54f515.svg\",\"33gHJ\",\"reactions-and-stickers-dark.fd611bb0.svg\",\"eRF5i\",\"jira-work-items-dark.f74ce1c2.svg\",\"crbaY\",\"loom-videos-dark.1afab585.svg\",\"31kOm\",\"nav4GlobalSpotlightImage.b0eee534.svg\",\"dW3gq\",\"nav4GlobalSpotlightImageDark.46829a6e.svg\",\"1aHOD\",\"nav4SpaceSpotlightImage.8dc1626b.svg\",\"huVSt\",\"nav4SpaceSpotlightImageDark.eeaa5b5d.svg\",\"iXULO\",\"LiveDocModalGif-light.2404511f.gif\",\"ff6Qm\",\"LiveDocModalGif-dark.64c94d68.gif\",\"li9sm\",\"MainButtons.8a6e6809.js\",\"8S7hU\",\"ContentWrapperSpotlightGIF-dark.bbe9839d.gif\",\"7P169\",\"ContentWrapperSpotlightGIF-light.9900190e.gif\",\"gs8si\",\"ConfluenceSmartCreationModalManager.cfaf535d.js\",\"fQKYr\",\"ConfluenceSmartCreationModal.e0b3ce87.js\",\"9gDvs\",\"accessibility.5564f20e.svg\",\"f4pjt\",\"award.214f8776.svg\",\"1A7In\",\"calendar.b3d986a4.svg\",\"hbmJV\",\"checklist.73c2b414.svg\",\"dfz72\",\"community.e0696574.svg\",\"8iDBX\",\"customer.b92e93e7.svg\",\"g9qwo\",\"develop.57b4f578.svg\",\"5MnfW\",\"flowchart.a71ff7c1.svg\",\"92hcC\",\"guidelines.997e35c4.svg\",\"YpFw7\",\"hire-writer.de7ada5b.svg\",\"hPfyy\",\"icons-gears.bfd13e5a.svg\",\"4d6gC\",\"icons-people.f158a567.svg\",\"ckHEC\",\"illustrations.98e8bf43.svg\",\"iXa6x\",\"lightbulb.e4ffc69c.svg\",\"lA2m1\",\"marketing.2c92f054.svg\",\"9DSi1\",\"onboarding.43d000af.svg\",\"69pz5\",\"project-management.8376933a.svg\",\"bFaEu\",\"release-phases.4229641f.svg\",\"4HRl6\",\"resilience.4a0de1ce.svg\",\"kyaih\",\"system-of-work.579d0af3.svg\",\"avXjM\",\"tips.695c0031.svg\",\"g7RCN\",\"trust.ae24e421.svg\",\"klZVQ\",\"user-testing.1d397bb2.svg\",\"aSfft\",\"vision-values.6d647ce6.svg\",\"bDavb\",\"volunteering.f0465fb3.svg\",\"7iOBS\",\"ConfluenceCreateIllustrationLight.e6af8be5.svg\",\"gNGuh\",\"ConfluenceCreateIllustrationDark.6237fca1.svg\",\"2tjCd\",\"main.568182d8.js\",\"7Vmxp\",\"table.b82c9896.js\",\"koKgZ\",\"datasourceRenderFailedAnalyticsWrapper.6dd05041.js\",\"7ixUU\",\"datasourceTableView.379f982c.js\",\"6cVEd\",\"fire-event.74c5ca8b.js\",\"db8rp\",\"datasourceTableView.2b4b0548.js\",\"7fMGd\",\"dark.16cc06e7.svg\",\"8OP1c\",\"light.e350f7db.svg\",\"gywm1\",\"dark.981334ac.svg\",\"29by2\",\"light.d61b1f64.svg\",\"XXMwE\",\"dark.90199792.svg\",\"cqbvn\",\"light.5ffcf568.svg\",\"bEo2Z\",\"standard.6c3cc6ed.svg\",\"8makw\",\"datasourceTableView.851020c6.js\",\"cwpgX\",\"datasourceTableView.8d80f86b.js\",\"gxkWc\",\"chevron-up.0e24c8c4.js\",\"jBtK5\",\"refresh.cc141204.js\",\"hoPZ9\",\"cs.633f358a.js\",\"gyXEE\",\"cs.f1b99b89.js\",\"i9sd0\",\"cs.ac94c7d7.js\",\"2Fu3d\",\"da.abfdc86b.js\",\"1Mp9N\",\"da.3b102b96.js\",\"aNg21\",\"da.fcd47f4a.js\",\"eJgH8\",\"de.6f3115d9.js\",\"dBb6q\",\"de.593d3b2f.js\",\"YEGhv\",\"de.48235885.js\",\"2YffH\",\"en.a1e59143.js\",\"7Lkvk\",\"en_GB.3d689c61.js\",\"2RQvP\",\"en_GB.8a36850a.js\",\"d8WL7\",\"en-GB.cb14e00e.js\",\"5FaEJ\",\"en_ZZ.1bd99558.js\",\"cukQS\",\"en_ZZ.eed1fbc6.js\",\"j5F5K\",\"en-ZZ.7c0f8a4e.js\",\"9yemY\",\"es.d8a58005.js\",\"3CucM\",\"es.097ed453.js\",\"dXu4x\",\"es.01147d0a.js\",\"5IaSN\",\"et.981137d9.js\",\"34YSq\",\"et.c555b67d.js\",\"l2LZP\",\"fi.e605cdc1.js\",\"lp8Wm\",\"fi.ad1e7b8f.js\",\"18TX5\",\"fi.92eec141.js\",\"35Ssm\",\"fr.969afb6a.js\",\"cHWSM\",\"fr.99efe9f9.js\",\"9Cdzw\",\"fr.f7a6df8c.js\",\"ik6u5\",\"hu.7cafb88d.js\",\"b37xN\",\"hu.3de7e458.js\",\"guNAg\",\"hu.fe0156a4.js\",\"fModo\",\"is.ef98b365.js\",\"Vt6S9\",\"it.8aa489b6.js\",\"7PjNK\",\"it.10e5966f.js\",\"cM3gY\",\"it.a86505c9.js\",\"9GZ76\",\"ja.6becd9ee.js\",\"ktSfi\",\"ja.f8b04575.js\",\"6yRq3\",\"ja.b2d80357.js\",\"4sOIV\",\"ko.92e96c65.js\",\"iouLY\",\"ko.7c8a5bee.js\",\"cft22\",\"ko.ee14ead1.js\",\"QTjdE\",\"nb.5234b817.js\",\"hPZE5\",\"nb.95a7fb27.js\",\"gctEz\",\"nb.974cb869.js\",\"hrf1M\",\"nl.932652ba.js\",\"dzIm8\",\"nl.3fd07f4d.js\",\"9PPH7\",\"nl.b7ae60bc.js\",\"lsloj\",\"pl.ccac68a2.js\",\"jqwnR\",\"pl.750f11bd.js\",\"1y1eN\",\"pl.d82d351b.js\",\"iRKhU\",\"pt_BR.16392395.js\",\"bGhLc\",\"pt_BR.7338b148.js\",\"e8jpx\",\"pt-BR.e2410441.js\",\"aGECO\",\"pt_PT.b38348c7.js\",\"aOdaf\",\"ro.95663ae9.js\",\"6tWAg\",\"ro.9b0188fa.js\",\"aEAsN\",\"ru.966e8af5.js\",\"9v6ER\",\"ru.ed8645ea.js\",\"fjbzp\",\"ru.2682923f.js\",\"5WkxF\",\"sk.d2eeea9b.js\",\"l6YHr\",\"sv.d2736638.js\",\"8Mz40\",\"sv.3166ea2c.js\",\"1pFHs\",\"sv.b309f38b.js\",\"l7PQP\",\"th.93fb5ab5.js\",\"77dzh\",\"tr.f1ada3aa.js\",\"6NHX3\",\"tr.ad560b51.js\",\"d0Fxy\",\"tr.491b614d.js\",\"fLjHM\",\"uk.7a8159bb.js\",\"3YGga\",\"vi.a291c6ef.js\",\"afU9w\",\"zh_TW.baf776ed.js\",\"hF4v3\",\"zh_TW.52e41400.js\",\"kKXTS\",\"zh-TW.bb215506.js\",\"7iCpI\",\"zh.fd5bafce.js\",\"1Tuyb\",\"zh.3b44b3ff.js\",\"7sItg\",\"zh-CN.1e4a68e1.js\",\"2lsX7\",\"main.33e42dd9.js\",\"c9Qqc\",\"auto-dev.232d76cf.js\",\"1TK6P\",\"auto-fix.257eceb2.js\",\"grvAy\",\"auto-review.0fe9b7f1.js\",\"23K0q\",\"backlog-buddy.d757d61a.js\",\"3kQkj\",\"comms-crafter.36507020.js\",\"6OXgE\",\"culture.33e027e3.js\",\"cbucA\",\"customer-insight.7dfcf35a.js\",\"bVhr1\",\"decision-director.35d226a4.js\",\"kE0QC\",\"feature-flag-avatar.f9d8e991.js\",\"eVFXf\",\"generic-avatar.cd98d7cb.js\",\"9FhBz\",\"hire-writer.7ebbca98.js\",\"6zB8z\",\"marketing-message-maestro.7404e3da.js\",\"eENGY\",\"my-user-manual.ac6d3669.js\",\"hmlb0\",\"okr-oracle.0602d51c.js\",\"2NGxc\",\"ops-agent.012e195b.js\",\"bPgcq\",\"pitch-perfector.e73b56ef.js\",\"31b1q\",\"product-requirement.2ba2b672.js\",\"8Lh9U\",\"release-notes.3c1911fc.js\",\"6ZzYJ\",\"research-scout.e2c817ef.js\",\"2zIbn\",\"rovo-dev.f6f9366f.js\",\"410SS\",\"social-media-scribe.e5fe68a5.js\",\"z3s9q\",\"team-connection.5f505a11.js\",\"9gqcE\",\"workflow-builder.07423129.js\",\"eipnW\",\"trial-guide.b54ccfd0.js\",\"1S9KM\",\"lock-locked--lock-circle.8a4d7155.js\",\"frhR0\",\"main.3cc72814.js\",\"LQeCh\",\"Rovo-loadingV2.b5f1b3c5.gif\",\"cU3hB\",\"smart-creation-wrapper.20786dc5.js\",\"hVTOO\",\"ConfluenceSmartCreationModal.405ec6d8.js\",\"lPsQk\",\"error-smart-create-icon.94df62fb.svg\",\"hFXeG\",\"main.0462ba49.js\",\"jn9xB\",\"Create-with-Rovo-Loading-Dark-Mode.07403868.gif\",\"81ouS\",\"Create-with-Rovo-Loading-Light-Mode.41a65ca6.gif\",\"ayspZ\",\"ui.ad6b968c.js\",\"37ldp\",\"block.7120c0d7.js\",\"7PMju\",\"refractor.4bbd520a.js\",\"7f9Fz\",\"root-component.2ecfdf2b.js\",\"iraZ1\",\"react-markdown.d5d9f6c3.js\",\"3GB1F\",\"conversation-assistant-viz.2c0373a4.js\",\"slRZz\",\"charts.f78b2d97.js\",\"bQUGu\",\"GoalPanel.fcba4a6f.js\",\"lNb0L\",\"GoalPanel.4a5bbb50.js\",\"k5bNG\",\"charts.f73248c6.js\",\"bYGFL\",\"charts.0e0a03c2.js\",\"2KBe6\",\"charts.988fd083.js\",\"jfCh6\",\"rovo.b06223c6.png\",\"bHRnB\",\"deep-research-icon.837407f5.svg\",\"7rHnm\",\"rovo-chat-bubbles.ad8ad13a.svg\",\"jlIyF\",\"studio-trigger-solution-build.dbdaf502.js\",\"ixTAZ\",\"text-field.3fa52048.js\",\"bvkpZ\",\"text-area.732a8a35.js\",\"e3d45\",\"date-time-picker.16f5bb45.js\",\"hvGeE\",\"datetime-picker.28c4d559.js\",\"d34hg\",\"gic-anywhere.b4260d43.js\",\"2O2Xv\",\"gic-anywhere.e60629ca.js\",\"anP9P\",\"error.5fbc7fe9.png\",\"gvJDI\",\"generic-issue-type-icon.b13acfc5.svg\",\"i7J2B\",\"avatar-with-arrow-darkmode.d9464bf1.svg\",\"2FbWf\",\"avatar-with-arrow.71e68580.svg\",\"3Xxws\",\"avatar-with-lock-darkmode.39948dbb.svg\",\"85zTu\",\"avatar-with-lock.b0750eee.svg\",\"girkx\",\"pencilled-field-with-arrow-darkmode.9a09e770.svg\",\"dCfoG\",\"pencilled-field-with-arrow.6615a67d.svg\",\"dG1sE\",\"text-field-with-lock-darkmode.6b00710c.svg\",\"jQD4g\",\"text-field-with-lock.548927e7.svg\",\"hZ3Uy\",\"text-field-with-tick-darkmode.49503976.svg\",\"h1tvj\",\"text-field-with-tick.9650a889.svg\",\"8jz4U\",\"mcp-server-tools.59be8744.js\",\"jALB7\",\"database-icon.af3511fd.svg\",\"aLbrw\",\"live-docs-icon.5595b5be.svg\",\"fe7gr\",\"page-icon.4dd78b86.svg\",\"cknJE\",\"preview-card-database-header.8549ac7f.svg\",\"gMvyv\",\"preview-card-page-header.8639e9c6.svg\",\"6p1RF\",\"preview-card-whiteboard-header.a8b554de.svg\",\"fuzt0\",\"whiteboard-icon.552d11f4.svg\",\"397zr\",\"conversation-assistant-auto-suggest.3607614b.js\",\"bWQZc\",\"3p-product-configs.a166b58b.js\",\"lXkAL\",\"InformationModal.f84ea23a.js\",\"2xz6W\",\"feedback-flag.66cb31f5.js\",\"lc53W\",\"local-frontend-components.7d5ced97.js\",\"krHda\",\"conversation-assistant-agent.acd47386.js\",\"l3kSC\",\"retry.d3d082f7.js\",\"a4yJG\",\"folder-open.6a0f53ed.js\",\"5m8Kg\",\"analyze-icon.5c4c7ecb.svg\",\"b2eNj\",\"brainstorm-icon.f24d96f2.svg\",\"4ofWJ\",\"create-icon.59c93a6c.svg\",\"jdeyK\",\"execute-icon.d7c359b6.svg\",\"5faYL\",\"find-icon.63225fe6.svg\",\"lPxCc\",\"learn-icon.7e0ca0d6.svg\",\"aDBGk\",\"review-icon.7da7ded4.svg\",\"grAf6\",\"summarize-icon.5a91c5af.svg\",\"6SM2I\",\"cs.fec650e3.js\",\"ivb6v\",\"da.92316868.js\",\"7LTI5\",\"de.3bc2c430.js\",\"hgUao\",\"en_GB.96c5329c.js\",\"j787T\",\"en_ZZ.93f5f5e7.js\",\"aEmWg\",\"es.3a34e945.js\",\"eR8Wp\",\"fi.b3ad1d6a.js\",\"72xPj\",\"fr.32a7e66a.js\",\"1OOEW\",\"hr.1a876c89.js\",\"jPs8I\",\"hu.a75990ee.js\",\"8dbN2\",\"it.93f492a7.js\",\"i9Imr\",\"ja.cdd6347f.js\",\"kYLWR\",\"ko.286349ad.js\",\"lC975\",\"nb.98d16e30.js\",\"jyEOm\",\"nl.143d7b0d.js\",\"agZBy\",\"pl.08db0f7a.js\",\"i0zKK\",\"pt_BR.1543678e.js\",\"2zDhc\",\"ru.987f5614.js\",\"4eO7d\",\"sl.27190420.js\",\"1Tr0G\",\"sr_RS.1247f084.js\",\"fGDED\",\"sr_YR.b869093c.js\",\"2l8tR\",\"sv.44362bb8.js\",\"4JJfl\",\"th.cd1411ae.js\",\"hYpqC\",\"tr.46ffade7.js\",\"cjEKg\",\"uk.2ec33bbf.js\",\"faxoo\",\"vi.ab8cf534.js\",\"a2X8X\",\"zh_TW.f3e42df6.js\",\"4arx8\",\"zh.cd39d5a8.js\",\"jTExV\",\"object-list-flyout-content.82c4ab6c.js\",\"je720\",\"no-results-dark.90199792.svg\",\"5CyuG\",\"no-results-light.5ffcf568.svg\",\"cGPv6\",\"empty.72f8b026.svg\",\"1B7k9\",\"error-state-dark.fd22b26d.svg\",\"9Ftrm\",\"error-state-light.f4c1cfc8.svg\",\"b9XqL\",\"no-results-dark.90199792.svg\",\"d019N\",\"no-results-light.5ffcf568.svg\",\"igAEH\",\"filters-dropdown.5617daaa.js\",\"5jNvH\",\"object-list-flyout-content.c8dc55dd.js\",\"pHE7k\",\"customization-modal.47379547.js\",\"hyJLQ\",\"customization-modal.89f38733.js\",\"3EXzu\",\"render.ba8f0428.js\",\"k1X5f\",\"RelatedLinksModal.d9f970c6.js\",\"lF0i0\",\"RelatedLinksModal.runtime.ece03e3a.js\",\"7RNcA\",\"component-lazy.9f48fd6f.js\",\"8bZKp\",\"component-lazy.0a6062b7.js\",\"aeEUI\",\"modal.0ec2b84e.js\",\"cmCrq\",\"modal.34d5af12.js\",\"enYNd\",\"modal.1fa144ae.js\",\"fTFcV\",\"mention.a3cbbc2f.js\",\"2KJHS\",\"esm.c998e094.js\",\"hyqsV\",\"esm.e99e8d08.js\",\"eYGV1\",\"AgentProfileCard.965e0391.js\",\"5Vmp6\",\"FullPageEditorComponent.671f4d55.js\",\"65rGD\",\"FullPageEditorComponent.runtime.5dff05cb.js\",\"fSV9f\",\"definition-popup-content.312ff617.js\",\"diR8t\",\"FullPageEditorComponent.e5b63cca.js\",\"huMsn\",\"FullPageEditorComponent.runtime.39ab9c21.js\",\"90kvt\",\"FullPageEditorComponent.42292d23.js\",\"9A0ig\",\"CommentEditor.ba3220d2.js\",\"69XRr\",\"team-preview-panel.6ff465c5.js\",\"e6wQ8\",\"team-preview-panel.035a8c2a.js\",\"attzI\",\"FullPageEditorComponent.1df8b2d1.js\",\"49cor\",\"agent-section.cd3f1976.js\",\"4T3hD\",\"conversation-assistant-agent.82bab2a9.js\",\"6faJ6\",\"lock-locked--lock.c940389d.js\",\"jdLWZ\",\"AgentProfileCard.19b882b6.js\",\"3kUQf\",\"eye-open-strikethrough.f218ba66.js\",\"kvwtq\",\"star-starred--star-filled.ff6efd9b.js\",\"aKNGF\",\"star-unstarred--star.3de48f64.js\",\"3RGYS\",\"briefcase--suitcase.21804e5c.js\",\"4Jbf1\",\"sprint.69e64865.js\",\"8Qv5g\",\"transition.dc10ff19.js\",\"3fdRd\",\"recommended-agents-preloader.6fd36271.js\",\"euJgP\",\"preview-bg.12045916.svg\",\"2fk6g\",\"16.39b6cb2e.js\",\"72780\",\"24.43557862.js\",\"hszIA\",\"24.9fce27aa.js\",\"4jPsO\",\"24.ea1906ea.js\",\"jDjSj\",\"16.0f9c0dbd.js\",\"8059b\",\"16.77f9d828.js\",\"3wmvj\",\"16.6efd8621.js\",\"hPalR\",\"16.782a40c1.js\",\"ijPJo\",\"spreadsheet.8bd9df3a.js\",\"iIL8i\",\"CommentsPanelFilterMenu.1cb228cf.js\",\"2i16i\",\"main.82db89cb.js\",\"2tSa5\",\"main.49975ab5.js\",\"5wtVQ\",\"main.033de189.js\",\"03aeW\",\"en_GB.21088f7b.js\",\"6nK39\",\"th.21f733a6.js\",\"hWNfo\",\"tr.db7fac89.js\",\"8UuQQ\",\"uk.78edbc55.js\",\"6BkMx\",\"vi.d59c3bda.js\",\"lWxi6\",\"main.0e70053b.js\",\"amUNi\",\"GoalPanel.e53e08ba.js\",\"4eboO\",\"CommentsPanelFilterMenu.31273927.js\",\"lF0i0\",\"RelatedLinksModal.runtime.ece03e3a.js\",\"65rGD\",\"FullPageEditorComponent.runtime.5dff05cb.js\",\"huMsn\",\"FullPageEditorComponent.runtime.39ab9c21.js\",\"878st\",\"base-component.f706b394.js\",\"jle6Z\",\"premium.3f265b33.js\",\"dAn5k\",\"base-component.88956e95.js\",\"6xJuR\",\"base-component.2b2656f7.js\",\"6Yu8N\",\"ShareButton.6f3a8154.js\",\"8fTZe\",\"GlobalComponents.c7bcb837.js\",\"lz2pE\",\"EditionAwarenessUpsell.8728eb90.js\",\"eWCiQ\",\"standard-to-premium-modal.88ade653.js\",\"lRtGG\",\"dashboard.839aaa25.js\",\"becB8\",\"on-call.39b97377.js\",\"adH3p\",\"roadmap.beb86071.js\",\"gjVBG\",\"devices.13a157d4.js\",\"hUapU\",\"StandardToPremiumModal.b91c1e53.js\",\"99Yp3\",\"standard-to-premium-modal.5020e939.js\",\"gobtw\",\"cs.f2325b58.js\",\"4XclW\",\"da.8823548e.js\",\"5FpC5\",\"de.9f8c75dc.js\",\"Z7F9W\",\"en_GB.88145e4b.js\",\"5vJlz\",\"en_ZZ.6e66d65b.js\",\"kqbLA\",\"es.ebafda9e.js\",\"2xTUv\",\"fi.e29037f1.js\",\"ke5Ak\",\"fr.c635078e.js\",\"78Xv1\",\"hu.36e2e3d5.js\",\"9WYDz\",\"it.b621bab0.js\",\"14Xp5\",\"ja.00759942.js\",\"5YZ43\",\"ko.cb3af28f.js\",\"hcAAz\",\"nb.cd8afc0a.js\",\"a3CGb\",\"nl.7356521a.js\",\"3jRvQ\",\"pl.7af8622a.js\",\"3eKFX\",\"pt_BR.24688c8c.js\",\"2cWJ7\",\"ru.b416633d.js\",\"7io6v\",\"sv.370b80d6.js\",\"bcDrQ\",\"th.aaf28806.js\",\"23xaC\",\"tr.5a5f7532.js\",\"dBkXE\",\"uk.f9026017.js\",\"fQKkM\",\"vi.09fcf459.js\",\"cXjwK\",\"zh_TW.2cb7259f.js\",\"fCfjN\",\"zh.9966cb4b.js\",\"eufZR\",\"PageHeaderLoomEntryPoint.b30b9a24.js\",\"3FT39\",\"cs.b4709f80.js\",\"7QoTg\",\"da.e788fd22.js\",\"d1Lrf\",\"de.2dd434ed.js\",\"kM5GB\",\"en_GB.82797faf.js\",\"5506N\",\"en_ZZ.a7c6e9ad.js\",\"7ioy0\",\"es.a4af58eb.js\",\"kZ6zs\",\"fi.aaa32cea.js\",\"phbpE\",\"fr.0e55ec47.js\",\"6pKhl\",\"hu.8153cc96.js\",\"hzLOt\",\"it.75418871.js\",\"1M8mW\",\"ja.6ef7e39a.js\",\"eHQAY\",\"ko.36b5b8ee.js\",\"8exPB\",\"nb.9e9e6a03.js\",\"knfAP\",\"nl.dbd0c739.js\",\"ljRXP\",\"pl.7932a8db.js\",\"bEb8c\",\"pt_BR.e2f7c972.js\",\"c7JYF\",\"ru.a2b7a11a.js\",\"ari8V\",\"sv.1d81f4cf.js\",\"kfrHX\",\"th.0d215dce.js\",\"aWToy\",\"tr.9415008a.js\",\"4ns5x\",\"uk.baa17c6e.js\",\"7bfAn\",\"vi.26b5754b.js\",\"gftgT\",\"zh_TW.b791e5b1.js\",\"6YVlG\",\"zh.ccb62d88.js\",\"6KFfh\",\"credit-card--creditcard-filled.b29fbb0e.js\",\"icLtf\",\"EditionAwarenessUpsell.3c72cfb8.js\",\"9CRBg\",\"StandardToPremiumModal.7596a714.js\",\"7e13v\",\"modal.1ab7ee5c.js\",\"kel4J\",\"CommentEditor.ce41adfd.js\",\"hv4mn\",\"modal.fe109fa9.js\",\"fisfU\",\"video-play-overlay.0278a0bb.js\",\"3z2v3\",\"EditorComponent.5d1ba0af.js\",\"i1TuF\",\"cs.2190cb07.js\",\"eEPT4\",\"da.02eaca38.js\",\"gkfGT\",\"de.90355bf8.js\",\"6kSRw\",\"en.32193a4b.js\",\"2dFTF\",\"en_GB.09598cb2.js\",\"auo6z\",\"en_ZZ.f14ca7c2.js\",\"685rk\",\"es.8fa0593c.js\",\"fp6pG\",\"fi.71fd59df.js\",\"6bt8l\",\"fr.40c5717d.js\",\"jjvsl\",\"hu.50ccd7da.js\",\"bAfbH\",\"it.e0e7a6ba.js\",\"5Q9X0\",\"ja.2dfec41f.js\",\"ePkyJ\",\"ko.0b1ec89d.js\",\"hpdFn\",\"nb.b2e768d2.js\",\"8qW90\",\"nl.7f781ad8.js\",\"a1OSV\",\"pl.ca25a045.js\",\"8AvOI\",\"pt_BR.eb536358.js\",\"jxu37\",\"ru.3bbb4cd9.js\",\"10YQF\",\"sv.b02b2c4a.js\",\"daBgp\",\"tr.1172519d.js\",\"bI6N0\",\"th.b72c3249.js\",\"3Qhls\",\"uk.c5a9160e.js\",\"dgXIC\",\"vi.98dce50e.js\",\"jh4hi\",\"zh_TW.79a7157d.js\",\"2AL0H\",\"zh.29b1c23a.js\",\"kG8pF\",\"ViewPage.2b375e4f.js\",\"fgAx2\",\"CommentsPanelFilterMenu.dbc857ac.js\",\"2UF2x\",\"FullPageEditorComponent.4921c728.js\",\"hcj2C\",\"FullPageEditorComponent.runtime.ac588851.js\",\"lLK0D\",\"video-pause-overlay.bf3f58b5.js\",\"2F69B\",\"vendors~small-pkgs.17e60a63.js\",\"cBy9y\",\"clipboard.d2ecfccd.js\",\"8gJl0\",\"video-previous-overlay.a5089076.js\",\"lVBal\",\"video-skip-backward-fifteen.7d60ceff.js\",\"7t5Ax\",\"video-skip-forward-fifteen.8c41b0f7.js\",\"2SjHp\",\"ShareRestrictAndCopyCoordinator.9f54d632.js\",\"lk4cE\",\"RequestAccessPopup.1ca8f5e1.js\",\"h4Nf7\",\"ExternalUserLozenge.6c39b83e.js\",\"coJiW\",\"DetailsPanelHeaderIcon.5420753e.js\",\"4mWJk\",\"GrantAccessFlag.2b3c3da8.js\",\"fno6o\",\"RestrictionsDialogMountPoint.95ef0c64.js\",\"inQqk\",\"RestrictionsDialog.75ea06da.js\",\"85liN\",\"InspectPermissionsDialog.138aea72.js\",\"fqBFU\",\"ReverseTrialLozenge.7d7b2a44.js\",\"iQ0Jm\",\"SmartButtonConfigPanel.ab4caeb8.js\",\"aX0L0\",\"InspectPermissionsDialog.2b4283a8.js\",\"dMOc8\",\"projection-screen.1d8acbb5.js\",\"dGk3x\",\"GlobalFeedbackCollector.298f6efb.js\",\"l5XQ1\",\"ViewSpaceExternalCollaboratorsDialog.68f06b80.js\",\"hA2SB\",\"GroupAndUserItem.76f2ec02.js\",\"iHlO3\",\"empty-filter.16dda5ac.svg\",\"9ftJe\",\"schemaLink.62f124b3.js\",\"gryT8\",\"ShareButton.530794ee.js\",\"8Q6ef\",\"GroupAndUserItem.bf222b4b.js\",\"lookM\",\"user-header-for-space-with-guests-Light.1b10bf7d.svg\",\"2GHvs\",\"user-header-for-space-with-guests-Dark.3d8c1f10.svg\",\"iO9O1\",\"personal_space.c63f5733.png\",\"9NxYX\",\"no-restriction-illustration-Light.a376c323.svg\",\"lpZU0\",\"no-restriction-illustration-Dark.8da66227.svg\",\"kgrX3\",\"no-restriction-illustration-pencil-Light.bcc52320.svg\",\"bRk6k\",\"no-restriction-illustration-pencil-Dark.5e6368e9.svg\",\"1DRtS\",\"no-restrictions-illustration-external-share-Light.85b8ab71.svg\",\"hhpRR\",\"no-restrictions-illustration-external-share-Dark.dff9aa3b.svg\",\"69XGw\",\"InspectPermissionsEntryPoint.7021dc29.js\",\"4yUSc\",\"PremiumLozenge.9ebcd3d3.js\",\"ePA5l\",\"Lozenge.bb73c511.js\",\"a8Jk0\",\"RestrictionsDialog.5edddaf9.js\",\"13QWg\",\"in-trial-feature-gates-banner.0a54cccc.js\",\"2VACG\",\"RestrictionsUpsellDialog.42602c34.js\",\"1zoBu\",\"ChangeEditionInlineDialog.18fa643b.js\",\"bfhXH\",\"RestrictionsButton.f2508a2f.js\",\"k28dP\",\"ContentTreeOnboarding.6a86d230.js\",\"4HdA1\",\"ObjectSidebarControl.5a23e600.js\",\"8f3Jd\",\"GlobalComponents.6603384d.js\",\"aIwO0\",\"cs.4a3e185e.js\",\"iwseV\",\"da.ab38deea.js\",\"eh9w8\",\"de.dcda2e59.js\",\"3eWGu\",\"en_GB.923e080c.js\",\"7SsCP\",\"en.d499e0ac.js\",\"8jVst\",\"en_ZZ.a7ccb6b6.js\",\"hNk7k\",\"es.9fe2799a.js\",\"arXo9\",\"fi.01282d54.js\",\"yuLnu\",\"fr.a800602e.js\",\"2pQv8\",\"hu.cc0cce26.js\",\"jGBo1\",\"it.c82fa366.js\",\"eUrwV\",\"ja.56d8bc58.js\",\"2zgDh\",\"ko.209a3e4b.js\",\"bETPT\",\"nb.51eabc92.js\",\"ceBZg\",\"nl.31e2454a.js\",\"5STWe\",\"pl.931ea232.js\",\"EfE3i\",\"pt_BR.9cabcef1.js\",\"hFqXA\",\"ru.8d363b8b.js\",\"4ArgV\",\"sv.4f2f0e25.js\",\"28EDH\",\"tr.86c4c702.js\",\"k3mTs\",\"th.c9644341.js\",\"jJdZ4\",\"uk.9795a380.js\",\"eZRzs\",\"vi.97244230.js\",\"bLQZ9\",\"zh_TW.08d995d9.js\",\"e0E8p\",\"zh.f9c8122a.js\",\"b2zon\",\"loom-cross-join-nudge.f489288b.js\",\"7rE1n\",\"msr-nudges.f3525117.js\",\"eArYP\",\"FullPageEditorComponent.e1cc923c.js\",\"4OKBF\",\"FullPageEditorComponent.runtime.77abd14c.js\",\"ghOf5\",\"EndOfPageRecommendation.19dbfee6.js\",\"boyA1\",\"EndOfPageRecommendation.runtime.4caf0410.js\",\"hcj2C\",\"FullPageEditorComponent.runtime.ac588851.js\",\"4OKBF\",\"FullPageEditorComponent.runtime.77abd14c.js\",\"boyA1\",\"EndOfPageRecommendation.runtime.4caf0410.js\",\"geh8r\",\"AdminNavigation.573d0b01.js\",\"1HAEl\",\"ReverseTrialListItem.982a6431.js\",\"kBLei\",\"PersistentCollapsibleSection.488fcf63.js\",\"dviIw\",\"CollapsibleSection.9219bdfe.js\",\"5E6oP\",\"AutomationOnBoarding.e83dc203.js\",\"1TfYn\",\"AutomationLight.3a471294.png\",\"5ZTDJ\",\"AutomationDark.427f07ad.png\",\"2LUls\",\"ExploreAdminTools.2290887b.js\",\"6folH\",\"ExploreAdminTools.fe44b7b1.js\",\"7RWJk\",\"troubleLoading.cdf95244.png\",\"8s35j\",\"SpaceRolesLozenge.ea76b364.js\",\"4rKYa\",\"person-added.bc078926.js\",\"gRwQ3\",\"cash.f61073db.js\",\"830Zv\",\"HubSettingsNavigation.fee9dc03.js\",\"cD5e0\",\"GlobalNavigationComponent.ebef44f2.js\",\"k7TXX\",\"people-teams.0ada4278.js\",\"9IFUy\",\"team-preview-panel.68578a4a.js\",\"48eS0\",\"cs.0a70d1eb.js\",\"lak6L\",\"da.c7babb2f.js\",\"inCHL\",\"de.cbe7feb8.js\",\"lLx4a\",\"en.e8d1a804.js\",\"auTAr\",\"en_GB.61079520.js\",\"9pxVf\",\"en_ZZ.deff80f1.js\",\"4cEzx\",\"es.612e2fbc.js\",\"iUIL3\",\"et.8f07e723.js\",\"lADZV\",\"fi.7a3ccf21.js\",\"1QHKh\",\"fr.6e11f6ae.js\",\"2Tjcq\",\"hu.f16e562a.js\",\"4WVVc\",\"is.aa3b7b54.js\",\"1QNch\",\"it.a968aca7.js\",\"jQCyA\",\"ja.30766580.js\",\"aQwae\",\"ko.58405243.js\",\"cS1j1\",\"nb.6303b090.js\",\"48pzM\",\"nl.9b8910a0.js\",\"c4a0F\",\"pl.768774fc.js\",\"cBmO4\",\"pt_PT.fb87e247.js\",\"9e3Ob\",\"pt_BR.881d260c.js\",\"7Hoje\",\"ro.6553ad3e.js\",\"4dj0m\",\"ru.3a560477.js\",\"j5HYK\",\"sk.89deb301.js\",\"1VsiM\",\"sv.995d4e94.js\",\"8CqFM\",\"tr.3a5f318f.js\",\"5bAmA\",\"th.1e8306bc.js\",\"i0Evx\",\"uk.3a4c5d55.js\",\"j8OKz\",\"vi.48908404.js\",\"2s1Lz\",\"zh.20bc79bb.js\",\"iI3rq\",\"zh_TW.f90769ea.js\",\"k9ktU\",\"OnboardingNudgeTooltip.f3d07f89.js\",\"h2810\",\"PersistentInvitePeopleButton.21c276bf.js\",\"aGsq7\",\"companyHubItemCallback.2a116980.js\",\"SepNY\",\"analyticsCallbacks.738ed835.js\",\"03cvv\",\"errorWarning.3a015e54.svg\",\"dvjk6\",\"noResultsDark.90199792.svg\",\"57B0v\",\"noResultsLight.5ffcf568.svg\",\"2yM8Y\",\"RecentContentMenu.08463680.js\",\"b3B6t\",\"coffeeChat.72f8b026.svg\",\"dbIft\",\"emptyStarBox.3b01bf42.svg\",\"7JfxY\",\"SpacesDropdown.f0377761.js\",\"kiDFE\",\"CreateSpaceMenuItem.a528101b.js\",\"lWi9V\",\"CreateSpaceMenuItemNav3.e72e6f29.js\",\"3tVyh\",\"CreateSpacePlusButton.93309fc3.js\",\"9jGiN\",\"DiscoverSection.a68f48e9.js\",\"brnyq\",\"miro.cb595030.png\",\"1IPtO\",\"slack.ba8f92ff.png\",\"gSraM\",\"invision.8f2e37e4.png\",\"8b1I3\",\"google-drive.d0028a0e.png\",\"6bVkQ\",\"lucidchart.8807407a.png\",\"kIryJ\",\"NotesMenu.a989f13c.js\",\"j6C8t\",\"notepad.29a984bb.svg\",\"FBIp4\",\"TeamsAppShortcutItem.e627969d.js\",\"borwc\",\"CustomizationModal.a0af12e4.js\",\"6XoCv\",\"grow-vertical.e1a3c29e.js\",\"1VNI4\",\"CustomizeSidebarDialog.b650f439.js\",\"1epse\",\"GuestRequestToUpgradeLearnMoreModal.83655025.js\",\"8Txex\",\"Guest-Avatar.ebdf69f1.svg\",\"2wyTK\",\"Team-Avatars.4f1b07ad.svg\",\"fkeSV\",\"ProjectPanel.55132059.js\",\"81eQE\",\"hashtag.01b327f2.js\",\"3FKNK\",\"LazyTrigger.c52e649e.js\",\"a1VZ3\",\"GlobalNavigationComponent.97fb82e3.js\",\"hmXd6\",\"fileCabinet.17ae0554.svg\",\"17BHA\",\"noResultsDark.90199792.svg\",\"7S3sF\",\"noResultsLight.5ffcf568.svg\",\"aYgZt\",\"SpaceNavigation.bd85a4d2.js\",\"TkY5q\",\"RtPaidFeatureEducationSpotlight.c899705e.js\",\"cJHFd\",\"Nav3SpaceNavigationContent.d62b64c4.js\",\"ltXeo\",\"PageTree.30c902c7.js\",\"4JUnA\",\"BulkDeletePagesAction.22fa35f2.js\",\"kgbtU\",\"BulkDeletePagesAction.9b0321e6.js\",\"anGwD\",\"BulkArchivePagesLoader.0ae0d0ac.js\",\"5Mf2k\",\"BulkArchivePagesLoader.67262623.js\",\"6sAbi\",\"ArchivePageAutomationDiscovery.84e53153.js\",\"gtMen\",\"ShareButton.a4a94975.js\",\"gODOu\",\"RtPaidFeatureEducationSpotlightTarget.ba19a426.js\",\"dkv9z\",\"PageTreeAfterIcon.c4e1a21e.js\",\"9F7vX\",\"CreateContentPopover.bb3a626c.js\",\"BgBDS\",\"Racecar.f378b1ee.svg\",\"dwffN\",\"GlobalCreateContentPopoverMenu.655d377e.js\",\"aDPqY\",\"ContextualCreateContentPopoverMenu.f6b7792a.js\",\"3fgvt\",\"LazyTrigger.8cbe8d85.js\",\"axhR6\",\"AsyncPopupContent.3efe1957.js\",\"fVzkJ\",\"AsyncPopupContent.221e6f03.js\",\"eZu0L\",\"goal.22e1fa66.js\",\"l8LQp\",\"data-number.9bfeb2b4.js\",\"hx3yr\",\"ProfileCard.e95085f5.js\",\"3jf0s\",\"GoalPanel.44f03644.js\",\"9ZnhG\",\"th.3de77e5a.js\",\"4Tiff\",\"uk.2960f49a.js\",\"iz8ME\",\"vi.697a528b.js\",\"1Pok1\",\"key-result.3e2e8c95.js\",\"jtcRz\",\"objective.9e034c80.js\",\"59349\",\"goal.86dfa158.js\",\"46t5f\",\"cs.3cd69e7d.js\",\"1YqfS\",\"da.4e338fd1.js\",\"9DYyx\",\"de.ae190103.js\",\"42ZJx\",\"en_GB.bf004380.js\",\"jtt0C\",\"en_ZZ.58296867.js\",\"3vk3N\",\"es.996fb7af.js\",\"hbGGN\",\"fi.f66c83c2.js\",\"dopc8\",\"fr.a6898161.js\",\"9RJgs\",\"hu.17abd0e0.js\",\"jo6RJ\",\"it.1c621672.js\",\"lKoae\",\"ja.a7d62119.js\",\"1MIK8\",\"ko.119c17e8.js\",\"jh74O\",\"nb.0e4961d0.js\",\"alBoB\",\"nl.242c2e8c.js\",\"fwQyo\",\"pl.d136da0e.js\",\"jnFv5\",\"pt_BR.dfe436c7.js\",\"3wEVm\",\"ru.01beca76.js\",\"1AYDD\",\"sv.92f32ef5.js\",\"503rY\",\"th.c7c05135.js\",\"h5gGf\",\"tr.ed58e9a8.js\",\"kgjXg\",\"uk.d88db2a5.js\",\"jvpmI\",\"vi.234ae9cc.js\",\"8ajSg\",\"zh_TW.bad5c5d0.js\",\"cz5Vg\",\"zh.7df99a04.js\",\"g55vn\",\"team.496d498d.js\",\"jvHRs\",\"team-preview-panel.04032fb3.js\",\"hjuEj\",\"project.80b973c0.js\",\"69G8x\",\"ProjectLinkerGoal.61e49ce0.js\",\"m7vj2\",\"provider.64ae3c34.js\",\"4Mixi\",\"cs.cbb5fe34.js\",\"cjveN\",\"da.835212d1.js\",\"8XGJb\",\"de.a2ec1619.js\",\"hdvZr\",\"en_GB.702092de.js\",\"4ViGN\",\"en_ZZ.bb1eba3d.js\",\"32vlK\",\"es.ac31b31a.js\",\"bjoGV\",\"fi.1e513850.js\",\"8oiz7\",\"fr.6f53d7a9.js\",\"hFxmj\",\"hu.cd9b6b61.js\",\"BXOZB\",\"it.99220f36.js\",\"9Xiuh\",\"ja.cae8a211.js\",\"7Odo3\",\"ko.f8696b38.js\",\"4VkvT\",\"nb.ab9adf1e.js\",\"g5qJV\",\"nl.27391c7e.js\",\"dPa6p\",\"pl.39ca0fea.js\",\"iG4uh\",\"pt_BR.b57aad22.js\",\"9tVE8\",\"ru.65c56da2.js\",\"6UAlo\",\"sv.575cc5b8.js\",\"cs0k1\",\"th.bc465272.js\",\"9Yw4z\",\"tr.fb23115c.js\",\"gce4m\",\"uk.ff4881ca.js\",\"eFwGF\",\"vi.52b3bee6.js\",\"ia9y3\",\"zh_TW.6efc768f.js\",\"15ncj\",\"zh.f634978a.js\",\"hLVzM\",\"suggested-edit.9edafd06.js\",\"k97iL\",\"focus-area.6dcaf5d4.js\",\"5BMnr\",\"calendar-plus.435c4b76.js\",\"4byV5\",\"is-supported.7b27a048.js\",\"lwKXH\",\"is-supported.7a02a63d.js\",\"btYwu\",\"esm.990961ac.js\",\"wIOhQ\",\"esm.f6c7f163.js\",\"9LQGG\",\"close.f1edfb26.js\",\"4drdS\",\"paint-palette.52c44fbd.js\",\"xvDzM\",\"success.1bcc5fc4.js\",\"fwwpP\",\"LazyTrigger.9dcdd982.js\",\"4XUbE\",\"universal-create.0a530493.js\",\"h2QhJ\",\"team-preview-panel.7b12335d.js\",\"3gnID\",\"CommentEditor.9eff7418.js\",\"np2ZB\",\"NonMasteredUserModal.8d80d21c.js\",\"j2eUy\",\"nonMasteredUserModalSplashImage.90ba8397.svg\",\"hq1Iv\",\"masteringFlowSplashImage.1f9bd0cc.svg\",\"daoWf\",\"LoomCrossSellPopupCardImage.6e60c328.png\",\"c0kqt\",\"TreeBottomCreateButton.1f57b905.js\",\"4Dabn\",\"ContextualCreateContentPopoverMenu.e67cf10d.js\",\"277qv\",\"ContextualCreateContentPopoverMenu.f536dc57.js\",\"3OZOS\",\"database.2a5a6e18.gif\",\"jDLf6\",\"folder_space.4db7be29.gif\",\"nLzCZ\",\"live_page.21be0d2b.gif\",\"4kpzK\",\"loom.4e5a8d5b.gif\",\"gfw8L\",\"page.cc74cd19.gif\",\"8p9Qn\",\"smart_link.98982781.gif\",\"4SZ7J\",\"whiteboards.caa514dd.gif\",\"iw0Pi\",\"ai.853086d4.gif\",\"bxW4e\",\"blueBar.ae629b00.svg\",\"6LpHZ\",\"greenBar.869cd775.svg\",\"ePdd1\",\"orangeBar.96a843e1.svg\",\"53OS2\",\"purpleBar.40dceaa5.svg\",\"h4qu8\",\"LiveDocsIntroGif.d2fc0787.gif\",\"j7hKO\",\"LiveDocIntroGADark.45e6357d.svg\",\"7yu5V\",\"LiveDocIntroGALight.8a32f41a.svg\",\"5TJ4V\",\"WhiteboardExperimentSpotlightImage.49c94c1b.svg\",\"iUB8p\",\"WhiteboardsPaywall.cf2c63af.svg\",\"1TlSS\",\"WhiteboardsPaywallDark.0948bce6.svg\",\"eJgN2\",\"WhiteboardsPaywallV2.5dd554e3.svg\",\"dk0NC\",\"WhiteboardsPaywallDarkV2.e9c25635.svg\",\"ipnbL\",\"createSpotlightImage.f64dc988.png\",\"brItY\",\"CreateWithRovoSpotlightAnimationDark.886221cf.gif\",\"jb5iT\",\"CreateWithRovoSpotlightAnimationLight.1a1df728.gif\",\"igneX\",\"ContextualCreateContentPopoverMenu.e19a5965.js\",\"clpSH\",\"PageTreeQuickActions.f543f845.js\",\"13PnU\",\"QuickActionsContent.8bd9ea4f.js\",\"bunf9\",\"Controller.372c0125.js\",\"764nc\",\"tooltip.39ce4f8b.js\",\"faXeM\",\"main.d10cc8b8.js\",\"7eOUa\",\"main.44c69f94.js\",\"9zjWJ\",\"main.ff019889.js\",\"cwwPf\",\"main.bcd96707.js\",\"3a4K1\",\"main.4069a580.js\",\"9J4KV\",\"cs.e0391d14.js\",\"8Y9JE\",\"da.c3314acc.js\",\"gWrRN\",\"de.2a16c293.js\",\"irKcy\",\"en.c4a4d260.js\",\"1aghR\",\"en_GB.f18e5ee2.js\",\"3jFnE\",\"en_ZZ.6852c493.js\",\"11Khz\",\"es.d1f41c39.js\",\"ap0LY\",\"et.e75ca3b6.js\",\"34Ma8\",\"fi.41faaf30.js\",\"lBwDa\",\"fr.67006757.js\",\"32Pvr\",\"hu.7ab434e7.js\",\"b7bFd\",\"is.d9772209.js\",\"6h8Ae\",\"it.aa86f8b6.js\",\"dW8Ws\",\"ja.5a53ae26.js\",\"fJZdm\",\"ko.b6ef3ae3.js\",\"kfTIE\",\"nb.e6a92d12.js\",\"b8M9e\",\"nl.4222c63b.js\",\"jMchi\",\"pl.3a4a5229.js\",\"2xsmF\",\"pt_BR.a00a089e.js\",\"hHyCx\",\"pt_PT.77e6008a.js\",\"gw4Pw\",\"ro.7a5f0e93.js\",\"8rhcn\",\"ru.95e5dfbb.js\",\"fh5Vk\",\"sk.173f2352.js\",\"aP4eD\",\"sv.d938fa31.js\",\"aJWAE\",\"th.40f721af.js\",\"b96A2\",\"tr.45563d42.js\",\"g0ukK\",\"uk.afa37c97.js\",\"8DuKk\",\"vi.4cc4334b.js\",\"5aSRq\",\"zh_TW.c563908f.js\",\"eQT38\",\"zh.a3dd97ca.js\",\"fYFVU\",\"UpflowV2ExperimentErrorBoundary.6e3bd6f8.js\",\"iWKl1\",\"ScheduledStatus.3a7bdd1e.js\",\"jYr96\",\"DraftStatus.c886c69b.js\",\"4opMD\",\"ShareRestrictAndCopyCoordinator.b5e21fec.js\",\"hKgit\",\"ShareNudgeSpotlight.f77e8517.js\",\"c4Kdp\",\"GeneralAccessLevelSelector.99b2939f.js\",\"k0hwN\",\"ShareToSlack.e5577eee.js\",\"lVO4z\",\"cs.66d17b1d.js\",\"2FVbf\",\"da.45f5bf76.js\",\"ljo6M\",\"de.87ff8d2a.js\",\"8d6ia\",\"es.44f7b6ae.js\",\"jh8UJ\",\"fi.bd46bce1.js\",\"bYwCr\",\"fr.854524fc.js\",\"11NiT\",\"hu.21eb6dc5.js\",\"le8VA\",\"it.111da4a0.js\",\"1beJ2\",\"ja.25f13916.js\",\"1tXCh\",\"ko.c7b3c730.js\",\"jzP8g\",\"nb.6ab8a8d0.js\",\"dJY66\",\"nl.b11fd7f9.js\",\"4foYW\",\"pl.200ddf23.js\",\"j0yc3\",\"pt_BR.3fad7d31.js\",\"RfEmw\",\"ru.64b44490.js\",\"5DOlG\",\"sv.812498a9.js\",\"6rD7n\",\"tr.6280d059.js\",\"1e62a\",\"th.646e04f8.js\",\"eLsCU\",\"uk.87a103d8.js\",\"g9qHs\",\"vi.352e605d.js\",\"2ri5s\",\"zh_TW.40e2425f.js\",\"3k60n\",\"zh.af15c051.js\",\"hxIYN\",\"integration-primer.cead19d9.svg\",\"5oKDR\",\"disabled-alert.0ba0a4e5.svg\",\"8LPnw\",\"lock-locked--lock-filled.572a51f5.js\",\"8Yk54\",\"DarkEmptyState.b237e8cb.png\",\"dEQI1\",\"LightEmptyState.1b72e55d.png\",\"2i7Iv\",\"DarkError.d13c9c5b.png\",\"17ygR\",\"LightError.5b516166.png\",\"6Wmon\",\"step-one.dcc386c3.svg\",\"lV4Df\",\"step-two.cd055733.svg\",\"i8Yee\",\"ViewPageDistinctionBanner.a713e36e.js\",\"jhTmh\",\"CommentsPanelFilterMenu.6ebbca8b.js\",\"e4GNb\",\"CommentEditor.156eedfd.js\",\"e9JE4\",\"CommentEditor.runtime.3b3b57ee.js\",\"5coOi\",\"MainButtons.34d13a72.js\",\"e9JE4\",\"CommentEditor.runtime.3b3b57ee.js\",\"36rXN\",\"MovePageDialog.fe3b4830.js\",\"6FaFk\",\"ContentTreeSearchStates.029a9c8b.js\",\"7ZHrh\",\"SearchNoResultLight.8777776b.svg\",\"gaG2b\",\"SearchNoResultDark.50b7a17f.svg\",\"PNyg1\",\"InlineRename.8c8d2ae8.js\",\"5zDuS\",\"NativeCollabComponent.4927f428.js\",\"lVcuZ\",\"MovePageDialog.b1db0aff.js\",\"3L1uC\",\"PageTreeErrorComponent.13e06b8a.js\",\"ewwba\",\"PageTreeEmptyComponent.4582c5e8.js\",\"dhqJV\",\"FooterCreateButtons.77abdfdb.js\",\"67Pvd\",\"ContentTreeOnboarding.c987dcbe.js\",\"e19Zv\",\"LiveDocsIconTile.a288ac56.js\",\"d1QkY\",\"TreeBottomCreateButton.caeedd78.js\",\"f9QHk\",\"TreeMonitor.bef0ea8b.js\",\"fnoJZ\",\"HomepageIcon.12230327.js\",\"6gau7\",\"DraftLozenge.6442dab1.js\",\"5ppK3\",\"MovePageDialog.1dd0edaa.js\",\"cPaXL\",\"ArchiveUpsellDialog.918f9077.js\",\"3uux1\",\"ArchivePagesLoader.319eda4a.js\",\"8qpSy\",\"ErrorSectionMessage.d7f6df04.js\",\"i5EJc\",\"ErrorComponent.b6468536.js\",\"2wJza\",\"ErrorGraphic.784b3ce3.svg\",\"1u9sS\",\"ArchivePagesLoader.201e83ec.js\",\"in6Mc\",\"NoChildrenBullet.00ba4557.js\",\"9QyoN\",\"PageQuickActionAutomationMenu.0cb4bed1.js\",\"kSBog\",\"PageQuickActionAutomationMenu.aa31b978.js\",\"cDlXo\",\"cs.bb7b2398.js\",\"aGqxI\",\"da.2f2eb656.js\",\"8DMgV\",\"de.d2d66f21.js\",\"3lwWF\",\"en_GB.ef04196d.js\",\"6n44e\",\"en_ZZ.0706863b.js\",\"i2lSs\",\"es.cfb981b6.js\",\"cddHY\",\"fi.b34be9f5.js\",\"2nFnK\",\"fr.9414a49e.js\",\"iMEy4\",\"hu.19dd1006.js\",\"79NWg\",\"it.5b76b6c9.js\",\"dn37Z\",\"ja.198e5ad1.js\",\"2y34H\",\"ko.a4730b26.js\",\"g8Vga\",\"nb.256e2e51.js\",\"fw5Rx\",\"nl.7df68bde.js\",\"cqxYX\",\"pl.48257922.js\",\"3Wq1f\",\"pt_BR.b0cab9c2.js\",\"ePmaE\",\"ru.f24df80d.js\",\"2PbJR\",\"sv.9362d1ff.js\",\"04oVB\",\"tr.2426a00f.js\",\"7lf25\",\"zh_TW.3e778977.js\",\"csVFP\",\"zh.453474a1.js\",\"kCTMZ\",\"PageQuickActionAutomationMenu.433c6c0b.js\",\"aOpoD\",\"empty-automation-list.9c7d0496.png\",\"awXdT\",\"error.b6351f9e.svg\",\"9YGIy\",\"DeleteNestedPagesAction.8739e0b7.js\",\"iomzR\",\"DeletePageDialog.d723748d.js\",\"p4ay7\",\"CopyPageTreeContainer.daf6ad02.js\",\"aiU5r\",\"CopyPageDialogContainer.711888a6.js\",\"aoUod\",\"MoveBlogModal.c7a9a459.js\",\"getgv\",\"QuickActionsContent.2f95a00c.js\",\"3TTZL\",\"panel.622cd19d.js\",\"kyxdN\",\"EditSpaceLogo.64684fe0.js\",\"gRwHT\",\"EditSpaceLogoComponent.fa98c356.js\",\"7t2Ec\",\"EditSpaceLogoGallery.83c03e48.js\",\"860dT\",\"SpaceHeaderExCoOnboarding.14925977.js\",\"9H1r6\",\"GraphBarIcon.91bdab17.js\",\"19Ali\",\"GridIcon.647248a8.js\",\"hI11K\",\"AutomationNavigation.6e1a5fdb.js\",\"4skpM\",\"AutomationChangeBoarding.1c13c617.js\",\"8xPy6\",\"SmartButtonIllustration.b4b7c8dc.png\",\"fbDZw\",\"QuestionsNavigation.8fcd195e.js\",\"c0OU0\",\"QuestionsIcon.b4cd7a81.js\",\"7Qxu7\",\"TeamCalendarNavigation.aafc7a91.js\",\"aZ9pO\",\"CalendarIcon.2ae1c62b.js\",\"5DqrE\",\"BulkToolsNavigation.70589864.js\",\"hHrTM\",\"edit-bulk.40121784.js\",\"klGUa\",\"ErrorView.a9931933.js\",\"j0beU\",\"EyeStrike.801ddb27.svg\",\"eWlhh\",\"Nav3SpaceApps.e7d49d06.js\",\"hs6o8\",\"SpaceAppsConfiguration.eaf1afae.js\",\"6vEb6\",\"PageLayout.0af6849f.js\",\"cIHDc\",\"PageLayout.7908369c.js\",\"4shpn\",\"PageLayout.runtime.2ab0ff73.js\",\"kDPsc\",\"render.1e69d210.js\",\"jdjSr\",\"render.f9adf4d7.js\",\"j4CTh\",\"tasks.4e573bd1.js\",\"1zcLV\",\"PageLayout.70e9c763.js\",\"iTImB\",\"heart.91f6fb22.svg\",\"bl22g\",\"notes.c9738615.png\",\"dAcu4\",\"ai-notes-icon.f866806e.svg\",\"lguNj\",\"chrome-icon.40414d4b.svg\",\"c4pCE\",\"rovo-icon.a638efdd.svg\",\"7ikjZ\",\"Nav3SpaceNavigationContent.907e3314.js\",\"1NnjK\",\"ShortcutsSection.b57fdc9e.js\",\"aBvTF\",\"ShortcutsDragContainer.5c063dcb.js\",\"kDqHr\",\"file-icon.22bc916f.js\",\"4HZlX\",\"chart-bar-icon.df50cf8f.js\",\"7jSfd\",\"list-bullet-icon.cb0c6e79.js\",\"jg5LT\",\"root-component.78049ca5.js\",\"5TCys\",\"SpaceViews.5945bf13.js\",\"aCG0y\",\"SpaceViewsErrors.5977aa38.js\",\"5qLBt\",\"SearchNoResultLight.8777776b.svg\",\"6KUsM\",\"SearchNoResultDark.50b7a17f.svg\",\"1TYNY\",\"SpaceViewsCurrentViewIndicator.567597fe.js\",\"guX1n\",\"ViewMoreButton.a28c4578.js\",\"kJLy8\",\"SpaceViewsList.9a0e23c8.js\",\"6gmSt\",\"PagesItemActions.a8902762.js\",\"3HpiM\",\"BulkActionsChangeboardingSpotlightInner.08d8c2f1.js\",\"3YKnT\",\"bulkActionsChangeboardingSpotlightImage.9c36fbc8.svg\",\"fC3D2\",\"SpaceViewsMenu.46f082c1.js\",\"cWvhX\",\"PageOwnershipByLineWithContributorsDropdownContent.4cde6701.js\",\"eQlG4\",\"ContentTreeSearch.e20e316f.js\",\"cQVtz\",\"SpaceHoverPageCard.8d04cf2e.js\",\"gLGsg\",\"FullPageEditorComponent.36b7777b.js\",\"hDNUK\",\"BlogTree.97bf3af5.js\",\"lnCW7\",\"ExternalCollaboratorInSpaceNotify.b3f7f319.js\",\"7Ni3R\",\"GuestOnboardingModal.b29bb06e.js\",\"WYAWv\",\"Guest-Onboarding-Light.8e788fbd.svg\",\"4rpM2\",\"Guest-Onboarding-Dark.f055cab3.svg\",\"4shpn\",\"PageLayout.runtime.2ab0ff73.js\",\"hFtKc\",\"SpaceNavigationContent.efd3f474.js\",\"c08ou\",\"CalendarsLink.189bb69b.js\",\"8uhuz\",\"QuestionsLink.7672f4bf.js\",\"kZjBp\",\"SpaceApps.ed191c9a.js\",\"e2ujj\",\"eye-open-filled.c4b25411.js\",\"6jw5Q\",\"chart-trend.1489503f.js\",\"jDLw3\",\"EnhanceOrientationTourNudge.b90aeefc.js\",\"dZAAu\",\"LocationPin.05f180e4.svg\",\"6XW9D\",\"Celebration.a5529ebd.svg\",\"4vd0S\",\"NavigationBanner.bca72c9b.js\",\"h4AS7\",\"EditionsIcon.5b4a5733.svg\",\"fSc0b\",\"Nav4CollapseReminderSpotlight.2efa3ca4.js\",\"3WCRn\",\"NewKeyboardShortcutsDialog.e5d203a6.js\",\"4AAsh\",\"AddPersonalSpaceDialog.5272758f.js\",\"cbb8R\",\"megaphone.ea49a10b.svg\",\"7enLt\",\"clipboard.6bbe40ee.svg\",\"irkOO\",\"nameTag.1bdcf89f.svg\",\"8H6xE\",\"EditionAwareness.7f48d46e.js\",\"1AVLS\",\"automation-free-limit-modal.ef09b302.js\",\"1Bzn5\",\"breached-icon-dark-mode.c76c5af4.svg\",\"4li5B\",\"breached-icon.604210d1.svg\",\"5Hb8k\",\"gestural-line-dark-mode.0238cd16.svg\",\"fKxeV\",\"gestural-line.c0eb7c9f.svg\",\"7REXs\",\"automation-danger-icon.9e7c0e3a.svg\",\"7NqPm\",\"automation-warning-icon.0d3ef917.svg\",\"fjOTL\",\"person-add.2ade7731.js\",\"aMOuo\",\"collection-add-payment-details-popup.ab8f0e61.js\",\"9gHNl\",\"twc-popup-background-dark.0f701da2.svg\",\"2l8ah\",\"twc-popup-background-light.30b1cc68.svg\",\"b02wj\",\"credit-card--creditcard.1e46df2b.js\",\"99wAt\",\"collection-change-plan-popup.e5c79eb1.js\",\"48HMF\",\"clock--recent.d917c73b.js\",\"4I0kP\",\"end-user-request-modal.2ad575b7.js\",\"8kpTd\",\"visual-dark.589bc948.png\",\"aPOi6\",\"visual-light.1c3bfa82.png\",\"dGvEg\",\"feature-onboarding-modal.43e9a9ac.js\",\"39fCS\",\"background-dark.a3b81b65.svg\",\"hlyBg\",\"background.335ae0da.svg\",\"ltJpU\",\"blue-box.4faddac8.svg\",\"lq3Sl\",\"free-choose-your-edition-modal.c56e3759.js\",\"iI6Q4\",\"free-to-standard-modal.765a4640.js\",\"2zp5o\",\"background-dark.46d9946a.svg\",\"eGZ7X\",\"background-light.c76a8e81.svg\",\"2kbQr\",\"discovery-background-dark.73b58e40.svg\",\"8LjMq\",\"discovery-background-light.e5db6720.svg\",\"7qqQA\",\"gestural-line-dark.5fb5d96c.svg\",\"jmfnZ\",\"gestural-line.8591d4ac.svg\",\"jr06u\",\"jsw-add-people.17946c9a.svg\",\"jTG5T\",\"jsw-increased-storage-limits.b8a08bb1.svg\",\"iNU7h\",\"increased-storage-limits.a7321574.svg\",\"15Vzp\",\"unlimited-creators.3de71904.svg\",\"i0M9R\",\"help-desk-attachments-darkmode.a8bd959e.svg\",\"9zK71\",\"help-desk-attachments.138601ac.svg\",\"2hde5\",\"jsm-service-collection-add-people-darkmode.290a8179.svg\",\"j99t9\",\"jsm-service-collection-add-people.8f940b7d.svg\",\"anVlQ\",\"jsm-increased-storage-limits.21bb9c1c.svg\",\"cYQGZ\",\"unlimited-agents.743019a8.svg\",\"7jH9e\",\"location.6c7fcf6a.js\",\"1B0KU\",\"lock-unlocked--unlock.75fcd67e.js\",\"aE4di\",\"phone.b88e8f90.js\",\"1D15t\",\"free-to-standard-refresh-modal.42ebab10.js\",\"de9xI\",\"background-light.c5aca943.svg\",\"mSvEe\",\"gestural-line-star-4.7814368e.svg\",\"gctwz\",\"shield.3f7ae2d2.js\",\"aKXvR\",\"payment-details-popup.e8e325f3.js\",\"kwFai\",\"background.b3afa1bc.svg\",\"cDKlY\",\"plan-selection-page-modal.c178b9bf.js\",\"4JtX7\",\"premium-add-payment-modal.aa9cfd52.js\",\"ki3nq\",\"premium-popup.c85b848c.js\",\"czatF\",\"premiumPopupHeader-Dark.8772bafb.svg\",\"8oiny\",\"premiumPopupHeader-Light.587e53c0.svg\",\"7YE3I\",\"reverse-trial-popup.52da7bab.js\",\"iFA9H\",\"special-offer-sixty-modal.90782f63.js\",\"3KKo2\",\"background.cfd6bca5.svg\",\"1j7i8\",\"gestural-line-signal-4.2ed74c75.svg\",\"abLmz\",\"gestural-line-star-4.7814368e.svg\",\"kyUks\",\"radio-unchecked.a80b0bc5.js\",\"3opZo\",\"radio-checked.bfe4f2a4.js\",\"eCMUX\",\"standard-add-payment-modal.9c584d44.js\",\"lmoGI\",\"confluence-add-people.95d7cd0c.png\",\"1JrC5\",\"confluence-guest-access.0a003025.png\",\"cfLGc\",\"confluence-page-insights.548fcd17.png\",\"3DLtA\",\"confluence-page-restrictions.6ddf91dd.png\",\"dp0gI\",\"attachments.a7321574.svg\",\"7XFVr\",\"help-desk-attachements.21bb9c1c.svg\",\"7RlGN\",\"jpd-add-people.3de71904.svg\",\"4jaDc\",\"jsm-add-people.743019a8.svg\",\"kVhCr\",\"jsw-add-people.17946c9a.svg\",\"ksfeV\",\"standard-trial-limit-breakers-modal.6318895c.js\",\"ifjlX\",\"background-dark.46d9946a.svg\",\"2fSYt\",\"background-light.c76a8e81.svg\",\"iJmYl\",\"discovery-background-dark.73b58e40.svg\",\"awCda\",\"discovery-background-light.e5db6720.svg\",\"bYCBI\",\"gestural-line-dark.5fb5d96c.svg\",\"hW47h\",\"gestural-line.8591d4ac.svg\",\"lLln8\",\"storage-hard-limit-modal.1bc39c34.js\",\"aCxGF\",\"storage-limit-breached-icon-dark-mode.c76c5af4.svg\",\"9WLSk\",\"storage-limit-breached-icon.604210d1.svg\",\"7hYpO\",\"storage-limit-danger-icon.9e7c0e3a.svg\",\"60S8F\",\"PremiumTrialOnboardingSpotlight.1beff867.js\",\"dTz74\",\"RtNeutralMessagingSuppressComponentsHoc.9790f54e.js\",\"d5wRy\",\"Spotlight-pto2-dark.d9bc480a.svg\",\"fZEhl\",\"Spotlight-pto2-light.bfab086d.svg\",\"5CaYW\",\"video-play.924440ef.js\",\"2OWSd\",\"PremiumOnboarding.9373cbc5.js\",\"78YgQ\",\"Illustration.bc0cbd7b.svg\",\"bKgRA\",\"Illustration.bc0cbd7b.svg\",\"kNFat\",\"ImpersonationFlag.08015697.js\",\"8Gekp\",\"sha256SimpleHasher.1fd3f520.js\",\"fhU7k\",\"esm.fe46a0d0.js\",\"dChec\",\"spotlight.b6e81038.js\",\"gMWRW\",\"PageLayout.ac9a9592.js\",\"6tsCm\",\"ContentTypesHeader.9f6d5305.js\",\"b6JBs\",\"CompanyHubBreadcrumbs.0bf11451.js\",\"lpcEN\",\"ChangeHubNameDialog.a0bae2e8.js\",\"70fET\",\"hub-hero-image.d6790ccb.png\",\"1GyAj\",\"BreadcrumbsDropdownContent.1b83460d.js\",\"hHYS0\",\"ModernizedBreadcrumbsIndentIcon.7708ddee.js\",\"9mtZC\",\"PageLayout.0da799d4.js\",\"cvXSy\",\"RightPanel.d6d86411.js\",\"aoJPa\",\"main.24ea107b.js\",\"a0ybh\",\"SmartCreateFeedbackBanner.6a6a4e24.js\",\"iOFzT\",\"HelpPanel.d790f268.js\",\"b3xzh\",\"LICENSES.a49f223c.js\",\"j2bbk\",\"flask.4abe7595.js\",\"1Qnbg\",\"device-mobile.e5585656.js\",\"llPKJ\",\"lightbulb.f6b5fe08.js\",\"9mBQe\",\"feed.e134a1f8.js\",\"jSJrn\",\"eye-open--watch.f3840828.js\",\"c2Cby\",\"NotesSidebar.f9bc0695.js\",\"1nKqs\",\"NotesModal.273c9db9.js\",\"7149U\",\"Arrow-Image.65dd605e.svg\",\"j0sJu\",\"NoResultsImage.d0ce8889.svg\",\"6M36W\",\"CommentsPanelFilterMenu.eba4f139.js\",\"5CdWD\",\"embedCard.c016bf33.js\",\"1Bh2o\",\"inlineCard.cbfda0c1.js\",\"h9Ed7\",\"ProjectPanel.623011ef.js\",\"4cER0\",\"FullPageEditorComponent.ff76848b.js\",\"iY2SX\",\"FullPageEditorComponent.runtime.504daec3.js\",\"assPZ\",\"GoalPanel.ffeab420.js\",\"9H9aT\",\"bodiedSyncedBlock.a7ac0b46.js\",\"87Teh\",\"syncedBlock.0876502b.js\",\"kFrh6\",\"NotesSidebar.3b29e74e.js\",\"O3OZ0\",\"TableOfContents.a2d0db3c.js\",\"iY2SX\",\"FullPageEditorComponent.runtime.504daec3.js\",\"9ijrN\",\"modal.7b6f1fce.js\",\"tKhaz\",\"CommentEditor.bada33e3.js\",\"dclpt\",\"CommentEditor.b4390421.js\",\"1Jgsw\",\"FullPageEditorComponent.ea54ab24.js\",\"gmzZ6\",\"FullPageEditorComponent.33dc0280.js\",\"6Nsud\",\"PageContentRendererFabric.384acc8f.js\",\"1g7tp\",\"EditorComponent.e443db6a.js\",\"g5HUX\",\"EditorComponent.2f493c91.js\",\"8dYdP\",\"BranchDeployLogo.766bd5ee.js\",\"beF0E\",\"formatRelative.6270d915.js\",\"bkswC\",\"FeatureFlagLogo.3a98c0b9.js\",\"5j5Dl\",\"NotificationsContent.03cb0100.js\",\"bCr24\",\"main.25074bcc.js\",\"lp0cK\",\"both-splash.465c87c4.svg\",\"bo7LK\",\"teams-splash.36cc0781.svg\",\"8XHrw\",\"slack-splash.73e116f6.svg\",\"dxwAu\",\"emoji-add.daa0891c.js\",\"lCT7Q\",\"GoalPanel.53b3f41d.js\",\"aCjO7\",\"NotificationsContent.4e613ab7.js\",\"8jKp2\",\"main.c0c19225.js\",\"6xBPW\",\"toolbox-background.8cac0d99.svg\",\"cqJPj\",\"cs.f13ec029.js\",\"k8s3i\",\"da.4e35a524.js\",\"4wXhf\",\"de.a2bc61ae.js\",\"6tXZg\",\"es.7d8b4b59.js\",\"ktJwC\",\"fi.22ac2c85.js\",\"7mgkS\",\"fr.ee2905d4.js\",\"fWDE2\",\"hu.33549323.js\",\"b2OUm\",\"it.c36cfe38.js\",\"9PhiM\",\"ja.820fabd6.js\",\"4d3pr\",\"ko.e0e91139.js\",\"duoZ2\",\"nb.cd2ae6ec.js\",\"7JbfU\",\"nl.60ca1efa.js\",\"k9Hsp\",\"pl.5dfa7111.js\",\"dNbgl\",\"pt_BR.9cb9b72b.js\",\"53dLt\",\"ru.1df08e33.js\",\"dCa0R\",\"sv.89aedbdb.js\",\"dR545\",\"tr.d04aa5f9.js\",\"gIlXN\",\"th.0850867f.js\",\"ktxue\",\"uk.9deaceaa.js\",\"db0Tb\",\"vi.de756b2f.js\",\"cknqz\",\"zh_TW.65d91506.js\",\"8XnIU\",\"zh.77172dfb.js\",\"44Ne1\",\"main.479758da.js\",\"bZ7A8\",\"main.5cb80322.js\",\"bP7LP\",\"check-circle--check-circle-outline.d7572606.js\",\"52WuW\",\"show-more-vertical--more-vertical.3fff291a.js\",\"3xuDK\",\"show-more-vertical.91054f89.js\",\"5Qjce\",\"shortcut-pro-tip.65d378ae.js\",\"3VL8p\",\"arrow-down.5455dd41.js\",\"j5Z6Q\",\"main.9340f859.js\",\"eFvBU\",\"generic-error.74ae12d9.js\",\"19qJC\",\"avatar-group.f7644992.js\",\"brzrr\",\"main.0bfb80e8.js\",\"kTdzk\",\"ObjectSidebarControl.679eb767.js\",\"8Z2Eu\",\"main.70d6b01d.js\",\"1y1ll\",\"main.870d36cb.js\",\"eYBaa\",\"main.4e8214d6.js\",\"fzXjm\",\"QuickReload.eeab7cba.js\",\"aJ5As\",\"main.34f221e9.js\",\"27Dzv\",\"dark-mode.c2768bcf.svg\",\"1gUFj\",\"light-mode.e7c3914f.svg\",\"8s2Uo\",\"match-browser.a2bb9bea.svg\",\"49f46\",\"cs.077e9f4c.js\",\"jQPB7\",\"cs_CZ.02a4f979.js\",\"88bR1\",\"da.f100d419.js\",\"bwD1u\",\"da_DK.87972b77.js\",\"85kOD\",\"de.1d9843a9.js\",\"R2BG5\",\"de_DE.c262d848.js\",\"2goda\",\"en_GB.dbcbc037.js\",\"gjxqp\",\"en_ZZ.44473633.js\",\"1S2jF\",\"es.c17cb0b0.js\",\"eERmJ\",\"fi.4fa64611.js\",\"8rk64\",\"fi_FI.3920d863.js\",\"bpktO\",\"fr.903b8e7a.js\",\"aC2ty\",\"fr_FR.55477104.js\",\"lmJBr\",\"hu.531afc04.js\",\"lVBNt\",\"hu_HU.482ed985.js\",\"lnHpS\",\"it.87f71de5.js\",\"kEBAh\",\"it_IT.6068682f.js\",\"3ZAy1\",\"ja.94bc339c.js\",\"fDXOw\",\"ja_JP.b9c5af46.js\",\"45dhs\",\"ko.1eee672d.js\",\"grGen\",\"ko_KR.2eefe595.js\",\"4iqE9\",\"nb.2f604276.js\",\"bAyJY\",\"nb_NO.0e1c1672.js\",\"51EOq\",\"nl.6cc51681.js\",\"d5GjE\",\"nl_NL.36ecf941.js\",\"4ILPZ\",\"pl.1d15f5b3.js\",\"6QVYs\",\"pl_PL.4b70058e.js\",\"7HuII\",\"pt_BR.2b035f6a.js\",\"iYxvq\",\"ru.c3f08be2.js\",\"8kHli\",\"ru_RU.b5aa2be7.js\",\"dqRWB\",\"sv.937a087d.js\",\"bYWK5\",\"sv_SE.708683d2.js\",\"k0u9s\",\"th.1046cb5c.js\",\"imObn\",\"th_TH.951654d3.js\",\"chSc4\",\"tr.c7d5b86f.js\",\"dfeY8\",\"tr_TR.38e54197.js\",\"fvaoj\",\"uk.628c902d.js\",\"lT1ej\",\"uk_UA.7f80708f.js\",\"8OH5J\",\"vi.60bec7b2.js\",\"hV9Rr\",\"vi_VN.3f64294f.js\",\"k4zbq\",\"zh.74d31329.js\",\"1cNBX\",\"zh_CN.2e8ebc6e.js\",\"ii6TT\",\"zh_TW.222165d8.js\",\"4YwES\",\"PageLayout.9084f86c.js\",\"gM13h\",\"navBarButton.f3904f4d.js\",\"1aPQ5\",\"PageLayout.23ae9f6c.js\",\"6XyGC\",\"atlassian-switcher.4c93988a.js\",\"4NUCi\",\"cs.8ebee097.js\",\"cSX69\",\"da.231e3a08.js\",\"deZYh\",\"de.cf1b862d.js\",\"kU59n\",\"en_GB.86c05959.js\",\"1L3Og\",\"en_ZZ.f8d04e24.js\",\"6HKYn\",\"en.cf43cad0.js\",\"UHyLS\",\"es.91313863.js\",\"7jCUc\",\"et.1dd8203e.js\",\"jq5xm\",\"fi.bd97b000.js\",\"anfIJ\",\"fr.b2a9702c.js\",\"369Q4\",\"hu.8c305237.js\",\"1vaU3\",\"is.5d4b1a56.js\",\"23Iwb\",\"it.ecc65d29.js\",\"fFLzH\",\"ja.d0121fc7.js\",\"hVd5u\",\"ko.55a5744e.js\",\"lz5E6\",\"nb.2ab27b18.js\",\"bdV9c\",\"nl.cf9096f6.js\",\"eDHUW\",\"pl.96ae55ca.js\",\"RmhvD\",\"pt_BR.0c7c7669.js\",\"dAgm7\",\"pt_PT.fb4e7968.js\",\"f7XN4\",\"ro.17474067.js\",\"bA1DV\",\"ru.6714ef7c.js\",\"5Zouf\",\"sk.a983b13a.js\",\"f6c6x\",\"sv.b4fb6c92.js\",\"6VL5F\",\"th.2f11e26c.js\",\"9zarI\",\"tr.f399af48.js\",\"gtgoF\",\"uk.8db7671e.js\",\"kkSDy\",\"vi.02bc865d.js\",\"fgDwh\",\"zh_TW.7903df54.js\",\"j25uO\",\"zh.c83667eb.js\",\"5VdYb\",\"PageLayout.7a300b76.js\",\"2PUw9\",\"robot-error.9b710643.js\",\"98wVx\",\"atlassian-switcher.ddc6d80f.js\",\"5dGIX\",\"animation-illustration.ceb03cfe.js\",\"a3B2V\",\"jira-switcher.71104dbc.js\",\"9B1r0\",\"confluence-switcher.01643cc3.js\",\"kgItH\",\"generic-switcher.cde8976e.js\",\"fgH74\",\"PageLayout.57c883b1.js\",\"6m2wP\",\"render.db5b1629.js\",\"8gQKz\",\"render.4443e9af.js\",\"gopxm\",\"render.fc34ce07.js\",\"9N316\",\"render.8d9c88ea.js\",\"603iI\",\"render.f4831d1b.js\",\"dVwBo\",\"render.8192d1cd.js\",\"ipxYo\",\"render.d40d5537.js\",\"l37ax\",\"render.b272300f.js\",\"ntv3W\",\"render.bd1b77b2.js\",\"1b5ye\",\"render.1473f5cc.js\",\"lXsOU\",\"render.c31c8356.js\",\"8Y9rK\",\"welcome-animation-light.91126d70.js\",\"l1BtG\",\"welcome-animation-dark.09187bd2.js\",\"eBicT\",\"twc.f376f02d.svg\",\"5IgYU\",\"esm.c50fdd21.js\",\"lKcQU\",\"render.673c14ea.js\",\"dUS4r\",\"confirmationBackgroundV2.dark.7c389c39.png\",\"6bGHk\",\"confirmationBackgroundV2.light.74baa5b8.png\",\"ksf6H\",\"confirmationVisual.dark.3beace2d.svg\",\"6H1xs\",\"confirmationVisual.light.4c2dbe9e.svg\",\"f0hWS\",\"teamworkCollectionHeaderV2.dark.88afbace.png\",\"77wr8\",\"teamworkCollectionHeaderV2.light.d5af8710.png\",\"3mvx6\",\"warning.f5011eb7.png\",\"2oFev\",\"teamwork_collection_header.dark.0d6ead39.png\",\"1BVx6\",\"teamwork_collection_header.light.46f39a8e.png\",\"lOVL5\",\"app-tiles.dark.8e97838c.png\",\"cqGeb\",\"app-tiles.light.c0171e78.png\",\"fYmaw\",\"normalizeSeatBackground.dark.3ce9cef1.png\",\"26YAb\",\"normalizeSeatBackground.light.c079ea47.png\",\"3EtHp\",\"provisioning.light.12580c01.js\",\"9m8Nr\",\"provisioning.dark.548ad10c.js\",\"4E6dy\",\"icons.light.bbb50d8d.js\",\"8JoSD\",\"icons.dark.b514e288.js\",\"bAOHw\",\"cs.e975d2d4.js\",\"h3G5z\",\"da.27978d15.js\",\"gNA0J\",\"de.b4df2c5c.js\",\"9kjAa\",\"en.e8014454.js\",\"vaHqY\",\"en_GB.68dfbf3d.js\",\"hKKq1\",\"en_ZZ.2a09e5ba.js\",\"699rt\",\"es.ca0dd8d8.js\",\"4U6vo\",\"fi.d2cb2a6d.js\",\"8bauW\",\"fr.d8181790.js\",\"2XHsa\",\"hr.904c7b21.js\",\"fQ6gV\",\"hu.5896a39b.js\",\"8N1M8\",\"it.cc9f1446.js\",\"64SZl\",\"ja.750cd491.js\",\"l9rrS\",\"ko.c42def94.js\",\"1K1DB\",\"nb.59ad49db.js\",\"2IhWo\",\"nl.911fd773.js\",\"cB5tA\",\"pl.ab26cceb.js\",\"14y9P\",\"pt_BR.09446ed2.js\",\"8BgQU\",\"ru.b807c15c.js\",\"kyH38\",\"sl.1bb427f1.js\",\"b8zkJ\",\"sr_RS.e62b00a1.js\",\"2Ypcl\",\"sr_YR.af893384.js\",\"g5vt7\",\"sv.56d8a5c2.js\",\"aUgRr\",\"th.c67970a8.js\",\"dZlmW\",\"tr.78c6b798.js\",\"dP9AS\",\"uk.d0863454.js\",\"7yahE\",\"vi.62095660.js\",\"kXGHC\",\"zh.ae3cadcf.js\",\"aparn\",\"zh_TW.a206d84a.js\",\"eEBx4\",\"render.766b1d07.js\",\"f7nCb\",\"render.dfdc65e6.js\",\"9xrtp\",\"render.f3fd740e.js\",\"iFcso\",\"render.2c8a5b7c.js\",\"6gEtt\",\"render.c23094c0.js\",\"br5B5\",\"cs.77653e15.js\",\"gjHAC\",\"da.29cb31a8.js\",\"50jL1\",\"de.6ac9c578.js\",\"icT1H\",\"en-GB.6e22a219.js\",\"jHACf\",\"en-US.74c2d95c.js\",\"gxykq\",\"en-XA.93384ee1.js\",\"jwi3q\",\"en-XB.8fd7d08a.js\",\"4vq5I\",\"en-ZZ.fc86b020.js\",\"3IaOg\",\"es.bff3b1ca.js\",\"c1t91\",\"et.96209c15.js\",\"5x1Zd\",\"fi.f6d4c608.js\",\"eNry3\",\"fr.76857f57.js\",\"cmudZ\",\"hr.9eda1dd8.js\",\"qOVvt\",\"hu.ce65db05.js\",\"cLRtU\",\"it.8d47acb1.js\",\"fWDs2\",\"ja.c832628a.js\",\"isQud\",\"ko.5ab13cf1.js\",\"iX3CG\",\"nb.7e2fbe68.js\",\"5GFyb\",\"nl.1de5b36d.js\",\"fDZox\",\"pl.e8103c49.js\",\"gYq2J\",\"pt-BR.db06477b.js\",\"4MDcN\",\"ro.6b8de570.js\",\"djU0u\",\"ru.7e5f867d.js\",\"gUvh2\",\"sl.adb9638d.js\",\"kb7kZ\",\"sr-RS.3b825f92.js\",\"kGHpg\",\"sr-YR.eb30ef98.js\",\"8GEyD\",\"sr.947e8003.js\",\"gSB6X\",\"sv.aecf40aa.js\",\"9s4Da\",\"th.34906a27.js\",\"f73pl\",\"tr.c80d459d.js\",\"jmWj5\",\"uk.8f0e380b.js\",\"inGUf\",\"vi.2a03c571.js\",\"9rQBn\",\"zh-CN.da1bdc7c.js\",\"4DECc\",\"zh-TW.5274fc2e.js\",\"9GMEV\",\"PageLayout.b6f59cda.js\",\"dJC82\",\"DeleteSpaceDialog.b506151a.js\",\"4ukY5\",\"AboutConfluenceDialog.a0ebdf88.js\",\"6wPv6\",\"GiveFeedbackDialog.83f3ada5.js\",\"943D1\",\"ThemePopupMenu.0a1ec96b.js\",\"9HjCR\",\"theme-light-thumb.1c8784c4.svg\",\"75cX5\",\"theme-dark-thumb.996efaf5.svg\",\"fc8cx\",\"theme-system-thumb.a357a448.svg\",\"gO36l\",\"PageLayout.3e9edc26.js\",\"EfTik\",\"hoverCard.5b6616c3.js\",\"4KiYL\",\"image.411671ed.js\",\"5GUmv\",\"search-error-dark.43e0a164.svg\",\"14R3W\",\"search-error-light.02ef2e6f.svg\",\"5nvBH\",\"landing-dark.4ee27e71.svg\",\"kv0qb\",\"landing-light.0988f0a2.svg\",\"8yV1V\",\"no-results-dark.a00ae47b.svg\",\"3bsGr\",\"no-results-light.5ca83755.svg\",\"efZH2\",\"recent-work-client.b69afda9.js\",\"8F6ik\",\"result-provider.f8da7de9.js\",\"hHoTx\",\"error-image.3040c8c6.js\",\"lUh9w\",\"async-select.82ce4d4f.js\",\"fEM7I\",\"static-select-filter.6fa97146.js\",\"bBtaF\",\"multi-select-filter.05c3d6a2.js\",\"3BloW\",\"image.8b35f735.js\",\"9RypW\",\"image.7359ba77.js\",\"4alnS\",\"no-results-light.5ca83755.svg\",\"bE2Fu\",\"no-results-dark.a00ae47b.svg\",\"6kNSo\",\"autocorrection-renderer.c4457480.js\",\"eQXoP\",\"image.6d8a5de7.js\",\"yzZO6\",\"search-error-light.02ef2e6f.svg\",\"e84X7\",\"search-error-dark.43e0a164.svg\",\"6sXO4\",\"drop-down-links.16d8050a.js\",\"4Sse2\",\"image.4aa8af18.js\",\"4KkwT\",\"prequery-empty-screen-light.0988f0a2.svg\",\"eM7lm\",\"prequery-empty-screen-dark.4ee27e71.svg\",\"5kEKD\",\"upsell-modal.5a57d1cb.js\",\"kqtzG\",\"compass-bitbucket-upsell-banner.1bbe07cf.png\",\"jjAxo\",\"smart-user-picker.0a5c4d8b.js\",\"8XFC9\",\"ai-answer-onboarding-banner.c43f39ee.js\",\"dhAgF\",\"definition-popup-content.53b505e7.js\",\"5QGog\",\"search-client.fe4e79c6.js\",\"fiCwF\",\"search-ai.30c88819.js\",\"St9Nk\",\"AgentProfileCard.0478e7ac.js\",\"lVO3w\",\"ProjectPanel.14772a24.js\",\"jnkIk\",\"TeamProfileCard.ed81ec17.js\",\"7RXky\",\"team-preview-panel.325f7acb.js\",\"8hSeL\",\"arrow-up-right--editor-open.ea870a79.js\",\"1QdXB\",\"CommentsPanelFilterMenu.1e636b30.js\",\"77ceh\",\"definition-popup-content.c3584302.js\",\"8lF3J\",\"office-building.ef555956.js\",\"b6BqD\",\"definition-popup-content.cbb11a85.js\",\"fPDs0\",\"Rovo.e24f6f93.svg\",\"6PtxN\",\"cs.4af6da41.js\",\"8RKtn\",\"da.00cc494f.js\",\"fCIoO\",\"de.feb55cf0.js\",\"1geBW\",\"es.2b9a509c.js\",\"5WU5D\",\"et.c12c2abb.js\",\"i1Uow\",\"fi.577f953a.js\",\"3ZuKT\",\"fr.6da7024a.js\",\"5nJlY\",\"hu.3d953190.js\",\"Uq5C2\",\"it.d747a7e7.js\",\"9TzAL\",\"ja.6cac578c.js\",\"oPAjm\",\"ko.e5176471.js\",\"3fvcK\",\"nb.cf4f3e33.js\",\"iMYDs\",\"nl.0646b6ed.js\",\"jPHqC\",\"pl.7e10aa61.js\",\"3saM6\",\"pt_BR.2e845e69.js\",\"4hCdo\",\"pt_PT.3585f16f.js\",\"78gs3\",\"ru.6f4b63fe.js\",\"2XhMA\",\"sk.9b031399.js\",\"f7Egw\",\"sv.567af81d.js\",\"aiZUj\",\"tr.5656666a.js\",\"6rH3p\",\"th.f0261be3.js\",\"lS1VG\",\"uk.fe1da325.js\",\"fFbe4\",\"vi.32dd8df9.js\",\"7JTjB\",\"zh_TW.3a48b1fe.js\",\"dMjyc\",\"zh.37507780.js\",\"lb9xb\",\"smart-card.e7de77fb.js\",\"cPSQq\",\"renderer.b33be1bd.js\",\"9wbwa\",\"calendar-dark.a0ed3c18.svg\",\"edV1v\",\"calendar-light.caa4677f.svg\",\"5P10P\",\"location-dark.395fc7dc.svg\",\"1jWRt\",\"location-light.9d9cfd0a.svg\",\"6mHrv\",\"definition-popup-content.83f720fc.js\",\"1Jsgt\",\"definition-popup-content.8236b095.js\",\"bWcRJ\",\"file.27d59cf0.js\",\"iDB1L\",\"pen.ff9dabea.js\",\"lvdR8\",\"department.20e9a61b.js\",\"dXz7U\",\"cs.6c96f43c.js\",\"gGEZv\",\"da.09087919.js\",\"d3blt\",\"de.533b7e5d.js\",\"59Z93\",\"en_GB.04b3cd19.js\",\"kotjW\",\"en_ZZ.3cc1be39.js\",\"kK6se\",\"es.82b58ab1.js\",\"5xf60\",\"et.7581eb28.js\",\"9VEIz\",\"fi.dd465a07.js\",\"cjdHS\",\"fr.8a552f95.js\",\"Whd6n\",\"hu.6ab28da5.js\",\"jkUKZ\",\"is.a0ebfb14.js\",\"9LPlo\",\"it.5dc51389.js\",\"bCZbu\",\"ja.a83ac8b3.js\",\"jUfGx\",\"ko.e0a051c8.js\",\"8yxgV\",\"nb.9352d383.js\",\"dBE2i\",\"nl.db0df47f.js\",\"6FNZU\",\"pl.5acc4dce.js\",\"ilWcC\",\"pt_BR.009aee02.js\",\"edU6Z\",\"pt_PT.94fccdb2.js\",\"atNxX\",\"ro.e8b3e3a3.js\",\"gpgvY\",\"ru.dbab8eb4.js\",\"3IA7L\",\"sk.9ec26891.js\",\"hpq4P\",\"sv.017f89af.js\",\"8WMbP\",\"th.210e3a3d.js\",\"kffHA\",\"tr.18c6d4d2.js\",\"2zh8u\",\"uk.72327820.js\",\"9YoTA\",\"vi.800067bf.js\",\"a9qyt\",\"zh.42c6c7c0.js\",\"04egH\",\"zh_TW.077720f1.js\",\"1Ojgx\",\"ai-answer-prompt.09562d37.js\",\"eVnxm\",\"trello-body.cf948b9e.js\",\"2exA8\",\"trello-popper.d0100eb6.js\",\"4WF1A\",\"PageLayout.c08f0a8f.js\",\"gD9D1\",\"cs.427d5f3d.js\",\"lpFHz\",\"da.e4b46608.js\",\"fYKge\",\"de.5858ed73.js\",\"4Wlui\",\"en_GB.5a1c4d19.js\",\"69mwC\",\"en_ZZ.b415f0cb.js\",\"7rN2h\",\"es.2fe6ffbc.js\",\"9Y8tZ\",\"fi.5f2aa8eb.js\",\"jjh1v\",\"fr.b5af68d4.js\",\"23sVT\",\"hr.abea954c.js\",\"eO6VH\",\"hu.220a831a.js\",\"8rFvt\",\"it.686f0da0.js\",\"lK8aI\",\"ja.96c27ff1.js\",\"5j4Hn\",\"ko.d793b8d2.js\",\"2Jfx0\",\"nb.98eab6ad.js\",\"c119j\",\"nl.1f6eeb6e.js\",\"lgdNv\",\"pl.3348f5c2.js\",\"dKIhk\",\"pt_BR.de2beaaa.js\",\"dwqTf\",\"ru.47408d94.js\",\"fbezn\",\"sl.41a2d6d2.js\",\"3HAPT\",\"sr_RS.ef2923e5.js\",\"2GH4w\",\"sr_YR.fb612843.js\",\"7Qzqz\",\"sv.1a76b9be.js\",\"gt8Kd\",\"th.8a9fbc45.js\",\"eVDdh\",\"tr.b04d4139.js\",\"hLIwJ\",\"uk.c1d7f223.js\",\"wnH66\",\"vi.1c704e4b.js\",\"5oeby\",\"zh_TW.a4ef35ec.js\",\"2shw0\",\"zh.7634d348.js\",\"5LCFM\",\"esm.70fc029a.js\",\"bvkZd\",\"no-results-dark.a00ae47b.svg\",\"cV42Q\",\"no-results-light.5ca83755.svg\",\"wirGo\",\"PageLayout.8238fa5b.js\",\"3Kg3S\",\"CreateComponent.7c9ef2ea.js\",\"kpzlp\",\"UnreadCommentCount.6e42f168.js\",\"7ZBIQ\",\"UnreadCommentCount.896669df.js\",\"i8hiG\",\"UnreadIndicator.c9f9b434.js\",\"9y1Aa\",\"WhiteboardGAModalManager.70f008f5.js\",\"dIuWY\",\"GAOnboardingAnnouncement.98a7a653.gif\",\"jBwbI\",\"LoomMigrationModalManager.26af1b20.js\",\"3jZMP\",\"loomMigrationModalImage.fa8ef03b.svg\",\"1wrZ9\",\"vector.07efb279.svg\",\"b8oHe\",\"EngagementInlineDialogWrapper.9e6e46f0.js\",\"a6eof\",\"PageLayout.212d1e68.js\",\"jfTrX\",\"AppNavigation.261965de.js\",\"8Kyi2\",\"OnboardingCTANudge.3acafe12.js\",\"hesl9\",\"RecentPages.60a21812.js\",\"8q7U9\",\"Collaboration.a011f6bd.svg\",\"eJwDQ\",\"SearchError.ab7cb722.svg\",\"lPQcc\",\"team-preview-panel.faba34bd.js\",\"6JvQz\",\"PeopleItemWrapper.77e89f86.js\",\"bf0yj\",\"modal-dialog.4ea336eb.js\",\"6SYnx\",\"teamCreateDialog.5f83dd6c.js\",\"40B2u\",\"MenuContent.6ac4cb5c.js\",\"bZtF0\",\"th.078cde1d.js\",\"9pBxJ\",\"uk.bd28f54b.js\",\"bM16t\",\"vi.1760e489.js\",\"2ZapG\",\"AppsContent.271d6808.js\",\"emP1M\",\"blocks.348a3d50.svg\",\"1Zku8\",\"DiscoverSection.c4f0bbd4.js\",\"bVqnE\",\"CustomHomepageItem.93a27dc5.js\",\"F2Q4u\",\"AppSwitcherComponentWrapper.ae7ad5ef.js\",\"5GXmr\",\"AppSwitcherContent.249b5785.js\",\"aOHmb\",\"app-switcher.6d284817.js\",\"df12q\",\"NotificationsComponent.e7de85fc.js\",\"lpfAf\",\"notification.cbda05c9.js\",\"iW7i1\",\"NotesComponent.727ac9f3.js\",\"heZTL\",\"SettingsComponent.b0cdfee7.js\",\"6YgN9\",\"MenuComponent.938672db.js\",\"eXOVv\",\"HelpComponent.42ebb1a8.js\",\"01qRE\",\"SearchComponent.ead3e1c9.js\",\"61fF8\",\"clock--emoji-frequent.0a3f8620.js\",\"cMlHc\",\"24.51929d4d.js\",\"dD4ld\",\"filter.b0e8732a.js\",\"eErVv\",\"cards-extension.28632dca.js\",\"eHw9Y\",\"ProfileComponent.d8d77898.js\",\"9IyPY\",\"ProfileMenu.244c9e3c.js\",\"65NKm\",\"log-in--sign-in.2e28e5a3.js\",\"9PQXU\",\"AppNavigation.66592e7b.js\",\"jmmCO\",\"RightSidebar.744cbf50.js\",\"lgm1i\",\"StandaloneRestrictedPageOrSpace.e5ad1631.js\",\"kUiwW\",\"RestrictedPage.62ae910f.js\",\"5WZOQ\",\"CantViewLight.81544b8c.svg\",\"dHMTU\",\"CantViewDark.ef25ef94.svg\",\"cOpg6\",\"CantEditLight.0ee7f232.svg\",\"37OHY\",\"CantEditDark.190a22b1.svg\",\"6f3t8\",\"AdminKeyUpSell.dc053a0e.js\",\"euA5f\",\"SuperAdminEntryPoint.0de288b6.js\",\"gEi5K\",\"NotFound.dcc963a1.js\",\"QfEJc\",\"NotFoundIcon.ab9d1086.svg\",\"2OcM6\",\"RestrictedSpace.10632f7a.js\",\"55AxV\",\"RestrictedContentIcon-Dark.bc90ae31.svg\",\"L0tFv\",\"RestrictedContentIcon-Light.e0fef1fb.svg\",\"7DDw1\",\"ConfluenceLogo.37570e84.svg\",\"k0WnS\",\"ExternalPageNotFoundV2.72618986.js\",\"4J5D7\",\"not-found-v2.ab9d1086.svg\",\"lwfE5\",\"ArchiveSpacePortal.c81e1bf6.js\",\"j06N4\",\"ArchiveSpacePanel.0676c281.js\",\"d7sp9\",\"DeleteSpacePortal.f278af96.js\",\"ei0Jg\",\"SpaceSettingsForgeExtensionPortal.aa95a1f5.js\",\"bGzhS\",\"ByLineForgeApp.8c48e3ad.js\",\"eMbal\",\"loading-button.90d63bac.js\",\"cjJTJ\",\"section-message.547b3afe.js\",\"jeyta\",\"no-results.603cf20f.svg\",\"2rCak\",\"FullPageEditorComponent.fe04749d.js\",\"A1eSR\",\"FullPageEditorComponent.runtime.f31abc74.js\",\"cf5vC\",\"ByLineForgeApp.80887d82.js\",\"8Kivm\",\"ByLineForgeApp.f26c625d.js\",\"jigcs\",\"LabelsSelect.b6dac9ed.js\",\"718G0\",\"LabelsSelectErrors.89971248.js\",\"4LmEY\",\"ViewPageLabels.e1ea0031.js\",\"djzzD\",\"PageLabelsAutomationDiscovery.c35cd600.js\",\"A1eSR\",\"FullPageEditorComponent.runtime.f31abc74.js\",\"bdzih\",\"ContentActionForgeApp.ec368c6c.js\",\"cwpVK\",\"ContextMenuForgeApp.1a2bc0be.js\",\"68RC4\",\"FullPageForgeApp.e12bcfe3.js\",\"87cDu\",\"GlobalPageForgeApp.b1da2633.js\",\"iXr0W\",\"GlobalSettingsForgeApp.00413ef4.js\",\"ccJug\",\"HomepageFeedForgeApp.1d8bd326.js\",\"irYLY\",\"SpaceSettingsForgeApp.49b4f436.js\",\"ldtPf\",\"SpacePageForgeApp.6aa4e3b0.js\",\"6wcNV\",\"CustomContentForgeApp.a502e5b2.js\",\"i9jMB\",\"BackgroundScriptForgeApp.daae2c26.js\",\"aFNXd\",\"PageBannerForgeApp.541569e6.js\",\"hhf8b\",\"SpaceTrashPortal.3897b499.js\",\"an2zh\",\"SiteSettingsHelpPanelLink.48fe27c8.js\",\"gJRFC\",\"BackupManagerButton.576a1571.js\",\"dc4c6\",\"dashboard-spa-container-jquery3.81e1c69e.js\",\"2mkZm\",\"dashboard-spa-container-jquery3.runtime.90242dad.js\",\"eiF7i\",\"stable_vendors.251bfc4c.js\",\"aZinD\",\"vendors.93919a54.js\"]"));
 }, ["7EorR","dc4c6","2mkZm","eiF7i","aZinD","hhss7","ffEVr","1yVM6","1qlDN","5pvpJ","6XCf4","9sJzT","6wr18"]);
$parcel$global.rwr("3pblT", () => { 
var $42omo = parcelRequire("42omo");


var $jTxSS = parcelRequire("jTxSS");


var $5QpZa = parcelRequire("5QpZa");


var $hp2SH = parcelRequire("hp2SH");


var $iC5L0 = parcelRequire("iC5L0");


var $aXEzU = parcelRequire("aXEzU");





var $3WLLD = parcelRequire("3WLLD");


var $bj5fB = parcelRequire("bj5fB");





var $7J5Uc = parcelRequire("7J5Uc");

const $14d55bbfca2abbc5$export$7a88623f52f1b79 = (initialTheme)=>{
    const [{ isInitialized: isInitialized }, { initializeTheme: initializeTheme }] = (0, $7J5Uc.useThemingState)();
    (0, $42omo.useEffect)(()=>{
        initializeTheme(initialTheme);
    // Only execute upon initial render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return isInitialized;
};


const $e6baa9171970034d$export$11eb671888ed6e7d = ({ children: children })=>{
    const { isMobileApp: isMobileApp } = (0, $bj5fB.useIsMobileApp)();
    const initialTheme = isMobileApp ? (0, $3WLLD.mobileAppTheme) : undefined;
    const isInitialized = (0, $14d55bbfca2abbc5$export$7a88623f52f1b79)(initialTheme);
    if (!isInitialized) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
};



var $7zgzO = parcelRequire("7zgzO");


var $awd1Q = parcelRequire("awd1Q");


var $9j59h = parcelRequire("9j59h");


var $xwvlW = parcelRequire("xwvlW");


var $8PKGr = parcelRequire("8PKGr");


var $68uaC = parcelRequire("68uaC");


var $17wUi = parcelRequire("17wUi");


var $gnYQc = parcelRequire("gnYQc");


var $2DVQX = parcelRequire("2DVQX");


var $7LuKf = parcelRequire("7LuKf");





var $6g1oe = parcelRequire("6g1oe");


var $4xcIM = parcelRequire("4xcIM");


var $2FNjD = parcelRequire("2FNjD");


var $ge2sX = parcelRequire("ge2sX");


var $f7i8j = parcelRequire("f7i8j");


var $cryCi = parcelRequire("cryCi");


var $dBmJE = parcelRequire("dBmJE");








var $kFqI2 = parcelRequire("kFqI2");


var $T1bCI = parcelRequire("T1bCI");


var $lonEO = parcelRequire("lonEO");


var $iJELi = parcelRequire("iJELi");


var $d5ap9 = parcelRequire("d5ap9");


var $hmRc4 = parcelRequire("hmRc4");


var $fcF01 = parcelRequire("fcF01");


var $iJiK8 = parcelRequire("iJiK8");


var $1kHsc = parcelRequire("1kHsc");


var $fGzMp = parcelRequire("fGzMp");


var $25MM7 = parcelRequire("25MM7");





var $jVK0t = parcelRequire("jVK0t");


var $64KID = parcelRequire("64KID");


var $kZDrw = parcelRequire("kZDrw");


var $8n9tL = parcelRequire("8n9tL");


var $1ytiN = parcelRequire("1ytiN");


var $a5txT = parcelRequire("a5txT");


var $97W74 = parcelRequire("97W74");

class $7db816b9e13721ff$export$2e2bcd8739ae039 extends (0, $42omo.Component) {
    getChildContext() {
        const { context: context } = this.props;
        const noop = ()=>{};
        return {
            insertCss: context.insertCss || noop
        };
    }
    render() {
        const { store: store } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Provider), {
            inject: [
                (0, $a5txT.getStandalonePageTreeStateUpdater)()
            ]
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lonEO.GraphqlProvider), {
            client: (0, $hp2SH.getApolloClient)()
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kFqI2.Provider), {
            store: store
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1ytiN.SPAViewContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1kHsc.ExperienceTrackerContext).Provider, {
            value: (0, $fGzMp.getExperienceTracker)()
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jVK0t.I18nProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d5ap9.ConfluenceAnalyticsListener), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kZDrw.NavdexListener), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $97W74.EngagementProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dBmJE.ConnectedRouter), {
            history: this.browserHistory,
            context: (0, $kFqI2.ReactReduxContext)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fcF01.UpFlowProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $25MM7.Flags), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iJELi.ConnectSupport), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8n9tL.RouteManager), {
            namedRoutes: (0, $64KID.namedRoutes)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iJiK8.Dialogs), null), this.props.children))))))))))));
    }
    constructor(...args){
        super(...args);
        this.browserHistory = (0, $hmRc4.getBrowserHistory)();
    }
}
$7db816b9e13721ff$export$2e2bcd8739ae039.propTypes = {
    /**
   * Global store
   */ store: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object.isRequired,
    /**
   * Context including the css handler (It has different versions for client and server rendering)
   */ context: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).shape({
        insertCss: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func
    }),
    /**
   * Children Component
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).any,
    /**
   * Indicates if the component is rendered as Root
   */ renderAsRoot: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool
};
$7db816b9e13721ff$export$2e2bcd8739ae039.childContextTypes = {
    /**
   * Handler for css injection in components.
   */ insertCss: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired
};



var $3Tw8v = parcelRequire("3Tw8v");


var $9F7Qb = parcelRequire("9F7Qb");

const $d4f95b5cede9219f$var$store = (0, $3Tw8v.default)({
    isServerRenderedPage: true
});
(0, $9F7Qb.subscribe)($d4f95b5cede9219f$var$store);
const $d4f95b5cede9219f$var$context = {
    insertCss: (styles)=>styles._insertCss()
};
/**
 * Method for rendering React/Redux component
 * Usage:
 * import renderComponent from './renderComponentIntoDOM';
 * renderComponent(<YourComponent />, 'your-component-section-id');
 * OR renderComponent(<YourComponent />, DOMComponent);
 *
 * @param children
 * @param container DOM node or id string
 */ const $d4f95b5cede9219f$var$renderComponentIntoDOM = (children, container, renderAsRoot = false)=>{
    if (typeof container === 'string') container = (0, (/*@__PURE__*/$parcel$interopDefault($6g1oe))).document.getElementById(container);
    const Component = ({ sessionData: sessionData })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f7i8j.SessionDataContext).Provider, {
            value: sessionData
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cryCi.Provider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7db816b9e13721ff$export$2e2bcd8739ae039), {
            store: $d4f95b5cede9219f$var$store,
            context: $d4f95b5cede9219f$var$context,
            renderAsRoot: renderAsRoot
        }, children)));
    Component.propTypes = {
        sessionData: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object.isRequired
    };
    (0, $ge2sX.getSessionData)().then((sessionData)=>{
        const concurrentComponentWrapper = (0, $2FNjD.createRoot)(container);
        concurrentComponentWrapper.render(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Component, {
            sessionData: sessionData
        }));
    });
};
var $d4f95b5cede9219f$export$2e2bcd8739ae039 = $d4f95b5cede9219f$var$renderComponentIntoDOM;



var $7RVQB = parcelRequire("7RVQB");




/**
 * These helper functions should be used to minimize the impact the standalone sidebar causes to the ui (jump, flip, flash, jank);
 */ const $8bee1fe38b9eef04$var$mainSectionsSelectors = [
    '#main',
    '#admin-content',
    '#custom-content-container',
    '.ap-servlet-placeholder'
];
const $8bee1fe38b9eef04$export$ed04e7f6ba662aee = ()=>{
    const head = (0, (/*@__PURE__*/$parcel$interopDefault($6g1oe))).document.head || (0, (/*@__PURE__*/$parcel$interopDefault($6g1oe))).document.querySelector('head');
    const style = (0, (/*@__PURE__*/$parcel$interopDefault($6g1oe))).document.createElement('style');
    const css = `${$8bee1fe38b9eef04$var$mainSectionsSelectors.join(',')} { opacity: 0 };`;
    style.type = 'text/css';
    if (style.styleSheet) style.styleSheet.cssText = css;
    else style.appendChild((0, (/*@__PURE__*/$parcel$interopDefault($6g1oe))).document.createTextNode(css));
    if (head) head.appendChild(style);
};
const $8bee1fe38b9eef04$export$4011f4c5a8044281 = (runs = 0)=>{
    const mainContainers = $8bee1fe38b9eef04$var$mainSectionsSelectors.map((selector)=>(0, (/*@__PURE__*/$parcel$interopDefault($6g1oe))).document.querySelector(selector)).filter((ele)=>ele !== null);
    if (mainContainers.length) mainContainers.forEach((container)=>{
        if (container) {
            container.style.transition = 'opacity .15s ease-in';
            container.style.opacity = '1';
        }
    });
    else // accounting for any race condition that could delay the parsing of the content
    if (runs < 5) {
        console.warn('Legacy pages: trying to fix jank behaviour on legacy pages but content container is not found yet');
        setTimeout(()=>$8bee1fe38b9eef04$export$4011f4c5a8044281(runs + 1), 100);
    } else console.error('Legacy pages: content container was not found');
};






var $iyEDi = parcelRequire("iyEDi");


var $gnnzK = parcelRequire("gnnzK");


var $1NBp8 = parcelRequire("1NBp8");

/* StandaloneConfluenceNavigation.js generated by @compiled/babel-plugin v0.36.1 */ 



var $gMc0m = parcelRequire("gMc0m");





var $eXODy = parcelRequire("eXODy");


var $iV00x = parcelRequire("iV00x");


var $3pfAb = parcelRequire("3pfAb");


var $NAPtM = parcelRequire("NAPtM");





var $3IBnw = parcelRequire("3IBnw");


var $hSqtY = parcelRequire("hSqtY");


var $bQm3c = parcelRequire("bQm3c");











var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");

var $gmMgo = parcelRequire("gmMgo");


var $30qWc = parcelRequire("30qWc");





var $gqqjz = parcelRequire("gqqjz");








var $b1HmN = parcelRequire("b1HmN");


var $eSUdr = parcelRequire("eSUdr");

const $13bb14eac5ea00fc$export$bae28e68d0aa638c = (0, $eSUdr.default)`mutation ClearRestrictionsForFreeMutation($contentId:ID!){clearRestrictionsForFree(contentId:$contentId){restrictionsHash}}`;


const $e5314625536bb69f$export$8a37b2ec23f0faea = 'confluence-change-edition-remove-restrictions-button';
const $e5314625536bb69f$export$9f92e67dea336ca7 = 'confluence-change-edition-notification-dialog';
const $e5314625536bb69f$var$i18n = (0, $cgtv4.defineMessages)({
    removeRestrictionButton: {
        id: "change-edition.notification.dialog.general.button.remove-restrictions",
        defaultMessage: "Remove restrictions"
    },
    removeRestrictionTitle: {
        id: "change-edition.notification.dialog.general.title.remove-restrictions-2",
        defaultMessage: "Remove restrictions?"
    },
    removeRestrictionTextSpaceLevel: {
        id: "change-edition.notification.dialog.space.text.remove-restrictions",
        defaultMessage: "You\u2019re on the free plan, so you can only <b>remove all restrictions</b> from <b>{contentTitle}</b>. <b>This can\u2019t be undone.</b> You won\u2019t be able to reset the restrictions later."
    },
    removeRestrictionConfirmationSuccessTitle: {
        id: "change-edition.notification.dialog.confirmation.success.title",
        defaultMessage: "Restrictions removed"
    },
    removeRestrictionConfirmationSuccessDesc: {
        id: "change-edition.notification.dialog.confirmation.success.desc",
        defaultMessage: "Anyone who\u2019s logged in can now view and edit {contentTitle}."
    },
    removeRestrictionConfirmationFailedTitle: {
        id: "change-edition.notification.dialog.confirmation.failed.title",
        defaultMessage: "Page restrictions not removed"
    },
    removeRestrictionConfirmationFailedDesc: {
        id: "change-edition.notification.dialog.confirmation.failed.desc",
        defaultMessage: "We couldn\u2019t remove restrictions from {contentTitle}. Try again."
    }
});
const $e5314625536bb69f$var$DEFAULT_COMPONENT_STATE = {
    isNotificationOpen: false,
    isMutationInProcess: false,
    contentId: null,
    contentTitle: null
};
//TODO: remove dep on shared i18n.
const $e5314625536bb69f$var$changeEditionPageRestrictionsLegacyCoordinatorI18n = (0, $cgtv4.defineMessages)({
    // Notification Dialog --------------------
    cancelButton: {
        id: "change-edition.general.button.cancel",
        defaultMessage: "Cancel"
    }
});
class $e5314625536bb69f$var$ChangeEditionPageRestrictionsLegacyCoordinatorComponent extends (0, $42omo.PureComponent) {
    componentDidMount() {
        Array.prototype.forEach.call(this.allRemoveRestrictionsElements, (el)=>{
            el.addEventListener('click', this.openNotificationDialog);
        });
    }
    componentWillUnmount() {
        Array.prototype.forEach.call(this.allRemoveRestrictionsElements, (el)=>{
            el.removeEventListener('click', this.openNotificationDialog);
        });
    }
    render() {
        const { intl: intl } = this.props;
        const { isNotificationOpen: isNotificationOpen, isMutationInProcess: isMutationInProcess, contentTitle: contentTitle, contentId: contentId } = this.state;
        if (!this.placeholderEl) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7zgzO.RoutesContext).Consumer, null, ({ location: location, matchRoute: matchRoute })=>{
            const route = matchRoute(location.pathname);
            // Skip rendering for other then "Space Setting / Restricted Page" page
            if (!route || route.name != (0, $1NBp8.SPACE_RESTRICTED_PAGES).name) return null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).createPortal(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
                to: [
                    (0, $gqqjz.FlagsStateContainer)
                ]
            }, (flags)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $30qWc.MutationInterop), {
                    mutation: (0, $13bb14eac5ea00fc$export$bae28e68d0aa638c),
                    variables: {
                        contentId: contentId
                    },
                    onCompleted: this.handleMutationComplete(flags),
                    onError: this.handleMutationError(flags)
                }, (clearRestrictionsForFreeMutation)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b1HmN.LoadableChangeEditionNotificationDialog), {
                        isOpen: isNotificationOpen,
                        isProcessing: isMutationInProcess,
                        cancelAction: {
                            text: intl.formatMessage($e5314625536bb69f$var$changeEditionPageRestrictionsLegacyCoordinatorI18n.cancelButton),
                            onClick: this.closeNotificationDialog
                        },
                        applyAction: {
                            text: intl.formatMessage($e5314625536bb69f$var$i18n.removeRestrictionButton),
                            onClick: this.applyChanges(clearRestrictionsForFreeMutation)
                        },
                        heading: intl.formatMessage($e5314625536bb69f$var$i18n.removeRestrictionTitle),
                        source: "individualSpaceRestrictedPages",
                        grandfathered: true
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
                        ...$e5314625536bb69f$var$i18n.removeRestrictionTextSpaceLevel,
                        values: {
                            contentTitle: contentTitle,
                            b: (...chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("b", null, chunks)
                        }
                    })))), this.placeholderEl);
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            ...$e5314625536bb69f$var$DEFAULT_COMPONENT_STATE
        };
        this.allRemoveRestrictionsElements = window.document.getElementsByClassName($e5314625536bb69f$export$8a37b2ec23f0faea) || [];
        this.placeholderEl = window.document.getElementById($e5314625536bb69f$export$9f92e67dea336ca7);
        this.openNotificationDialog = (event)=>{
            this.setState({
                isNotificationOpen: true,
                contentId: event.target.getAttribute('data-page-id'),
                contentTitle: event.target.getAttribute('data-page-title')
            });
        };
        this.closeNotificationDialog = ()=>{
            this.setState($e5314625536bb69f$var$DEFAULT_COMPONENT_STATE);
        };
        this.applyChanges = (mutationFunction)=>()=>{
                this.setState({
                    isMutationInProcess: true
                });
                mutationFunction();
            };
        this.handleMutationComplete = (flags)=>()=>{
                const { intl: intl } = this.props;
                const { contentTitle: contentTitle } = this.state;
                flags.showSuccessFlag({
                    title: intl.formatMessage($e5314625536bb69f$var$i18n.removeRestrictionConfirmationSuccessTitle),
                    description: intl.formatMessage($e5314625536bb69f$var$i18n.removeRestrictionConfirmationSuccessDesc, {
                        contentTitle: contentTitle
                    })
                });
                this.closeNotificationDialog();
                window.setTimeout(()=>{
                    // refresh the page to see the changes
                    window.location.reload();
                }, 500);
            };
        this.handleMutationError = (flags)=>()=>{
                const { intl: intl } = this.props;
                const { contentTitle: contentTitle } = this.state;
                flags.showErrorFlag({
                    title: intl.formatMessage($e5314625536bb69f$var$i18n.removeRestrictionConfirmationFailedTitle),
                    description: intl.formatMessage($e5314625536bb69f$var$i18n.removeRestrictionConfirmationFailedDesc, {
                        contentTitle: contentTitle
                    })
                });
                this.closeNotificationDialog();
            };
    }
}
$e5314625536bb69f$var$ChangeEditionPageRestrictionsLegacyCoordinatorComponent.propTypes = {
    intl: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object
};
const $e5314625536bb69f$export$5b44234181f42094 = (0, $gmMgo.default)($e5314625536bb69f$var$ChangeEditionPageRestrictionsLegacyCoordinatorComponent);




















var $8C5kA = parcelRequire("8C5kA");





var $4WmbV = parcelRequire("4WmbV");

const $4c2daaa3bc0c282d$var$i18n = (0, $cgtv4.defineMessages)({
    siteAdminAuditLogsTitle: {
        id: "change-edition.section.message.site-admin.audit-logs.title",
        defaultMessage: "Upgrade for Audit logs"
    },
    nonSiteAdminAuditLogsTitle: {
        id: "change-edition.section.message.non-site-admin.audit-logs.title",
        defaultMessage: "Audit logs are only available on paid plans"
    },
    siteAdminAuditLogsBody: {
        id: "change-edition.section.message.site-admin-audit-logs.body",
        defaultMessage: "You\u2019re on the free plan, so you can\u2019t view and track changes made across your site in the audit logs. To access the audit logs, upgrade your plan."
    },
    nonSiteAdminAuditLogsBody: {
        id: "change-edition.section.message.non-site-admin-audit-logs.body",
        defaultMessage: "You\u2019re on the free plan, so you can\u2019t view and track changes made across your site in the audit logs."
    }
});
const $4c2daaa3bc0c282d$export$cb2ba78fe55aff74 = ()=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { isSiteAdmin: isSiteAdmin } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    const title = isSiteAdmin ? $4c2daaa3bc0c282d$var$i18n.siteAdminAuditLogsTitle : $4c2daaa3bc0c282d$var$i18n.nonSiteAdminAuditLogsTitle;
    const body = isSiteAdmin ? $4c2daaa3bc0c282d$var$i18n.siteAdminAuditLogsBody : $4c2daaa3bc0c282d$var$i18n.nonSiteAdminAuditLogsBody;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4WmbV.ChangeEditionSectionMessage), {
        title: formatMessage(title),
        body: formatMessage(body),
        source: "auditLogs"
    });
};














var $f7Bnv = parcelRequire("f7Bnv");




const $ee74963fbde2c4ed$var$i18n = (0, $cgtv4.defineMessages)({
    siteAdminContentRestrictionsTitle: {
        id: "change-edition.section.message.site-admin.content-restrictions.title",
        defaultMessage: "Upgrade for content-level restrictions"
    },
    nonSiteAdminContentRestrictionsTitle: {
        id: "change-edition.section.message.non-site-admin.content-restrictions.title",
        defaultMessage: "Content-level restrictions are only available on paid plans"
    },
    spaceRestrictedPagesText: {
        id: "change-edition.section.message.space-restricted-pages.text",
        defaultMessage: "You\u2019re on the free plan, so you can only remove all restrictions from content by clicking the lock icon below. To set restrictions, upgrade your plan."
    },
    nonSiteAdminGrandfatheredRestrictedPagesBody: {
        id: "change-edition.section.message.non-admin.grandfathered.space-restricted-pages.body",
        defaultMessage: "You\u2019re on the free plan, so you can only remove all restrictions from content by clicking the lock icon below."
    },
    siteAdminRestrictedPagesBody: {
        id: "change-edition.section.message.site-admin.space-restricted-pages.body",
        defaultMessage: "You\u2019re on the free plan, so anyone who\u2019s logged in can view and edit everything. To set restrictions, upgrade your plan."
    },
    nonSiteAdminRestrictedPagesBody: {
        id: "change-edition.section.message.non-admin.space-restricted-pages.body",
        defaultMessage: "You\u2019re on the free plan, so anyone who\u2019s logged in can view and edit everything."
    }
});
function $ee74963fbde2c4ed$var$getBody(isSiteAdmin, grandfathered) {
    if (grandfathered) {
        if (isSiteAdmin) return $ee74963fbde2c4ed$var$i18n.spaceRestrictedPagesText;
        else return $ee74963fbde2c4ed$var$i18n.nonSiteAdminGrandfatheredRestrictedPagesBody;
    } else {
        if (isSiteAdmin) return $ee74963fbde2c4ed$var$i18n.siteAdminRestrictedPagesBody;
        else return $ee74963fbde2c4ed$var$i18n.nonSiteAdminRestrictedPagesBody;
    }
}
const $ee74963fbde2c4ed$var$ChangeEditionSectionMessageSpaceContentComponent = ({ grandfathered: grandfathered, isSiteAdmin: isSiteAdmin })=>{
    const intl = (0, $8C5kA.default)();
    const bodyText = $ee74963fbde2c4ed$var$getBody(isSiteAdmin, grandfathered);
    const title = isSiteAdmin ? $ee74963fbde2c4ed$var$i18n.siteAdminContentRestrictionsTitle : $ee74963fbde2c4ed$var$i18n.nonSiteAdminContentRestrictionsTitle;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4WmbV.ChangeEditionSectionMessage), {
        title: intl.formatMessage(title),
        body: intl.formatMessage(bodyText),
        source: "individualSpaceRestrictedPages"
    });
};
$ee74963fbde2c4ed$var$ChangeEditionSectionMessageSpaceContentComponent.propTypes = {
    grandfathered: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool.isRequired,
    isSiteAdmin: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool.isRequired
};
const $ee74963fbde2c4ed$export$51350d82d36f7e43 = (0, $f7Bnv.withIsSiteAdmin)($ee74963fbde2c4ed$var$ChangeEditionSectionMessageSpaceContentComponent);


const $63cbc74b40cb8d33$export$4a53029580aac53e = 'confluence-change-edition-section-message';
class $63cbc74b40cb8d33$export$b9f1eac8c818cdb0 extends (0, $42omo.Component) {
    isSectionMessageNeeded(routeName) {
        return routeName && Boolean(this.ROUTE_NAME2COMPONENT[routeName.name]);
    }
    getComponentParams(routeName) {
        if (routeName === (0, $1NBp8.SPACE_RESTRICTED_PAGES).name) return {
            grandfathered: this.el.getAttribute('data-grandfathered') === 'true'
        };
        return {};
    }
    render() {
        if (!this.el) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7zgzO.RoutesContext).Consumer, null, ({ location: location, matchRoute: matchRoute })=>{
            const routeName = matchRoute(location.pathname + location.search);
            if (!this.isSectionMessageNeeded(routeName)) return null;
            const ChangEditionComponent = this.ROUTE_NAME2COMPONENT[routeName.name];
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).createPortal(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ChangEditionComponent, this.getComponentParams(routeName.name)), this.el);
        });
    }
    constructor(...args){
        super(...args);
        this.el = window.document.getElementById($63cbc74b40cb8d33$export$4a53029580aac53e);
        this.ROUTE_NAME2COMPONENT = {
            [(0, $1NBp8.SPACE_RESTRICTED_PAGES).name]: (0, $ee74963fbde2c4ed$export$51350d82d36f7e43),
            [(0, $1NBp8.ADMIN_AUDIT_LOG).name]: (0, $4c2daaa3bc0c282d$export$cb2ba78fe55aff74)
        };
    }
}


const $f60f9bb0af41c642$export$ddc928ad192d2b94 = ()=>(0, $bQm3c.useSessionData)().edition === 'FREE' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hSqtY.TransparentErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).ADMIN_EXPERIENCE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $63cbc74b40cb8d33$export$b9f1eac8c818cdb0), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hSqtY.TransparentErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).ADMIN_EXPERIENCE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e5314625536bb69f$export$5b44234181f42094), null))) : null;






var $4PPzL = parcelRequire("4PPzL");


var $04e9M = parcelRequire("04e9M");


var $56QzY = parcelRequire("56QzY");


var $1dnxO = parcelRequire("1dnxO");


var $aeSHO = parcelRequire("aeSHO");


var $iJ8K8 = parcelRequire("iJ8K8");


var $4l6Wo = parcelRequire("4l6Wo");


var $hDG7z = parcelRequire("hDG7z");


var $eWwvy = parcelRequire("eWwvy");


var $39rFu = parcelRequire("39rFu");





var $cBuRD = parcelRequire("cBuRD");





var $eIKcA = parcelRequire("eIKcA");





var $ezLwY = parcelRequire("ezLwY");

/**
 * shortcutContext('global') or shortcutContext(['global', 'viewcontent'])
 * @param context
 * @returns {Function}
 */ function $089e60b6c1a73ffc$var$shortcutContext(context) {
    return (BaseComponent)=>{
        class ShortcutContextComponent extends (0, $42omo.Component) {
            componentDidMount() {
                (0, $ezLwY.enableContext)(context);
            }
            componentWillUnmount() {
                (0, $ezLwY.disableContext)(context);
            }
            render() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(BaseComponent, this.props);
            }
        }
        ShortcutContextComponent.displayName = `ShortcutContextComponent(${BaseComponent.displayName || BaseComponent.name})`;
        return ShortcutContextComponent;
    };
}
var $089e60b6c1a73ffc$export$2e2bcd8739ae039 = $089e60b6c1a73ffc$var$shortcutContext;



var $jmjWc = parcelRequire("jmjWc");


const $f05a18473f890654$export$ffff49ea750347f8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "3CTAv",
    name: "StandaloneRestrictedPageOrSpace",
    loader: async ()=>(await (parcelRequire("fmuCC"))).StandaloneRestrictedPageOrSpace
});



var $jwv1p = parcelRequire("jwv1p");


var $arkw6 = parcelRequire("arkw6");


var $3j0Cc = parcelRequire("3j0Cc");


var $4QflW = parcelRequire("4QflW");





var $ba9cbe60fdf9141e$exports = {};

var $bCMS0 = parcelRequire("bCMS0");


var $daAKm = parcelRequire("daAKm");


var $ehlgT = parcelRequire("ehlgT");


var $fPVB6 = parcelRequire("fPVB6");

/**
 * Checks if `string` ends with the given target string.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {string} [target] The string to search for.
 * @param {number} [position=string.length] The position to search up to.
 * @returns {boolean} Returns `true` if `string` ends with `target`,
 *  else `false`.
 * @example
 *
 * _.endsWith('abc', 'c');
 * // => true
 *
 * _.endsWith('abc', 'b');
 * // => false
 *
 * _.endsWith('abc', 'b', 2);
 * // => true
 */ function $ba9cbe60fdf9141e$var$endsWith(string, target, position) {
    string = $fPVB6(string);
    target = $daAKm(target);
    var length = string.length;
    position = position === undefined ? length : $bCMS0($ehlgT(position), 0, length);
    var end = position;
    position -= target.length;
    return position >= 0 && string.slice(position, end) == target;
}
$ba9cbe60fdf9141e$exports = $ba9cbe60fdf9141e$var$endsWith;



var $jzEl8 = parcelRequire("jzEl8");

const $9117dce6b863f439$var$LINKS_TO_BE_REMOVED = [
    '#action-page-permissions-link'
];
const $9117dce6b863f439$var$LINKS_TO_BE_REMOVED_ON_PAGE_INFORMATION = [
    '#page-favourite',
    '#action-menu-link'
];
const $9117dce6b863f439$var$replacedPlaceholder = {
    elementName: 'span',
    attributes: {
        style: `display: none`
    }
};
function $9117dce6b863f439$export$9e2c81a475b5d1b8() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jzEl8.LegacyDOMBridge), {
        selectors: $9117dce6b863f439$var$LINKS_TO_BE_REMOVED,
        attempts: 100,
        retryDelay: 500,
        portalNode: null,
        replacePlaceholderWith: $9117dce6b863f439$var$replacedPlaceholder
    }), (0, (/*@__PURE__*/$parcel$interopDefault($ba9cbe60fdf9141e$exports)))(window.location.pathname, '/pages/viewinfo.action') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jzEl8.LegacyDOMBridge), {
        selectors: $9117dce6b863f439$var$LINKS_TO_BE_REMOVED_ON_PAGE_INFORMATION,
        attempts: 100,
        retryDelay: 500,
        replacePlaceholderWith: $9117dce6b863f439$var$replacedPlaceholder,
        portalNode: null
    }));
}














var $inPa6 = parcelRequire("inPa6");








const $b82761c2a95901d5$export$18a8a22069631f81 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "kdP2C",
    loader: async ()=>(await (parcelRequire("5qwh1"))).ArchiveSpacePortal,
    name: 'ArchiveSpacePortal'
});






const $e87d969ba20a20a0$export$854f67824ef9311 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "P3ji1",
    loader: async ()=>(await (parcelRequire("2NJWg"))).DeleteSpacePortal,
    name: 'DeleteSpacePortal'
});






const $a6c6b76f924ecb80$export$b4b583c595949768 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "BlJ6r",
    name: "LazySpaceSettingsForgeExtensionPortal",
    loader: async ()=>(await (parcelRequire("cq0jI"))).SpaceSettingsForgeExtensionPortal
});
$a6c6b76f924ecb80$export$b4b583c595949768.displayName = 'LazySpaceSettingsForgeExtensionPortal';



var $7QM6o = parcelRequire("7QM6o");


var $feuG2 = parcelRequire("feuG2");





const $b270d87888ab1caf$export$cca256d7c562dc07 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "mTzRP",
    loader: async ()=>(await (parcelRequire("7nmkU"))).SpaceTrashPortal,
    name: 'SpaceTrashPortal'
});






const $d2b3f21ec8a84bb2$export$2c12a08ca2f15d0e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "wu877",
    name: "SiteSettingsHelpPanelLink",
    loader: async ()=>(await (parcelRequire("ax8Zf"))).SiteSettingsHelpPanelLink
});






const $406f60e313bf3a3f$export$b52880da76836cd4 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "h3QZB",
    name: "BackupManagerButton",
    loader: async ()=>(await (parcelRequire("d1Pi6"))).BackupManagerButton
});



var $14QAi = parcelRequire("14QAi");


var $ep3mz = parcelRequire("ep3mz");

/* PdfBannerPortal.tsx generated by @compiled/babel-plugin v0.36.1 */ 











var $gdv5Z = parcelRequire("gdv5Z");

var $iXCQx = parcelRequire("iXCQx");





var $6mKj3 = parcelRequire("6mKj3");

const $530cf45a0f14746c$var$PDF_BANNER_PORTAL_ID = 'pdf-export-banner-root';
const $530cf45a0f14746c$var$i18n = (0, $cgtv4.defineMessages)({
    bannerMessage: {
        id: "pdf-export.banner.message",
        defaultMessage: "We've received your print request. To maintain your page's format, we're exporting it to a PDF for you to download and print."
    }
});
const $530cf45a0f14746c$var$styles = {
    bannerStyles: "_1yt4pxbi _bfhk1aqn _1bto1l2s _o5721q9c"
};
const $530cf45a0f14746c$var$PdfBanner = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $530cf45a0f14746c$var$styles.bannerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        color: "color.text.inverse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $530cf45a0f14746c$var$i18n.bannerMessage)));
const $530cf45a0f14746c$export$57cc11a378563774 = ()=>{
    const { getQueryParams: getQueryParams } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const queryParams = getQueryParams();
    if (!(0, $6mKj3.expValEquals)('afm-enable-command-p-reroute', 'isEnabled', true)) return null;
     // only inject if ?showPdfBanner=true
    if (queryParams.showPdfBanner !== 'true') return null;
    let targetElement = document.getElementById($530cf45a0f14746c$var$PDF_BANNER_PORTAL_ID); // if the target doesn't exist, create and insert it before <main>
    if (!targetElement) {
        const main = document.querySelector('main#main');
        if (main && main.parentElement) {
            targetElement = document.createElement('div');
            targetElement.id = $530cf45a0f14746c$var$PDF_BANNER_PORTAL_ID;
            main.parentElement.insertBefore(targetElement, main);
        }
    } // if no anchor could be found, bail
    if (!targetElement) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).createPortal(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($530cf45a0f14746c$var$PdfBanner, null), targetElement);
};


const $76c1a3880217c32d$var$i18n = (0, $cgtv4.defineMessages)({
    importingTemplates: {
        id: "standalone-navigation.importing.templates",
        defaultMessage: "More about importing templates"
    }
});
const $76c1a3880217c32d$export$fc287ab47b11c4ec = ({ spaceKey: spaceKey, isSpaceSettingsScreen: isSpaceSettingsScreen })=>{
    const { location: { pathname: pathname } } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const spaceId = (0, $7QM6o.useSpaceId)(spaceKey);
    (0, $42omo.useEffect)(()=>{
        const { section: section, screen: screen } = (0, $14QAi.getRouteData)(pathname);
        // We only want analytics for IPH specific routes for now
        if (screen !== 'notTracked') createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: screen,
                attributes: {
                    section: section
                }
            }
        }).fire();
    }, [
        pathname,
        createAnalyticsEvent,
        spaceId
    ]);
    return pathname && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, isSpaceSettingsScreen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ep3mz.PageStateContainer), {
        spaceKey: spaceKey
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $feuG2.SpaceSettingsNavigationV2Portal), {
        spaceKey: spaceKey
    })) : null, pathname.includes('/spaces/archivespace.action') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b82761c2a95901d5$export$18a8a22069631f81), {
        spaceKey: spaceKey,
        pathname: pathname
    }), pathname.includes('/spaces/removespace.action') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e87d969ba20a20a0$export$854f67824ef9311), {
        spaceKey: spaceKey,
        pathname: pathname
    }), pathname.includes('/pages/viewtrash.action') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b270d87888ab1caf$export$cca256d7c562dc07), {
        spaceKey: spaceKey
    }), pathname.includes('/templatePackage/configurePlugin.action') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d2b3f21ec8a84bb2$export$2c12a08ca2f15d0e), {
        articleId: "7p0QTJJI0VkoU49M4GzKH2",
        articleTopic: "admin-import-templates",
        portalTargetId: "site-settings-import",
        buttonContent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $76c1a3880217c32d$var$i18n.importingTemplates),
        pathname: pathname,
        routeGroup: "site-settings",
        routeName: "undefined"
    }), pathname.includes('/plugins/servlet/ondemandbackupmanager') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $406f60e313bf3a3f$export$b52880da76836cd4), {
        pathname: pathname
    }), pathname.includes('spaces/flyingpdf/pdfpageexport.action') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $530cf45a0f14746c$export$57cc11a378563774), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a6c6b76f924ecb80$export$b4b583c595949768), {
        spaceKey: spaceKey
    }));
};
// needed for react-proptypes warning
$76c1a3880217c32d$export$fc287ab47b11c4ec.propTypes = {
    spaceKey: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    isSpaceSettingsScreen: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool
};


var $7c0ba11073bcb5f1$var$_StandaloneConfluenceNavigation;
function $7c0ba11073bcb5f1$var$_defineProperty(e, r, t) {
    return (r = $7c0ba11073bcb5f1$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $7c0ba11073bcb5f1$var$_toPropertyKey(t) {
    var i = $7c0ba11073bcb5f1$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $7c0ba11073bcb5f1$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $7c0ba11073bcb5f1$var$TopNavSpacer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1ule _1bsb1osq _4t3iymf6",
            __cmplp.className
        ])
    });
});
var $7c0ba11073bcb5f1$export$2e2bcd8739ae039 = (0, $089e60b6c1a73ffc$export$2e2bcd8739ae039)('global')(($7c0ba11073bcb5f1$var$_StandaloneConfluenceNavigation = class StandaloneConfluenceNavigation extends (0, $42omo.PureComponent) {
    componentDidMount() {
        const { isAdminScreen: isAdminScreen } = this.props; // if admin screen, show content as we mount
        if (isAdminScreen) (0, $8bee1fe38b9eef04$export$4011f4c5a8044281)();
        else setTimeout((0, $8bee1fe38b9eef04$export$4011f4c5a8044281), 300);
        (0, $ge2sX.getSessionData)();
    }
    render() {
        const { isAdminScreen: isAdminScreen, isSpaceSettingsScreen: isSpaceSettingsScreen, isSpaceScreen: isSpaceScreen, route: route, spaceKey: spaceKey } = this.props;
        let navView;
        if ((0, $1dnxO.getIsNav4Enabled)() && isSpaceSettingsScreen) navView = (0, $4l6Wo.CONTAINER_ADMIN_HOME_ID);
        else if (isSpaceSettingsScreen || isSpaceScreen) navView = (0, $4l6Wo.CONTAINER_HOME_ID);
        else if (isAdminScreen) navView = (0, $4l6Wo.ADMIN_HOME_ID);
        else if (route?.name !== (0, $1NBp8.EXTERNAL_SHARE).name) // XXX EXTERNAL_SHARE does not have the typical navigation.
        navView = (0, $4l6Wo.PRODUCT_HOME_ID);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f05a18473f890654$export$ffff49ea750347f8), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $76c1a3880217c32d$export$fc287ab47b11c4ec), {
            spaceKey: spaceKey,
            isSpaceSettingsScreen: isSpaceSettingsScreen
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aeSHO.CopySpacePermissionsForLegacyNewSpace), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3pfAb.default), {
            client: (0, $04e9M.getAnalyticsWebClient)()
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $39rFu.EditPageLoadingContextProvider), {
            nativeEditorComponentsPreloader: (0, $eXODy.nativeEditorComponentsPreloader),
            livePageComponentsPreloader: (0, $jwv1p.preloadLivePagesComponents)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
            attribution: (0, $3IBnw.Attribution).DISCO
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iV00x.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iJ8K8.Screen), {
            screenEvent: {
                name: 'serverRenderedScreen',
                attributes: {
                    navdexPointType: (0, $56QzY.START_TOUCH)
                }
            },
            pageState: {
                spaceKey: spaceKey,
                contentId: (0, $iJ8K8.SPACE_OVERVIEW)
            }
        }, navView && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hDG7z.PageLayout), {
            view: navView,
            isSpaceSettingsScreen: isSpaceSettingsScreen,
            standalone: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $NAPtM.CreateDialogContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $arkw6.LazyCreateDialogQueryRenderer), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3j0Cc.LazyCreateDialogBlueprintWizardRenderer), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4QflW.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eIKcA.default), null), isSpaceSettingsScreen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eWwvy.EditSpaceLogo), {
            spaceKey: spaceKey
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9117dce6b863f439$export$9e2c81a475b5d1b8), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cBuRD.NotificationLandedEvent), null)))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f60f9bb0af41c642$export$ddc928ad192d2b94), null));
    }
    constructor(...args){
        super(...args);
        $7c0ba11073bcb5f1$var$_defineProperty(this, "spacer", ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7c0ba11073bcb5f1$var$TopNavSpacer, {
                "data-test-id": "top-nav-spacer"
            }));
    }
}, $7c0ba11073bcb5f1$var$_defineProperty($7c0ba11073bcb5f1$var$_StandaloneConfluenceNavigation, "displayName", 'StandaloneConfluenceNavigation'), $7c0ba11073bcb5f1$var$_defineProperty($7c0ba11073bcb5f1$var$_StandaloneConfluenceNavigation, "propTypes", {
    isAdminScreen: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    isSpaceScreen: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    isSpaceSettingsScreen: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    route: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object,
    spaceKey: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string
}), $7c0ba11073bcb5f1$var$_StandaloneConfluenceNavigation));


const $fe485fa379bdff14$var$getSpaceKey = (state)=>{
    const routeParams = (0, $iyEDi.getRouteParams)(state);
    return (0, $iyEDi.routerStateExists)(state) && routeParams && routeParams.spaceKey || state.meta.get('space-alias') || state.meta.get('space-key');
};
const $fe485fa379bdff14$var$mapStateToProps = (state, props)=>{
    const { location: location, matchRoute: matchRoute } = props;
    const isSpaceScreen = state.meta.get('is-space-page') === 'true' || (0, $gnnzK.isContentTypeOf)('page', state) || (0, $gnnzK.isContentTypeOf)('blogpost', state);
    //On the DELETE_SPACE_LEGACY path the space is already deleted but certain queries
    //use the spaceKey. Set spaceKey to null if on this path
    const route = matchRoute(`${location.pathname}${location.search}${location.hash}`);
    const spaceKey = route?.name === (0, $1NBp8.DELETE_SPACE_LEGACY).name ? null : $fe485fa379bdff14$var$getSpaceKey(state);
    return {
        isAdminScreen: state.meta.get('is-admin-page') === 'true',
        isSpaceScreen: isSpaceScreen,
        isSpaceSettingsScreen: state.meta.get('is-space-tool-page') === 'true',
        route: route,
        spaceKey: spaceKey
    };
};
var $fe485fa379bdff14$export$2e2bcd8739ae039 = (0, $kFqI2.connect)($fe485fa379bdff14$var$mapStateToProps)((0, $7c0ba11073bcb5f1$export$2e2bcd8739ae039));


/**
 * setupUFOGlobalErrorHandler MUST be the first thing executed before any rendering operations.
 * This ensures we catch and track any errors that occur during the app's initialization,
 * including async operations and React rendering. Moving this call later would risk missing
 * early errors.
 * it provides ufo:errors:globalCount is the count of all errors which occurred on the client all up
 */ (0, $5QpZa.default)();
const $f5e2aff200456a49$var$sessionDataPromise = (async ()=>{
    (0, $hp2SH.getApolloClient)();
    try {
        const [sessionData] = await Promise.all([
            (0, $aXEzU.getSessionDataAndInitializeStatsig)(),
            (0, $68uaC.Cookies).initialize()
        ]);
        const { userId: userId, isLicensed: isLicensed, monolithRegion: monolithRegion } = sessionData;
        (0, $8PKGr.initializeAggRegionSteeringHint)(monolithRegion);
        (0, $xwvlW.initializePreloaderFnContext)(sessionData);
        await (0, $17wUi.initializeStorageManager)({
            userId: userId,
            isLicensed: isLicensed
        });
        (0, $gnYQc.applyPersistedStatsigOverrides)();
        return sessionData;
    } catch  {
        // For the same reasons as in the non-standalone case documented in the
        // counterpart of this file which is
        // confluence/packages/confluence-frontend-server/src/index.js at the moment
        return (0, $iC5L0.getEmptySessionData)();
    }
})();
const $f5e2aff200456a49$var$translationPromise = (0, $awd1Q.loadTranslation)((0, $7RVQB.lazyLanguage));
Promise.all([
    $f5e2aff200456a49$var$sessionDataPromise,
    $f5e2aff200456a49$var$translationPromise
]).then(([sessionData])=>{
    const browserNotSupportedCheck = (0, $2DVQX.coreBrowserNotSupported)();
    // the only requirement for BrowserNotSupported to render is the translationPromise
    if (browserNotSupportedCheck) {
        // the monolith attaches this id to the body here: confluence-core/confluence-webapp/src/main/webapp/decorators/main.vmd:62
        const documentBody = document.getElementById('com-atlassian-confluence');
        // eslint-disable-next-line react/no-deprecated
        return void (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).render(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9j59h.BrowserNotSupportedLoader), null), documentBody);
    }
    (0, $7LuKf.initialization)(sessionData);
    (0, $8bee1fe38b9eef04$export$ed04e7f6ba662aee)();
    (0, $d4f95b5cede9219f$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e6baa9171970034d$export$11eb671888ed6e7d), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7zgzO.RoutesContext).Consumer, null, ({ location: location, matchRoute: matchRoute })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fe485fa379bdff14$export$2e2bcd8739ae039), {
            apolloClient: (0, $hp2SH.getApolloClient)(),
            location: location,
            matchRoute: matchRoute
        }))), 'ui-global-sidebar-section', true);
});
 }, ["7EorR","dc4c6","2mkZm","eiF7i","aZinD","hhss7","ffEVr","1yVM6","1qlDN","5pvpJ","6XCf4","9sJzT","6wr18"]);

$parcel$global.rlb("3pblT")
//# sourceMappingURL=standalone-navigation-jquery3.3b827c1e.js.map
